import * as t from "react";
import { useState as x, useRef as I, useCallback as ee, useEffect as G, Fragment as Ja, Component as Za, useLayoutEffect as ht, isValidElement as zn, cloneElement as Qa, forwardRef as Wo, createContext as eo, useContext as to, useMemo as Fe, Children as ca, createRef as zo } from "react";
import { createPortal as Ho } from "react-dom";
const av = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, Qn = "poc_portal_token", cn = "poc_portal_refresh", Hn = "auth:session-expired", no = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let ao = no + "/chat-api/api/auth";
function ov(e) {
  e.authBase && (ao = e.authBase);
}
function ea(e) {
  try {
    const n = e.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(n))));
  } catch {
    return {};
  }
}
function Ko(e, n = 30) {
  const a = ea(e).exp;
  return !a || a * 1e3 < Date.now() + n * 1e3;
}
function oo(e = 30) {
  const n = localStorage.getItem(cn);
  if (!n) return !0;
  const a = ea(n).exp;
  return !!a && a * 1e3 < Date.now() + e * 1e3;
}
function Go() {
  return localStorage.getItem(Qn);
}
function Uo(e, n) {
  localStorage.setItem(Qn, e), n && localStorage.setItem(cn, n);
}
function Yo() {
  localStorage.removeItem(Qn), localStorage.removeItem(cn), ro();
}
function en() {
  Yo(), window.dispatchEvent(new Event(Hn));
}
function rv(e) {
  return window.addEventListener(Hn, e), () => window.removeEventListener(Hn, e);
}
let tn = null;
const Vo = 2147483647;
function Jo() {
  if (ro(), oo()) {
    en();
    return;
  }
  const e = localStorage.getItem(cn), n = e ? ea(e).exp : void 0;
  if (!n) return;
  const a = Math.min(Math.max(n * 1e3 - Date.now() - 30 * 1e3, 0), Vo);
  tn = setTimeout(() => {
    tn = null, Jo();
  }, a);
}
function ro() {
  tn !== null && (clearTimeout(tn), tn = null);
}
let bn = null;
function lo() {
  return bn || (bn = Zo()), bn;
}
async function Zo() {
  try {
    return await Qo();
  } finally {
    bn = null;
  }
}
async function Qo() {
  const e = localStorage.getItem(cn);
  if (!e)
    return en(), null;
  let n;
  try {
    n = await fetch(ao + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: e })
    });
  } catch {
    return null;
  }
  if (!n.ok)
    return n.status < 500 && en(), null;
  const a = await n.json().catch(() => ({}));
  return a.access_token ? (Uo(a.access_token, a.refresh_token), a.access_token) : (en(), null);
}
async function er() {
  if (oo())
    return en(), null;
  const e = Go();
  return e && !Ko(e) ? e : lo();
}
async function un(e, n = {}) {
  const a = (l) => {
    var s;
    return {
      ...n,
      headers: { ...(s = n.headers) != null ? s : {}, ...l ? { Authorization: "Bearer " + l } : {} }
    };
  }, o = await er();
  let r = await fetch(e, a(o));
  if (r.status === 401 && o) {
    const l = await lo();
    l && (r = await fetch(e, a(l)));
  }
  return r;
}
let Ot = no + "/chat-api/api/comments";
function lv(e) {
  e.base && (Ot = e.base);
}
function tr(e) {
  return e.parentId !== void 0 && e.parentId !== null;
}
async function mn(e) {
  var a;
  const n = await e.json().catch(() => ({}));
  if (!e.ok) throw new Error((a = n.error) != null ? a : `요청 실패 (${e.status})`);
  return n;
}
async function ia(e, n, a, o, r) {
  const l = new URLSearchParams({ targetType: e, targetId: n, page: String(a), size: String(o) }), s = await un(`${Ot}?${l}`, { cache: "no-store", signal: r });
  return mn(s);
}
async function nr(e, n, a, o) {
  const r = await un(Ot, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: e, targetId: n, content: a, parentId: o })
  });
  return mn(r);
}
async function ar(e, n) {
  const a = await un(`${Ot}/${e}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: n })
  });
  return mn(a);
}
async function or(e) {
  const n = await un(`${Ot}/${e}`, { method: "DELETE" });
  return (await mn(n)).status;
}
async function rr(e, n, a) {
  if (n.length === 0) return {};
  const o = new URLSearchParams({ targetType: e, targetIds: n.join(",") }), r = await un(`${Ot}/counts?${o}`, { cache: "no-store", signal: a });
  return (await mn(r)).counts;
}
const ua = 50;
function Kn(e) {
  return e.parentId === void 0 || e.parentId === null;
}
function lr(e, n) {
  if (Kn(n)) return [...e, n];
  const a = n.parentId;
  let o = -1;
  for (let r = 0; r < e.length; r += 1)
    (e[r].id === a || e[r].parentId === a) && (o = r);
  return o < 0 ? [...e, n] : [...e.slice(0, o + 1), n, ...e.slice(o + 1)];
}
function Ht(e, n) {
  return e instanceof Error && e.message ? e.message : n;
}
function sr(e, n) {
  const [a, o] = x([]), [r, l] = x(!0), [s, c] = x(!0), [i, d] = x(null), [u, m] = x(0), [_, p] = x(0), f = e + " " + n, y = I(f);
  y.current = f;
  const [E, k] = x(0), $ = ee(() => k((B) => B + 1), []);
  G(() => {
    const B = new AbortController(), A = f;
    return o([]), p(0), m(0), d(null), l(!0), c(!0), ia(e, n, 0, ua, B.signal).then((T) => {
      y.current === A && (o(T.items), m(T.total));
    }).catch((T) => {
      B.signal.aborted || y.current !== A || d(Ht(T, "댓글을 불러오지 못했어요."));
    }).finally(() => {
      y.current === A && (l(!1), c(!1));
    }), () => B.abort();
  }, [e, n, f, E]);
  const g = a.filter(Kn).length < u, h = ee(() => {
    if (r || !g) return;
    const B = _ + 1, A = y.current;
    l(!0), ia(e, n, B, ua).then((T) => {
      y.current === A && (o((R) => [...R, ...T.items]), m(T.total), p(B));
    }).catch((T) => {
      y.current === A && d(Ht(T, "댓글을 더 불러오지 못했어요."));
    }).finally(() => {
      y.current === A && l(!1);
    });
  }, [r, g, _, e, n]), v = ee(async (B, A) => {
    const T = B.trim();
    if (!T) return !1;
    const R = -Date.now(), F = {
      id: R,
      targetType: e,
      targetId: n,
      parentId: A != null ? A : null,
      authorName: "나",
      content: T,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, U = y.current;
    o((P) => lr(P, F)), d(null);
    try {
      const P = await nr(e, n, T, A);
      return y.current !== U || (o((M) => M.map((j) => j.id === R ? P : j)), A === void 0 && m((M) => M + 1)), !0;
    } catch (P) {
      return y.current !== U || (o((M) => M.filter((j) => j.id !== R)), d(Ht(P, "댓글을 등록하지 못했어요."))), !1;
    }
  }, [e, n]), b = ee(async (B, A) => {
    const T = A.trim();
    if (!T) return !1;
    const R = y.current;
    try {
      const F = await ar(B, T);
      return y.current !== R || o((U) => U.map((P) => P.id === B ? F : P)), !0;
    } catch (F) {
      return y.current === R && d(Ht(F, "댓글을 수정하지 못했어요.")), !1;
    }
  }, []), C = ee(async (B) => {
    const A = y.current;
    try {
      const T = await or(B);
      return y.current !== A ? !0 : T === "soft-deleted" ? (o((R) => R.map((F) => F.id === B ? { ...F, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : F)), !0) : (o((R) => {
        const F = R.find((j) => j.id === B), U = R.filter((j) => j.id !== B);
        if (!F) return U;
        if (Kn(F))
          return m((j) => Math.max(0, j - 1)), U;
        const P = F.parentId, M = U.find((j) => j.id === P);
        return M && M.deleted && !U.some((j) => j.parentId === P) ? (m((j) => Math.max(0, j - 1)), U.filter((j) => j.id !== P)) : U;
      }), !0);
    } catch (T) {
      return y.current === A && d(Ht(T, "댓글을 삭제하지 못했어요.")), !1;
    }
  }, []);
  return {
    items: a,
    loading: r,
    initialLoading: s,
    error: i,
    count: a.filter((B) => !B.deleted).length,
    hasMore: g,
    loadMore: h,
    reload: $,
    add: v,
    edit: b,
    remove: C
  };
}
const cr = "_thread_1layy_9", ir = "_head_1layy_28", ur = "_headTitle_1layy_37", mr = "_headCount_1layy_43", dr = "_list_1layy_54", _r = "_row_1layy_61", pr = "_isReply_1layy_73", fr = "_pending_1layy_80", yr = "_avatar_1layy_84", hr = "_avatarGhost_1layy_98", br = "_body_1layy_103", Er = "_meta_1layy_108", gr = "_author_1layy_116", vr = "_dept_1layy_122", wr = "_time_1layy_130", kr = "_text_1layy_135", Nr = "_textDeleted_1layy_143", $r = "_acts_1layy_148", xr = "_act_1layy_148", Cr = "_actDanger_1layy_169", Dr = "_empty_1layy_175", Sr = "_error_1layy_182", Br = "_skeleton_1layy_196", Ar = "_more_1layy_219", Mr = "_foot_1layy_245", Tr = "_composer_1layy_252", Lr = "_composerInput_1layy_261", jr = "_composerActions_1layy_284", Ir = "_btn_1layy_291", Rr = "_btnPrimary_1layy_301", Fr = "_btnGhost_1layy_310", W = {
  thread: cr,
  head: ir,
  headTitle: ur,
  headCount: mr,
  list: dr,
  row: _r,
  isReply: pr,
  pending: fr,
  avatar: yr,
  avatarGhost: hr,
  body: br,
  meta: Er,
  author: gr,
  dept: vr,
  time: wr,
  text: kr,
  textDeleted: Nr,
  acts: $r,
  act: xr,
  actDanger: Cr,
  empty: Dr,
  error: Sr,
  skeleton: Br,
  more: Ar,
  foot: Mr,
  composer: Tr,
  composerInput: Lr,
  composerActions: jr,
  btn: Ir,
  btnPrimary: Rr,
  btnGhost: Fr
}, ma = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function qr(e) {
  let n = 0;
  for (let a = 0; a < e.length; a += 1) n = (n * 31 + e.charCodeAt(a)) % 997;
  return ma[n % ma.length];
}
function Pr(e) {
  const n = e.trim();
  return n ? n[0].toUpperCase() : "?";
}
const da = 6e4, _a = 36e5, pa = 864e5, Xr = 6048e5;
function Or(e) {
  const n = new Date(e).getTime();
  if (Number.isNaN(n)) return "";
  const a = Date.now() - n;
  if (a < da) return "방금";
  if (a < _a) return `${Math.floor(a / da)}분 전`;
  if (a < pa) return `${Math.floor(a / _a)}시간 전`;
  if (a < Xr) return `${Math.floor(a / pa)}일 전`;
  const o = new Date(n), r = (l) => l < 10 ? `0${l}` : String(l);
  return `${o.getFullYear()}.${r(o.getMonth() + 1)}.${r(o.getDate())}`;
}
function Gn({
  placeholder: e,
  submitLabel: n,
  autoFocus: a,
  initialValue: o,
  onSubmit: r,
  onCancel: l
}) {
  const [s, c] = x(o != null ? o : ""), [i, d] = x(!1), u = I(null);
  G(() => {
    a && u.current && u.current.focus();
  }, [a]);
  const m = async () => {
    const _ = s.trim();
    if (!_ || i) return;
    d(!0);
    const p = await r(_);
    d(!1), p && c("");
  };
  return /* @__PURE__ */ t.createElement("div", { className: W.composer }, /* @__PURE__ */ t.createElement(
    "textarea",
    {
      ref: u,
      className: W.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: e,
      value: s,
      disabled: i,
      onChange: (_) => c(_.target.value),
      onKeyDown: (_) => {
        const p = _.nativeEvent.isComposing;
        _.key === "Enter" && !_.shiftKey && !p && (_.preventDefault(), m()), _.key === "Escape" && l && (_.nativeEvent.stopPropagation(), l());
      }
    }
  ), /* @__PURE__ */ t.createElement("div", { className: W.composerActions }, l && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${W.btn} ${W.btnGhost}`,
      onClick: l,
      disabled: i
    },
    "취소"
  ), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${W.btn} ${W.btnPrimary}`,
      onClick: () => void m(),
      disabled: i || !s.trim()
    },
    i ? "보내는 중…" : n
  )));
}
function Wr({
  item: e,
  replying: n,
  editing: a,
  onReply: o,
  onEdit: r,
  onSubmitReply: l,
  onSubmitEdit: s,
  onDelete: c,
  onCancel: i
}) {
  var _, p;
  const d = tr(e), u = d ? ` ${W.isReply}` : "";
  if (e.deleted)
    return /* @__PURE__ */ t.createElement("div", { className: `${W.row}${u}` }, /* @__PURE__ */ t.createElement("span", { className: `${W.avatar} ${W.avatarGhost}` }, "·"), /* @__PURE__ */ t.createElement("div", { className: W.body }, /* @__PURE__ */ t.createElement("div", { className: `${W.text} ${W.textDeleted}` }, "삭제된 댓글입니다")));
  const m = (_ = e.authorName) != null ? _ : "anonymous";
  return /* @__PURE__ */ t.createElement("div", { className: `${W.row}${u}${e.pending ? ` ${W.pending}` : ""}` }, /* @__PURE__ */ t.createElement("span", { className: W.avatar, style: { background: qr(m) } }, Pr(m)), /* @__PURE__ */ t.createElement("div", { className: W.body }, /* @__PURE__ */ t.createElement("div", { className: W.meta }, /* @__PURE__ */ t.createElement("span", { className: W.author }, m), e.dept && /* @__PURE__ */ t.createElement("span", { className: W.dept }, e.dept), /* @__PURE__ */ t.createElement("span", { className: W.time }, Or(e.createdAt)), e.updatedAt && /* @__PURE__ */ t.createElement("span", { className: W.time }, "(수정됨)")), a ? /* @__PURE__ */ t.createElement(
    Gn,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (p = e.content) != null ? p : "",
      onSubmit: s,
      onCancel: i
    }
  ) : /* @__PURE__ */ t.createElement("div", { className: W.text }, e.content), !a && !e.pending && /* @__PURE__ */ t.createElement("div", { className: W.acts }, !d && /* @__PURE__ */ t.createElement("button", { type: "button", className: W.act, onClick: o }, "답글"), e.mine && /* @__PURE__ */ t.createElement("button", { type: "button", className: W.act, onClick: r }, "수정"), e.mine && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${W.act} ${W.actDanger}`,
      onClick: c
    },
    "삭제"
  )), n && /* @__PURE__ */ t.createElement(
    Gn,
    {
      placeholder: `${m} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: l,
      onCancel: i
    }
  )));
}
function sv({
  targetType: e,
  targetId: n,
  onCountChange: a,
  autoFocus: o,
  showHeader: r = !0,
  className: l,
  style: s
}) {
  const { items: c, initialLoading: i, loading: d, error: u, count: m, hasMore: _, loadMore: p, reload: f, add: y, edit: E, remove: k } = sr(e, n), [$, S] = x(null), [g, h] = x(null);
  G(() => {
    S(null), h(null);
  }, [e, n]);
  const v = I(a);
  return v.current = a, G(() => {
    !i && v.current && v.current(m);
  }, [m, i]), /* @__PURE__ */ t.createElement("div", { className: l ? `${W.thread} ${l}` : W.thread, style: s }, r && /* @__PURE__ */ t.createElement("div", { className: W.head }, /* @__PURE__ */ t.createElement("span", { className: W.headTitle }, "댓글"), /* @__PURE__ */ t.createElement("span", { className: W.headCount }, m)), /* @__PURE__ */ t.createElement("div", { className: W.list }, i && /* @__PURE__ */ t.createElement("div", { className: W.skeleton }, /* @__PURE__ */ t.createElement("span", null), /* @__PURE__ */ t.createElement("span", null), /* @__PURE__ */ t.createElement("span", null)), u && /* @__PURE__ */ t.createElement("div", { className: W.error }, /* @__PURE__ */ t.createElement("span", null, u), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${W.btn} ${W.btnGhost}`,
      onClick: f
    },
    "다시 시도"
  )), !i && !u && c.length === 0 && /* @__PURE__ */ t.createElement("div", { className: W.empty }, "첫 댓글을 남겨 보세요."), c.map((b) => /* @__PURE__ */ t.createElement(
    Wr,
    {
      key: b.id,
      item: b,
      replying: $ === b.id,
      editing: g === b.id,
      onReply: () => {
        h(null), S(b.id);
      },
      onEdit: () => {
        S(null), h(b.id);
      },
      onCancel: () => {
        S(null), h(null);
      },
      onSubmitReply: async (C) => {
        const B = await y(C, b.id);
        return B && S(null), B;
      },
      onSubmitEdit: async (C) => {
        const B = await E(b.id, C);
        return B && h(null), B;
      },
      onDelete: () => {
        k(b.id);
      }
    }
  )), _ && /* @__PURE__ */ t.createElement("button", { type: "button", className: W.more, onClick: p, disabled: d }, d ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ t.createElement("div", { className: W.foot }, /* @__PURE__ */ t.createElement(
    Gn,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (b) => y(b)
    }
  )));
}
function cv(e, n) {
  const [a, o] = x({}), [r, l] = x(!1), [s, c] = x(0), i = n.join(",");
  return G(() => {
    const d = i ? i.split(",") : [];
    if (d.length === 0) {
      o({});
      return;
    }
    const u = new AbortController();
    return l(!0), rr(e, d, u.signal).then((m) => {
      u.signal.aborted || o(m);
    }).catch(() => {
      u.signal.aborted || o({});
    }).finally(() => {
      u.signal.aborted || l(!1);
    }), () => u.abort();
  }, [e, i, s]), {
    counts: a,
    loading: r,
    reload: () => c((d) => d + 1)
  };
}
const zr = "_card_epi3f_1", Hr = "_header_epi3f_8", Kr = "_headerNoDivider_epi3f_13", Gr = "_body_epi3f_17", Ur = "_paddingSm_epi3f_22", Yr = "_paddingMd_epi3f_26", Vr = "_paddingLg_epi3f_30", et = {
  card: zr,
  header: Hr,
  headerNoDivider: Kr,
  body: Gr,
  paddingSm: Ur,
  paddingMd: Yr,
  paddingLg: Vr
};
function iv({
  children: e,
  header: n,
  padding: a = "md",
  radius: o,
  headerDivider: r = !0,
  headerBackground: l,
  headerPadding: s,
  headerBorderColor: c,
  className: i
}) {
  const d = typeof a == "number" ? "" : a === "sm" ? et.paddingSm : a === "lg" ? et.paddingLg : et.paddingMd, u = typeof a == "number" ? { padding: a } : void 0, m = i ? `${et.card} ${i}` : et.card, _ = r ? et.header : `${et.header} ${et.headerNoDivider}`, p = {
    ...l !== void 0 ? { background: l } : {},
    ...s !== void 0 ? { padding: s } : {},
    ...c !== void 0 ? { borderBottomColor: c } : {}
  };
  return /* @__PURE__ */ t.createElement("div", { className: m, style: o !== void 0 ? { borderRadius: o } : void 0 }, n && /* @__PURE__ */ t.createElement("div", { className: _, style: p }, n), /* @__PURE__ */ t.createElement("div", { className: `${et.body} ${d}`, style: u }, e));
}
const Jr = "_horizontal_mkht7_1", Zr = "_vertical_mkht7_8", fa = {
  horizontal: Jr,
  vertical: Zr
};
function uv({ orientation: e = "horizontal", spacing: n = 0, color: a }) {
  const o = e === "vertical";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: o ? fa.vertical : fa.horizontal,
      style: {
        ...o ? { marginLeft: n, marginRight: n } : { marginTop: n, marginBottom: n },
        ...a !== void 0 ? { backgroundColor: a } : {}
      },
      role: "separator",
      "aria-orientation": e
    }
  );
}
const Qr = "_root_nvy8t_1", el = "_icon_nvy8t_7", tl = "_iconBadge_nvy8t_15", nl = "_titleGroup_nvy8t_25", al = "_title_nvy8t_25", ol = "_subtitle_nvy8t_41", rl = "_trailing_nvy8t_49", ll = "_closeButton_nvy8t_58", mt = {
  root: Qr,
  icon: el,
  iconBadge: tl,
  titleGroup: nl,
  title: al,
  subtitle: ol,
  trailing: rl,
  closeButton: ll
};
function mv({
  icon: e,
  iconColor: n,
  iconBadge: a = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: r,
  iconBadgeSize: l,
  title: s,
  titleWeight: c,
  titleSize: i,
  subtitle: d,
  subtitleColor: u,
  subtitleSize: m,
  trailing: _,
  onClose: p
}) {
  const f = {
    ...c !== void 0 ? { fontWeight: c } : {},
    ...i !== void 0 ? { fontSize: i } : {}
  }, y = {
    ...u !== void 0 ? { color: u } : {},
    ...m !== void 0 ? { fontSize: m } : {}
  };
  return /* @__PURE__ */ t.createElement("div", { className: mt.root }, e && a && /* @__PURE__ */ t.createElement(
    "span",
    {
      className: mt.iconBadge,
      style: {
        ...r ? { background: `linear-gradient(135deg, ${r[0]}, ${r[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...l !== void 0 ? { width: l, height: l } : {}
      }
    },
    e
  ), e && !a && /* @__PURE__ */ t.createElement("span", { className: mt.icon, style: n !== void 0 ? { color: n } : void 0 }, e), /* @__PURE__ */ t.createElement("div", { className: mt.titleGroup }, /* @__PURE__ */ t.createElement("span", { className: mt.title, style: f }, s), d && /* @__PURE__ */ t.createElement("span", { className: mt.subtitle, style: y }, d)), _ && /* @__PURE__ */ t.createElement("div", { className: mt.trailing }, _), p && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: mt.closeButton,
      onClick: p,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const sl = "_badge_19977_1", cl = {
  badge: sl
};
function dv({
  size: e = 32,
  gradient: n = ["#7C3AED", "#3B82F6"],
  icon: a
}) {
  const o = e * 0.55;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: cl.badge,
      style: {
        width: e,
        height: e,
        background: `linear-gradient(135deg, ${n[0]}, ${n[1]})`
      }
    },
    a != null ? a : /* @__PURE__ */ t.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ t.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const il = "_wrapper_ccmq2_1", ul = "_image_ccmq2_8", ml = "_fallback_ccmq2_16", dl = "_statusDot_ccmq2_29", pn = {
  wrapper: il,
  image: ul,
  fallback: ml,
  statusDot: dl
}, _l = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function pl(e) {
  const n = e == null ? void 0 : e.trim();
  return n ? Array.from(n)[0].toUpperCase() : "";
}
const Ln = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function fl(e) {
  const n = e == null ? void 0 : e.trim();
  if (!n) return Ln[5];
  let a = 0;
  for (let o = 0; o < n.length; o += 1)
    a = a * 31 + n.charCodeAt(o) | 0;
  return Ln[Math.abs(a) % Ln.length];
}
function so({
  src: e,
  fallbackText: n,
  alt: a,
  size: o = 32,
  statusDot: r,
  color: l,
  ring: s = !1,
  ringColor: c = "#fff"
}) {
  var m;
  const [i, d] = x(), u = !!e && i !== e;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: pn.wrapper,
      style: {
        width: o,
        height: o,
        ...s ? { boxShadow: `0 0 0 2px ${c}` } : {}
      }
    },
    u ? /* @__PURE__ */ t.createElement(
      "img",
      {
        className: pn.image,
        src: e,
        alt: (m = a != null ? a : n) != null ? m : "",
        onError: () => d(e)
      }
    ) : /* @__PURE__ */ t.createElement(
      "span",
      {
        className: pn.fallback,
        style: {
          backgroundColor: l != null ? l : fl(n),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      pl(n)
    ),
    r && /* @__PURE__ */ t.createElement(
      "span",
      {
        className: pn.statusDot,
        style: {
          backgroundColor: _l[r],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const yl = "_stack_y8phg_1", hl = "_item_y8phg_6", bl = "_overflow_y8phg_18", fn = {
  stack: yl,
  item: hl,
  overflow: bl
};
function _v({
  avatars: e,
  max: n = 4,
  size: a = 32
}) {
  const o = e.slice(0, n), r = e.length - o.length;
  return /* @__PURE__ */ t.createElement("span", { className: fn.stack }, o.map((l, s) => /* @__PURE__ */ t.createElement("span", { key: s, className: fn.item, style: { zIndex: o.length - s } }, /* @__PURE__ */ t.createElement(so, { src: l.src, alt: l.alt, fallbackText: l.fallbackText, size: a }))), r > 0 && /* @__PURE__ */ t.createElement("span", { className: fn.item, style: { zIndex: 0 } }, /* @__PURE__ */ t.createElement(
    "span",
    {
      className: fn.overflow,
      style: { width: a, height: a, fontSize: Math.max(10, a * 0.36) }
    },
    "+",
    r
  )));
}
const El = "_badge_1mjda_1", gl = "_pill_1mjda_15", vl = "_dot_1mjda_19", wl = "_dotPulse_1mjda_26", kl = "_outline_1mjda_40", Nl = "_soft_1mjda_46", Kt = {
  badge: El,
  pill: gl,
  dot: vl,
  dotPulse: wl,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: kl,
  soft: Nl
};
function pv({
  label: e,
  variant: n = "default",
  color: a,
  background: o,
  textColor: r,
  shape: l = "rounded",
  dot: s = !1,
  dotColor: c,
  dotPulse: i = !1,
  border: d = !1,
  borderColor: u = "currentColor"
}) {
  var f;
  const m = {};
  a && (n === "default" ? (m.backgroundColor = a, m.color = "#fff") : n === "outline" ? (m.borderColor = a, m.color = a) : (m.backgroundColor = `${a}1A`, m.color = a)), o !== void 0 && (m.backgroundColor = o), r !== void 0 && (m.color = r), d && (m.borderColor = u);
  const _ = [
    Kt.badge,
    Kt[n],
    l === "pill" ? Kt.pill : ""
  ].filter(Boolean).join(" "), p = [Kt.dot, i ? Kt.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ t.createElement("span", { className: _, style: m }, s && /* @__PURE__ */ t.createElement("span", { className: p, style: { backgroundColor: c != null ? c : (f = r != null ? r : a) != null ? f : "currentColor" } }), e);
}
const $l = "_row_1k2ap_1", xl = "_reply_1k2ap_7", Cl = "_avatar_1k2ap_12", Dl = "_avatarImage_1k2ap_25", Sl = "_avatarFallback_1k2ap_32", Bl = "_body_1k2ap_44", Al = "_headerLine_1k2ap_49", Ml = "_author_1k2ap_56", Tl = "_meta_1k2ap_62", Ll = "_text_1k2ap_67", jl = "_actionsRow_1k2ap_74", Il = "_actionBtn_1k2ap_81", Ae = {
  row: $l,
  reply: xl,
  avatar: Cl,
  avatarImage: Dl,
  avatarFallback: Sl,
  body: Bl,
  headerLine: Al,
  author: Ml,
  meta: Tl,
  text: Ll,
  actionsRow: jl,
  actionBtn: Il
};
function Rl(e) {
  const n = e.trim();
  return n ? n[0].toUpperCase() : "";
}
function fv({
  avatarSrc: e,
  author: n,
  meta: a,
  text: o,
  likeCount: r,
  replyCount: l,
  isReply: s = !1,
  onLikeClick: c,
  onReplyClick: i
}) {
  const [d, u] = x(!1), m = !!e && !d;
  return /* @__PURE__ */ t.createElement("div", { className: `${Ae.row} ${s ? Ae.reply : ""}` }, /* @__PURE__ */ t.createElement("span", { className: Ae.avatar }, m ? /* @__PURE__ */ t.createElement(
    "img",
    {
      className: Ae.avatarImage,
      src: e,
      alt: n,
      onError: () => u(!0)
    }
  ) : /* @__PURE__ */ t.createElement("span", { className: Ae.avatarFallback }, Rl(n))), /* @__PURE__ */ t.createElement("div", { className: Ae.body }, /* @__PURE__ */ t.createElement("div", { className: Ae.headerLine }, /* @__PURE__ */ t.createElement("span", { className: Ae.author }, n), a && /* @__PURE__ */ t.createElement("span", { className: Ae.meta }, a)), /* @__PURE__ */ t.createElement("div", { className: Ae.text }, o), /* @__PURE__ */ t.createElement("div", { className: Ae.actionsRow }, /* @__PURE__ */ t.createElement("button", { type: "button", className: Ae.actionBtn, onClick: c }, /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof r == "number" && /* @__PURE__ */ t.createElement("span", null, r)), /* @__PURE__ */ t.createElement("button", { type: "button", className: Ae.actionBtn, onClick: i }, /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof l == "number" && /* @__PURE__ */ t.createElement("span", null, l)))));
}
const Fl = "_wrapper_79n51_1", ql = {
  wrapper: Fl
}, Pl = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, Xl = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function Ol({ ext: e, size: n = 32 }) {
  var s;
  const a = e.trim().toLowerCase().replace(/^\./, ""), { label: o, color: r, bg: l } = (s = Pl[a]) != null ? s : Xl;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      className: ql.wrapper,
      style: {
        width: n,
        height: n,
        backgroundColor: l,
        color: r,
        fontSize: Math.max(8, n * 0.26)
      }
    },
    o
  );
}
const Wl = "_chip_1jhj8_1", zl = "_clickable_1jhj8_12", Hl = "_icon_1jhj8_21", Kl = "_info_1jhj8_26", Gl = "_name_1jhj8_33", Ul = "_size_1jhj8_42", Yl = "_chipError_1jhj8_48", Vl = "_chipDone_1jhj8_53", Jl = "_status_1jhj8_57", Zl = "_statusError_1jhj8_66", Ql = "_statusDone_1jhj8_67", es = "_statusIcon_1jhj8_69", ts = "_statusLabel_1jhj8_71", ns = "_progressTrack_1jhj8_78", as = "_progressFill_1jhj8_88", os = "_actionBtn_1jhj8_96", he = {
  chip: Wl,
  clickable: zl,
  icon: Hl,
  info: Kl,
  name: Gl,
  size: Ul,
  chipError: Yl,
  chipDone: Vl,
  status: Jl,
  statusError: Zl,
  statusDone: Ql,
  statusIcon: es,
  statusLabel: ts,
  progressTrack: ns,
  progressFill: as,
  actionBtn: os
};
function yv({
  name: e,
  ext: n,
  size: a,
  onRemove: o,
  downloadable: r = !1,
  onClick: l,
  status: s,
  statusText: c,
  percent: i
}) {
  const d = s === "error" ? he.chipError : s === "done" ? he.chipDone : "";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: `${he.chip} ${l ? he.clickable : ""} ${d}`,
      onClick: l,
      title: s === "error" ? c : void 0
    },
    n && /* @__PURE__ */ t.createElement("span", { className: he.icon }, /* @__PURE__ */ t.createElement(Ol, { ext: n, size: 28 })),
    /* @__PURE__ */ t.createElement("span", { className: he.info }, /* @__PURE__ */ t.createElement("span", { className: he.name }, e), c ? /* @__PURE__ */ t.createElement("span", { className: `${he.status} ${s === "error" ? he.statusError : s === "done" ? he.statusDone : ""}` }, s === "error" && /* @__PURE__ */ t.createElement("svg", { className: he.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ t.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ t.createElement("path", { d: "M12 7v6M12 16.5v.01" })), s === "done" && /* @__PURE__ */ t.createElement("svg", { className: he.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ t.createElement("span", { className: he.statusLabel }, c)) : a ? /* @__PURE__ */ t.createElement("span", { className: he.size }, a) : null, s === "processing" && /* @__PURE__ */ t.createElement("span", { className: he.progressTrack }, /* @__PURE__ */ t.createElement("span", { className: he.progressFill, style: { width: `${Math.max(0, Math.min(100, i != null ? i : 0))}%` } }))),
    r ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: he.actionBtn,
        "aria-label": "download",
        onClick: (u) => u.stopPropagation()
      },
      /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: he.actionBtn,
        "aria-label": "remove",
        onClick: (u) => {
          u.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const rs = "_list_1yxwc_1", ls = "_row_1yxwc_6", ss = "_inline_1yxwc_15", cs = "_label_1yxwc_22", is = "_value_1yxwc_29", us = "_stacked_1yxwc_35", ms = "_bold_1yxwc_51", Dt = {
  list: rs,
  row: ls,
  inline: ss,
  label: cs,
  value: is,
  stacked: us,
  bold: ms
};
function hv({
  rows: e,
  direction: n = "inline"
}) {
  return /* @__PURE__ */ t.createElement("div", { className: `${Dt.list} ${Dt[n]}` }, e.map((a, o) => /* @__PURE__ */ t.createElement("div", { key: o, className: Dt.row }, /* @__PURE__ */ t.createElement("span", { className: Dt.label }, a.label), /* @__PURE__ */ t.createElement("span", { className: `${Dt.value} ${a.bold ? Dt.bold : ""}` }, a.value))));
}
const ds = "_container_2r163_1", _s = "_row_2r163_5", ps = "_clickable_2r163_12", fs = "_leading_2r163_20", ys = "_main_2r163_26", hs = "_titleLine_2r163_34", bs = "_title_2r163_34", Es = "_tags_2r163_50", gs = "_meta_2r163_57", vs = "_actions_2r163_62", ws = "_expandable_2r163_69", Pe = {
  container: ds,
  row: _s,
  clickable: ps,
  leading: fs,
  main: ys,
  titleLine: hs,
  title: bs,
  tags: Es,
  meta: gs,
  actions: vs,
  expandable: ws
};
function bv({
  leading: e,
  title: n,
  meta: a,
  tags: o,
  actions: r,
  expandableContent: l,
  expanded: s = !1,
  onClick: c
}) {
  return /* @__PURE__ */ t.createElement("div", { className: Pe.container }, /* @__PURE__ */ t.createElement("div", { className: `${Pe.row} ${c ? Pe.clickable : ""}`, onClick: c }, e && /* @__PURE__ */ t.createElement("div", { className: Pe.leading }, e), /* @__PURE__ */ t.createElement("div", { className: Pe.main }, /* @__PURE__ */ t.createElement("div", { className: Pe.titleLine }, /* @__PURE__ */ t.createElement("span", { className: Pe.title }, n), o && /* @__PURE__ */ t.createElement("span", { className: Pe.tags }, o)), a && /* @__PURE__ */ t.createElement("div", { className: Pe.meta }, a)), r && /* @__PURE__ */ t.createElement("div", { className: Pe.actions, onClick: (i) => i.stopPropagation() }, r)), s && l && /* @__PURE__ */ t.createElement("div", { className: Pe.expandable }, l));
}
const ks = "_row_xzgny_1", Ns = "_info_xzgny_8", $s = "_name_xzgny_16", xs = "_subtitle_xzgny_25", Cs = "_status_xzgny_33", Gt = {
  row: ks,
  info: Ns,
  name: $s,
  subtitle: xs,
  status: Cs
};
function Ev({
  avatarSrc: e,
  name: n,
  subtitle: a,
  status: o,
  statusColor: r = "#64748B",
  statusBg: l = "#F1F5F9"
}) {
  return /* @__PURE__ */ t.createElement("div", { className: Gt.row }, /* @__PURE__ */ t.createElement(so, { src: e, fallbackText: n, size: 36 }), /* @__PURE__ */ t.createElement("div", { className: Gt.info }, /* @__PURE__ */ t.createElement("span", { className: Gt.name }, n), a && /* @__PURE__ */ t.createElement("span", { className: Gt.subtitle }, a)), o && /* @__PURE__ */ t.createElement(
    "span",
    {
      className: Gt.status,
      style: { color: r, backgroundColor: l }
    },
    o
  ));
}
const Ds = "_row_qoxwr_1", Ss = "_clickable_qoxwr_9", Bs = "_rank_qoxwr_17", As = "_title_qoxwr_25", Ms = "_trailing_qoxwr_36", Ut = {
  row: Ds,
  clickable: Ss,
  rank: Bs,
  title: As,
  trailing: Ms
}, Ts = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function gv({
  rank: e,
  rankColor: n,
  title: a,
  trailingText: o,
  onClick: r
}) {
  var s;
  const l = (s = n != null ? n : Ts[e]) != null ? s : "#64748B";
  return /* @__PURE__ */ t.createElement("div", { className: `${Ut.row} ${r ? Ut.clickable : ""}`, onClick: r }, /* @__PURE__ */ t.createElement("span", { className: Ut.rank, style: { color: l } }, e), /* @__PURE__ */ t.createElement("span", { className: Ut.title }, a), o && /* @__PURE__ */ t.createElement("span", { className: Ut.trailing }, o));
}
const Ls = "_badge_1qibj_1", js = "_sm_1qibj_11", Is = "_md_1qibj_16", Rs = "_overdue_1qibj_21", Fs = "_warning_1qibj_26", qs = "_progress_1qibj_31", Ps = "_success_1qibj_36", Xs = "_info_1qibj_41", Os = "_neutral_1qibj_46", jn = {
  badge: Ls,
  sm: js,
  md: Is,
  overdue: Rs,
  warning: Fs,
  progress: qs,
  success: Ps,
  info: Xs,
  neutral: Os
};
function vv({
  label: e,
  tone: n = "neutral",
  size: a = "md",
  background: o,
  textColor: r
}) {
  const l = {};
  return o !== void 0 && (l.backgroundColor = o), r !== void 0 && (l.color = r), /* @__PURE__ */ t.createElement("span", { className: `${jn.badge} ${jn[n]} ${jn[a]}`, style: l }, e);
}
const Ws = "_wrapper_14p14_1", zs = "_avatar_14p14_11", Hs = "_body_14p14_21", Ks = "_message_14p14_26", Gs = "_dots_14p14_32", Us = "_dot_14p14_32", Ys = "_action_14p14_70", Vs = "_actionIcon_14p14_89", Js = "_gradientWrapper_14p14_95", Zs = "_bareIcon_14p14_100", Qs = "_ctaButton_14p14_109", De = {
  wrapper: Ws,
  avatar: zs,
  body: Hs,
  message: Ks,
  dots: Gs,
  dot: Us,
  action: Ys,
  actionIcon: Vs,
  gradientWrapper: Js,
  bareIcon: Zs,
  ctaButton: Qs
};
function ya() {
  return /* @__PURE__ */ t.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ t.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function ha() {
  return /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ t.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function wv({
  message: e,
  accentColor: n = "#7C3AED",
  buttonLabel: a,
  buttonIcon: o,
  onAction: r,
  phase: l = "complete",
  variant: s = "card",
  gradientColors: c = ["#EEF4FF", "#F3EEFF"]
}) {
  const i = s === "gradient-cta";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [De.wrapper, i ? De.gradientWrapper : ""].join(" "),
      style: i ? { borderColor: `${n}33`, background: `linear-gradient(135deg, ${c[0]}, ${c[1]})` } : { borderColor: `${n}33` }
    },
    i ? /* @__PURE__ */ t.createElement("span", { className: De.bareIcon, style: { color: n } }, /* @__PURE__ */ t.createElement(ya, null)) : /* @__PURE__ */ t.createElement(
      "span",
      {
        className: De.avatar,
        style: { backgroundColor: `${n}1A`, color: n }
      },
      /* @__PURE__ */ t.createElement(ya, null)
    ),
    /* @__PURE__ */ t.createElement("div", { className: De.body }, l === "loading" ? /* @__PURE__ */ t.createElement("span", { className: De.dots }, /* @__PURE__ */ t.createElement("span", { className: De.dot, style: { backgroundColor: n } }), /* @__PURE__ */ t.createElement("span", { className: De.dot, style: { backgroundColor: n } }), /* @__PURE__ */ t.createElement("span", { className: De.dot, style: { backgroundColor: n } })) : /* @__PURE__ */ t.createElement("span", { className: De.message, style: i ? { color: n } : void 0 }, e)),
    a && r && (i ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: De.ctaButton,
        style: { backgroundColor: n },
        onClick: r
      },
      /* @__PURE__ */ t.createElement("span", null, a),
      /* @__PURE__ */ t.createElement("span", { className: De.actionIcon }, o === void 0 ? /* @__PURE__ */ t.createElement(ha, null) : o)
    ) : /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: De.action,
        style: { color: n },
        onClick: r
      },
      /* @__PURE__ */ t.createElement("span", null, a),
      /* @__PURE__ */ t.createElement("span", { className: De.actionIcon }, o === void 0 ? /* @__PURE__ */ t.createElement(ha, null) : o)
    ))
  );
}
const ec = "_wrapper_68zkp_1", tc = "_bordered_68zkp_13", nc = "_compact_68zkp_17", ac = "_icon_68zkp_23", oc = "_title_68zkp_31", rc = "_description_68zkp_38", lc = "_action_68zkp_46", bt = {
  wrapper: ec,
  bordered: tc,
  compact: nc,
  icon: ac,
  title: oc,
  description: rc,
  action: lc
};
function sc() {
  return /* @__PURE__ */ t.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ t.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function kv({
  icon: e,
  hideIcon: n = !1,
  title: a,
  titleColor: o,
  titleSize: r,
  titleWeight: l,
  description: s,
  actionLabel: c,
  onAction: i,
  bordered: d = !0,
  compact: u = !1
}) {
  const m = {
    ...o !== void 0 ? { color: o } : {},
    ...r !== void 0 ? { fontSize: r } : {},
    ...l !== void 0 ? { fontWeight: l } : {}
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [bt.wrapper, d && !u ? bt.bordered : "", u ? bt.compact : ""].join(" ")
    },
    !n && /* @__PURE__ */ t.createElement("div", { className: bt.icon }, e != null ? e : /* @__PURE__ */ t.createElement(sc, null)),
    /* @__PURE__ */ t.createElement("p", { className: bt.title, style: m }, a),
    s && /* @__PURE__ */ t.createElement("p", { className: bt.description }, s),
    c && i && /* @__PURE__ */ t.createElement("button", { type: "button", className: bt.action, onClick: i }, c)
  );
}
const cc = "_wrapper_oide4_1", ic = "_toggle_oide4_7", uc = "_toggleOpen_oide4_29", mc = "_panel_oide4_34", dc = "_text_oide4_41", Yt = {
  wrapper: cc,
  toggle: ic,
  toggleOpen: uc,
  panel: mc,
  text: dc
};
function Nv({
  label: e,
  summaryText: n,
  open: a,
  onToggle: o
}) {
  return /* @__PURE__ */ t.createElement("div", { className: Yt.wrapper }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: [Yt.toggle, a ? Yt.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": a
    },
    e
  ), a && /* @__PURE__ */ t.createElement("div", { className: Yt.panel }, /* @__PURE__ */ t.createElement("p", { className: Yt.text }, n)));
}
const _c = "_wrapper_96dw1_1", pc = "_labelRow_96dw1_8", fc = "_label_96dw1_8", yc = "_value_96dw1_21", hc = "_track_96dw1_27", bc = "_xs_96dw1_35", Ec = "_sm_96dw1_39", gc = "_md_96dw1_43", vc = "_square_96dw1_47", wc = "_fill_96dw1_51", tt = {
  wrapper: _c,
  labelRow: pc,
  label: fc,
  value: yc,
  track: hc,
  xs: bc,
  sm: Ec,
  md: gc,
  square: vc,
  fill: wc
};
function $v({
  value: e,
  max: n = 100,
  label: a,
  color: o = "#3B82F6",
  gradient: r,
  size: l = "md",
  rounded: s = !0,
  height: c,
  trackColor: i
}) {
  const d = n > 0 ? n : 100, u = Math.min(100, Math.max(0, e / d * 100)), m = r ? { width: `${u}%`, background: `linear-gradient(90deg, ${r[0]}, ${r[1]})` } : { width: `${u}%`, backgroundColor: o }, _ = {
    ...c !== void 0 ? { height: c } : {},
    ...i !== void 0 ? { background: i } : {}
  };
  return /* @__PURE__ */ t.createElement("div", { className: tt.wrapper }, a && /* @__PURE__ */ t.createElement("div", { className: tt.labelRow }, /* @__PURE__ */ t.createElement("span", { className: tt.label }, a), /* @__PURE__ */ t.createElement("span", { className: tt.value }, Math.round(u), "%")), /* @__PURE__ */ t.createElement("div", { className: [tt.track, tt[l], s ? "" : tt.square].join(" "), style: _ }, /* @__PURE__ */ t.createElement("div", { className: [tt.fill, s ? "" : tt.square].join(" "), style: m })));
}
const kc = "_list_aixh6_1", Nc = "_vertical_aixh6_8", $c = "_horizontal_aixh6_13", xc = "_item_aixh6_18", Cc = "_iconWrap_aixh6_41", Dc = "_iconSvg_aixh6_51", Sc = "_spin_aixh6_56", Bc = "_label_aixh6_70", Ac = "_item_active_aixh6_82", Mc = "_item_done_aixh6_87", Tc = "_connector_aixh6_91", Lc = "_cardList_aixh6_114", jc = "_cardItem_aixh6_122", Ic = "_card_pending_aixh6_133", Rc = "_card_active_aixh6_142", Fc = "_card_done_aixh6_152", Se = {
  list: kc,
  vertical: Nc,
  horizontal: $c,
  item: xc,
  iconWrap: Cc,
  iconSvg: Dc,
  spin: Sc,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: Bc,
  item_active: Ac,
  item_done: Mc,
  connector: Tc,
  cardList: Lc,
  cardItem: jc,
  card_pending: Ic,
  card_active: Rc,
  card_done: Fc
};
function qc({ status: e }) {
  return e === "done" ? /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: Se.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : e === "active" ? /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: [Se.iconSvg, Se.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: Se.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ t.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function xv({
  steps: e,
  orientation: n = "vertical",
  variant: a = "timeline"
}) {
  const o = a === "card";
  return /* @__PURE__ */ t.createElement("ul", { className: [Se.list, Se[n], o ? Se.cardList : ""].join(" ") }, e.map((r, l) => /* @__PURE__ */ t.createElement(
    "li",
    {
      key: `${r.label}-${l}`,
      className: [
        Se.item,
        o ? Se.cardItem : "",
        Se[`item_${r.status}`],
        o ? Se[`card_${r.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ t.createElement("span", { className: Se.iconWrap }, /* @__PURE__ */ t.createElement(qc, { status: r.status })),
    /* @__PURE__ */ t.createElement("span", { className: Se.label }, r.label),
    !o && l < e.length - 1 && /* @__PURE__ */ t.createElement("span", { className: Se.connector })
  )));
}
const Pc = "_wrapper_1ohmw_1", Xc = "_icon_1ohmw_7", Oc = "_dots_1ohmw_14", Wc = "_dot_1ohmw_14", zc = "_sm_1ohmw_27", Hc = "_md_1ohmw_32", Et = {
  wrapper: Pc,
  icon: Xc,
  dots: Oc,
  dot: Wc,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: zc,
  md: Hc
};
function Cv({ withIcon: e, size: n = "md" }) {
  return /* @__PURE__ */ t.createElement("div", { className: Et.wrapper }, e && /* @__PURE__ */ t.createElement("span", { className: Et.icon }, e), /* @__PURE__ */ t.createElement("span", { className: [Et.dots, Et[n]].join(" ") }, /* @__PURE__ */ t.createElement("span", { className: Et.dot }), /* @__PURE__ */ t.createElement("span", { className: Et.dot }), /* @__PURE__ */ t.createElement("span", { className: Et.dot })));
}
const Kc = "_container_85404_1", Gc = "_table_85404_9", Uc = "_row_85404_31", Yc = "_striped_85404_35", Vc = "_clickable_85404_43", Jc = "_alignLeft_85404_47", Zc = "_alignCenter_85404_51", Qc = "_alignRight_85404_55", ei = "_emptyCell_85404_59", nt = {
  container: Kc,
  table: Gc,
  row: Uc,
  striped: Yc,
  clickable: Vc,
  alignLeft: Jc,
  alignCenter: Zc,
  alignRight: Qc,
  emptyCell: ei
};
function Dv({
  columns: e,
  rows: n,
  striped: a = !0,
  onRowClick: o,
  emptyMessage: r = "데이터가 없습니다"
}) {
  const l = (s) => s === "center" ? nt.alignCenter : s === "right" ? nt.alignRight : nt.alignLeft;
  return /* @__PURE__ */ t.createElement("div", { className: nt.container }, /* @__PURE__ */ t.createElement("table", { className: nt.table }, /* @__PURE__ */ t.createElement("thead", null, /* @__PURE__ */ t.createElement("tr", null, e.map((s) => /* @__PURE__ */ t.createElement(
    "th",
    {
      key: s.key,
      className: l(s.align),
      style: s.width ? { width: s.width } : void 0
    },
    s.label
  )))), /* @__PURE__ */ t.createElement("tbody", null, n.length === 0 ? /* @__PURE__ */ t.createElement("tr", null, /* @__PURE__ */ t.createElement("td", { className: nt.emptyCell, colSpan: e.length }, r)) : n.map((s, c) => {
    const i = [
      nt.row,
      a && c % 2 === 1 ? nt.striped : "",
      o ? nt.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "tr",
      {
        key: c,
        className: i,
        onClick: o ? () => o(s, c) : void 0
      },
      e.map((d) => /* @__PURE__ */ t.createElement("td", { key: d.key, className: l(d.align) }, s[d.key]))
    );
  }))));
}
const ti = "_grid_plbcd_1", ni = "_cell_plbcd_6", ai = "_primaryCell_plbcd_16", oi = "_label_plbcd_21", ri = "_value_plbcd_26", li = "_note_plbcd_32", St = {
  grid: ti,
  cell: ni,
  primaryCell: ai,
  label: oi,
  value: ri,
  note: li
};
function Sv({
  items: e,
  columns: n = 4,
  primaryFirst: a = !1,
  cellBackground: o,
  cellBorderColor: r,
  labelColor: l,
  valueColor: s,
  primaryBackground: c,
  primaryLabelColor: i,
  primaryValueColor: d,
  primaryNoteColor: u
}) {
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: St.grid,
      style: { gridTemplateColumns: `repeat(${n}, 1fr)` }
    },
    e.map((m, _) => {
      const p = a && _ === 0, f = [St.cell, p ? St.primaryCell : ""].filter(Boolean).join(" "), y = {};
      o !== void 0 && (y.background = o), r !== void 0 && (y.borderColor = r), p && c !== void 0 && (y.background = c, y.borderColor = "transparent");
      const E = {};
      l !== void 0 && (E.color = l), p && i !== void 0 && (E.color = i);
      const k = {};
      s !== void 0 && (k.color = s), p && d !== void 0 && (k.color = d);
      const $ = {};
      return p && u !== void 0 && ($.color = u), /* @__PURE__ */ t.createElement("div", { key: `${m.label}-${_}`, className: f, style: y }, /* @__PURE__ */ t.createElement("span", { className: St.label, style: E }, m.label), /* @__PURE__ */ t.createElement("span", { className: St.value, style: k }, m.value), m.note && /* @__PURE__ */ t.createElement("span", { className: St.note, style: $ }, m.note));
    })
  );
}
const si = "_button_16ajt_1", ci = "_disabledSolid_16ajt_19", ii = "_icon_16ajt_26", ui = "_label_16ajt_32", mi = "_fullWidth_16ajt_37", di = "_sm_16ajt_41", _i = "_md_16ajt_47", pi = "_lg_16ajt_53", fi = "_primary_16ajt_59", yi = "_secondary_16ajt_70", hi = "_outline_16ajt_81", bi = "_ghost_16ajt_93", Ei = "_active_16ajt_104", gi = "_colorOverride_16ajt_116", vi = "_gradient_16ajt_126", wi = "_dashed_16ajt_135", ki = "_pill_16ajt_139", Le = {
  button: si,
  disabledSolid: ci,
  icon: ii,
  label: ui,
  fullWidth: mi,
  sm: di,
  md: _i,
  lg: pi,
  primary: fi,
  secondary: yi,
  outline: hi,
  ghost: bi,
  active: Ei,
  colorOverride: gi,
  gradient: vi,
  dashed: wi,
  pill: ki
};
function Bv({
  variant: e = "primary",
  size: n = "md",
  icon: a,
  iconPosition: o = "leading",
  disabled: r = !1,
  disabledVariant: l = "dim",
  onClick: s,
  children: c,
  fullWidth: i = !1,
  type: d = "button",
  active: u = !1,
  color: m,
  background: _,
  borderColor: p,
  hoverColor: f,
  hoverBackground: y,
  gradient: E,
  borderStyle: k = "solid",
  shape: $ = "rounded"
}) {
  const S = m !== void 0 || p !== void 0 || f !== void 0 || y !== void 0, g = [
    Le.button,
    Le[e],
    Le[n],
    i ? Le.fullWidth : "",
    r && l === "solid" ? Le.disabledSolid : "",
    u ? Le.active : "",
    S ? Le.colorOverride : "",
    E || _ ? Le.gradient : "",
    k === "dashed" ? Le.dashed : "",
    $ === "pill" ? Le.pill : ""
  ].filter(Boolean).join(" "), h = {
    ...m !== void 0 ? { "--ax-btn-color": m } : {},
    ...p !== void 0 ? { "--ax-btn-border": p } : {},
    ...f !== void 0 ? { "--ax-btn-hover-color": f } : {},
    ...y !== void 0 ? { "--ax-btn-hover-bg": y } : {},
    ...E ? { background: `linear-gradient(135deg, ${E[0]}, ${E[1]})` } : {},
    ..._ !== void 0 ? { background: _ } : {}
  }, v = a && /* @__PURE__ */ t.createElement("span", { className: Le.icon }, a);
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: d,
      className: g,
      style: h,
      disabled: r,
      onClick: s
    },
    o === "leading" && v,
    /* @__PURE__ */ t.createElement("span", { className: Le.label }, c),
    o === "trailing" && v
  );
}
const Ni = "_iconButton_1oiog_1", $i = "_sm_1oiog_18", xi = "_md_1oiog_23", Ci = "_lg_1oiog_28", Di = "_plain_1oiog_33", Si = "_outline_1oiog_42", Bi = "_circle_1oiog_53", Ai = "_bordered_1oiog_62", Mi = "_tint_1oiog_73", Ti = "_active_1oiog_81", Li = "_hoverBgOverride_1oiog_92", ji = "_gradient_1oiog_96", dt = {
  iconButton: Ni,
  sm: $i,
  md: xi,
  lg: Ci,
  plain: Di,
  outline: Si,
  circle: Bi,
  bordered: Ai,
  tint: Mi,
  active: Ti,
  hoverBgOverride: Li,
  gradient: ji
};
function Av({
  icon: e,
  title: n,
  active: a = !1,
  size: o = "md",
  variant: r = "plain",
  onClick: l,
  onMouseDown: s,
  disabled: c = !1,
  color: i,
  hoverColor: d,
  bordered: u = !1,
  borderColor: m = "#e2e8f0",
  borderHoverColor: _ = "#3b82f6",
  tint: p = !1,
  tintColor: f = "#eef4ff",
  tintHoverColor: y = "#dbeafe",
  hoverBackground: E,
  gradient: k
}) {
  const $ = typeof o == "number", S = [
    dt.iconButton,
    $ ? "" : dt[o],
    dt[r],
    a ? dt.active : "",
    u ? dt.bordered : "",
    p ? dt.tint : "",
    E !== void 0 ? dt.hoverBgOverride : "",
    k ? dt.gradient : ""
  ].filter(Boolean).join(" "), g = {
    ...$ ? { width: o, height: o } : {},
    ...i !== void 0 ? { "--ax-icon-color": i } : {},
    ...d !== void 0 ? { "--ax-icon-hover": d } : {},
    ...u ? { "--ax-icon-border": m, "--ax-icon-border-hover": _ } : {},
    ...p ? { "--ax-icon-tint": f, "--ax-icon-tint-hover": y } : {},
    ...E !== void 0 ? { "--ax-icon-hover-bg": E } : {},
    ...k ? { background: `linear-gradient(135deg, ${k[0]}, ${k[1]})` } : {}
  };
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: S,
      style: g,
      onClick: l,
      onMouseDown: s,
      disabled: c,
      title: n,
      "aria-label": n
    },
    e
  );
}
const Ii = "_wrapper_wrch3_1", Ri = "_searchIcon_wrch3_18", Fi = "_input_wrch3_26", qi = "_clearButton_wrch3_40", Pi = "_hint_wrch3_60", Vt = {
  wrapper: Ii,
  searchIcon: Ri,
  input: Fi,
  clearButton: qi,
  hint: Pi
}, Xi = /* @__PURE__ */ t.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ t.createElement("path", { d: "M21 21l-4.35-4.35" }));
function Oi({
  value: e,
  onChange: n,
  placeholder: a,
  hint: o,
  onSubmit: r,
  onClear: l
}) {
  const s = (c) => {
    c.key === "Enter" && (r == null || r());
  };
  return /* @__PURE__ */ t.createElement("div", { className: Vt.wrapper }, /* @__PURE__ */ t.createElement("span", { className: Vt.searchIcon }, Xi), /* @__PURE__ */ t.createElement(
    "input",
    {
      type: "text",
      className: Vt.input,
      value: e,
      placeholder: a,
      onChange: (c) => n(c.target.value),
      onKeyDown: s
    }
  ), l && e.length > 0 && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Vt.clearButton,
      onClick: l,
      "aria-label": "clear"
    },
    /* @__PURE__ */ t.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ t.createElement("path", { d: "M6 6l12 12" }))
  ), o && /* @__PURE__ */ t.createElement("span", { className: Vt.hint }, o));
}
const Wi = "_control_1kv40_1", zi = "_option_1kv40_10", Hi = "_active_1kv40_28", Ki = "_sm_1kv40_37", Gi = "_md_1kv40_43", Ui = "_dot_1kv40_49", Yi = "_count_1kv40_56", Vi = "_outline_1kv40_70", Ji = "_outlineOption_1kv40_75", at = {
  control: Wi,
  option: zi,
  active: Hi,
  sm: Ki,
  md: Gi,
  dot: Ui,
  count: Yi,
  outline: Vi,
  outlineOption: Ji
};
function Mv({
  options: e,
  value: n,
  onChange: a,
  size: o = "md",
  variant: r = "filled",
  activeBackground: l,
  activeColor: s,
  activeBorderColor: c
}) {
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [at.control, at[o], r === "outline" ? at.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    e.map((i) => {
      const d = i.value === n, u = d ? {
        ...l !== void 0 ? { background: l } : {},
        ...s !== void 0 ? { color: s } : {},
        ...c !== void 0 ? { borderColor: c } : {}
      } : void 0;
      return /* @__PURE__ */ t.createElement(
        "button",
        {
          key: i.value,
          type: "button",
          role: "tab",
          "aria-selected": d,
          className: [at.option, d ? at.active : "", r === "outline" ? at.outlineOption : ""].filter(Boolean).join(" "),
          style: u,
          onClick: () => a(i.value)
        },
        i.dot && /* @__PURE__ */ t.createElement("span", { className: at.dot, style: { backgroundColor: i.dot } }),
        /* @__PURE__ */ t.createElement("span", { className: at.label }, i.label),
        typeof i.count == "number" && /* @__PURE__ */ t.createElement("span", { className: at.count }, i.count)
      );
    })
  );
}
const Zi = "_chip_8jgxm_1", Qi = "_clickable_8jgxm_14", eu = "_suggested_8jgxm_23", tu = "_readonly_8jgxm_33", nu = "_plusIcon_8jgxm_39", au = "_label_8jgxm_45", ou = "_removeButton_8jgxm_50", Bt = {
  chip: Zi,
  clickable: Qi,
  default: "_default_8jgxm_18",
  suggested: eu,
  readonly: tu,
  plusIcon: nu,
  label: au,
  removeButton: ou
};
function Tv({
  label: e,
  variant: n = "default",
  onRemove: a,
  onClick: o,
  background: r,
  textColor: l,
  borderColor: s
}) {
  const c = [Bt.chip, Bt[n], o ? Bt.clickable : ""].filter(Boolean).join(" "), d = r !== void 0 || l !== void 0 || s !== void 0 ? {
    ...r !== void 0 ? { background: r } : {},
    ...l !== void 0 ? { color: l } : {},
    ...s !== void 0 ? { borderColor: s } : {}
  } : {}, u = n !== "readonly" && !!a, m = /* @__PURE__ */ t.createElement(t.Fragment, null, n === "suggested" && /* @__PURE__ */ t.createElement("span", { className: Bt.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ t.createElement("span", { className: Bt.label }, e), u && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Bt.removeButton,
      "aria-label": `remove ${e}`,
      onClick: (_) => {
        _.stopPropagation(), a == null || a();
      }
    },
    /* @__PURE__ */ t.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ t.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ t.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: c,
      style: d,
      onClick: o,
      onKeyDown: (_) => {
        (_.key === "Enter" || _.key === " ") && (_.preventDefault(), o());
      }
    },
    m
  ) : /* @__PURE__ */ t.createElement("span", { className: c, style: d }, m);
}
const ru = "_wrapper_15dm4_1", lu = "_disabled_15dm4_8", su = "_track_15dm4_13", cu = "_checked_15dm4_30", iu = "_thumb_15dm4_34", uu = "_label_15dm4_50", At = {
  wrapper: ru,
  disabled: lu,
  track: su,
  checked: cu,
  thumb: iu,
  label: uu
};
function Lv({
  checked: e,
  onChange: n,
  labelOn: a,
  labelOff: o,
  disabled: r = !1,
  color: l
}) {
  const s = e ? a : o;
  return /* @__PURE__ */ t.createElement("label", { className: [At.wrapper, r ? At.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": e,
      disabled: r,
      className: [At.track, e ? At.checked : ""].filter(Boolean).join(" "),
      style: e && l !== void 0 ? { background: l } : void 0,
      onClick: () => !r && n(!e)
    },
    /* @__PURE__ */ t.createElement("span", { className: At.thumb })
  ), s && /* @__PURE__ */ t.createElement("span", { className: At.label }, s));
}
const mu = "_card_1uh3t_1", du = "_active_1uh3t_24", _u = "_iconChip_1uh3t_29", pu = "_body_1uh3t_41", fu = "_label_1uh3t_48", yu = "_description_1uh3t_54", Mt = {
  card: mu,
  active: du,
  iconChip: _u,
  body: pu,
  label: fu,
  description: yu
};
function jv(e) {
  const { icon: n, label: a, description: o, active: r = !1, onClick: l } = e;
  return /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: `${Mt.card} ${r ? Mt.active : ""}`,
      onClick: l,
      "aria-pressed": r
    },
    /* @__PURE__ */ t.createElement("span", { className: Mt.iconChip }, n),
    /* @__PURE__ */ t.createElement("span", { className: Mt.body }, /* @__PURE__ */ t.createElement("span", { className: Mt.label }, a), o && /* @__PURE__ */ t.createElement("span", { className: Mt.description }, o))
  );
}
const hu = "_breadcrumb_zkol9_1", bu = "_list_zkol9_6", Eu = "_item_zkol9_16", gu = "_link_zkol9_22", vu = "_plain_zkol9_43", wu = "_current_zkol9_48", ku = "_separator_zkol9_54", gt = {
  breadcrumb: hu,
  list: bu,
  item: Eu,
  link: gu,
  plain: vu,
  current: wu,
  separator: ku
};
function Iv(e) {
  const { items: n, separator: a = "/", textColor: o, hoverColor: r, currentColor: l } = e, s = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...r !== void 0 ? { "--ax-bc-hover": r } : {},
    ...l !== void 0 ? { "--ax-bc-current": l } : {}
  };
  return /* @__PURE__ */ t.createElement("nav", { className: gt.breadcrumb, "aria-label": "breadcrumb", style: s }, /* @__PURE__ */ t.createElement("ol", { className: gt.list }, n.map((c, i) => {
    const d = i === n.length - 1;
    return /* @__PURE__ */ t.createElement("li", { key: i, className: gt.item }, d ? /* @__PURE__ */ t.createElement("span", { className: gt.current, "aria-current": "page" }, c.label) : c.onClick ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: gt.link,
        onClick: c.onClick
      },
      c.label
    ) : /* @__PURE__ */ t.createElement("span", { className: gt.plain }, c.label), !d && /* @__PURE__ */ t.createElement("span", { className: gt.separator, "aria-hidden": "true" }, a));
  })));
}
const Nu = "_treeItem_1ouqz_1", $u = "_active_1ouqz_18", xu = "_chevron_1ouqz_28", Cu = "_chevronExpanded_1ouqz_48", Du = "_chevronSpacer_1ouqz_52", Su = "_icon_1ouqz_57", Bu = "_label_1ouqz_69", Au = "_count_1ouqz_76", Mu = "_dark_1ouqz_86", ot = {
  treeItem: Nu,
  active: $u,
  chevron: xu,
  chevronExpanded: Cu,
  chevronSpacer: Du,
  icon: Su,
  label: Bu,
  count: Au,
  dark: Mu
};
function Rv(e) {
  const {
    icon: n,
    label: a,
    count: o,
    indent: r = 0,
    active: l = !1,
    expandable: s = !1,
    expanded: c = !1,
    theme: i = "light",
    onToggleExpand: d,
    onClick: u
  } = e, m = (p) => {
    p.stopPropagation(), d == null || d();
  }, _ = i === "dark" ? ot.dark : "";
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: `${ot.treeItem} ${_} ${l ? ot.active : ""}`,
      style: { paddingLeft: 12 + r * 16 },
      onClick: u,
      role: "treeitem",
      "aria-selected": l,
      "aria-expanded": s ? c : void 0
    },
    s ? /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: `${ot.chevron} ${c ? ot.chevronExpanded : ""}`,
        onClick: m,
        "aria-label": c ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ t.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ t.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ t.createElement("span", { className: ot.chevronSpacer }),
    n && /* @__PURE__ */ t.createElement("span", { className: ot.icon }, n),
    /* @__PURE__ */ t.createElement("span", { className: ot.label }, a),
    typeof o == "number" && /* @__PURE__ */ t.createElement("span", { className: ot.count }, o)
  );
}
const Tu = "_backdrop_gstyy_1", Lu = "_panel_gstyy_9", ju = "_right_gstyy_21", Iu = "_left_gstyy_27", Ru = "_header_gstyy_51", Fu = "_icon_gstyy_59", qu = "_titleGroup_gstyy_66", Pu = "_kicker_gstyy_71", Xu = "_title_gstyy_66", Ou = "_subtitle_gstyy_87", Wu = "_closeButton_gstyy_93", zu = "_body_gstyy_115", Hu = "_footer_gstyy_123", Me = {
  backdrop: Tu,
  panel: Lu,
  right: ju,
  left: Iu,
  header: Ru,
  icon: Fu,
  titleGroup: qu,
  kicker: Pu,
  title: Xu,
  subtitle: Ou,
  closeButton: Wu,
  body: zu,
  footer: Hu
};
function Fv({
  open: e,
  onClose: n,
  icon: a,
  kicker: o,
  title: r,
  titleSize: l,
  titleWeight: s,
  subtitle: c,
  footer: i,
  children: d,
  side: u = "right",
  headerBackground: m,
  topOffset: _
}) {
  if (!e)
    return null;
  const p = [Me.panel, u === "left" ? Me.left : Me.right].filter(Boolean).join(" "), f = {
    ...l !== void 0 ? { fontSize: l } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  }, y = _ !== void 0 ? { top: _, height: `calc(100vh - ${_}px)` } : void 0;
  return /* @__PURE__ */ t.createElement("div", { className: Me.backdrop, onClick: n }, /* @__PURE__ */ t.createElement("div", { className: p, style: y, onClick: (E) => E.stopPropagation() }, /* @__PURE__ */ t.createElement("div", { className: Me.header, style: m !== void 0 ? { background: m } : void 0 }, a && /* @__PURE__ */ t.createElement("span", { className: Me.icon }, a), /* @__PURE__ */ t.createElement("div", { className: Me.titleGroup }, o && /* @__PURE__ */ t.createElement("p", { className: Me.kicker }, o), /* @__PURE__ */ t.createElement("h2", { className: Me.title, style: f }, r), c && /* @__PURE__ */ t.createElement("p", { className: Me.subtitle }, c)), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Me.closeButton,
      onClick: n,
      "aria-label": "닫기"
    },
    "×"
  )), /* @__PURE__ */ t.createElement("div", { className: Me.body }, d), i && /* @__PURE__ */ t.createElement("div", { className: Me.footer }, i)));
}
const Ku = "_backdrop_6kso7_1", Gu = "_menu_6kso7_8", Uu = "_alignRight_6kso7_24", Yu = "_alignLeft_6kso7_28", Vu = "_item_6kso7_32", Ju = "_itemIcon_6kso7_50", Zu = "_itemText_6kso7_59", Qu = "_itemLabel_6kso7_66", em = "_itemDescription_6kso7_72", tm = "_danger_6kso7_77", He = {
  backdrop: Ku,
  menu: Gu,
  alignRight: Uu,
  alignLeft: Yu,
  item: Vu,
  itemIcon: Ju,
  itemText: Zu,
  itemLabel: Qu,
  itemDescription: em,
  danger: tm
};
function qv({
  open: e,
  onClose: n,
  items: a,
  anchor: o = "right"
}) {
  if (!e)
    return null;
  const r = [He.menu, o === "left" ? He.alignLeft : He.alignRight].filter(Boolean).join(" "), l = (s) => {
    s.onClick(), n();
  };
  return /* @__PURE__ */ t.createElement(Ja, null, /* @__PURE__ */ t.createElement("div", { className: He.backdrop, onClick: n }), /* @__PURE__ */ t.createElement("div", { className: r, onClick: (s) => s.stopPropagation() }, a.map((s, c) => {
    const i = [He.item, s.danger ? He.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: c,
        type: "button",
        className: i,
        onClick: () => l(s)
      },
      s.icon && /* @__PURE__ */ t.createElement("span", { className: He.itemIcon }, s.icon),
      /* @__PURE__ */ t.createElement("span", { className: He.itemText }, /* @__PURE__ */ t.createElement("span", { className: He.itemLabel }, s.label), s.description && /* @__PURE__ */ t.createElement("span", { className: He.itemDescription }, s.description))
    );
  })));
}
const nm = "_backdrop_3pc9i_1", am = "_card_3pc9i_12", om = "_header_3pc9i_23", rm = "_icon_3pc9i_31", lm = "_titleGroup_3pc9i_38", sm = "_title_3pc9i_38", cm = "_subtitle_3pc9i_50", im = "_closeButton_3pc9i_56", um = "_body_3pc9i_78", mm = "_footer_3pc9i_85", Ke = {
  backdrop: nm,
  card: am,
  header: om,
  icon: rm,
  titleGroup: lm,
  title: sm,
  subtitle: cm,
  closeButton: im,
  body: um,
  footer: mm
};
function Pv({
  open: e,
  onClose: n,
  icon: a,
  title: o,
  subtitle: r,
  footer: l,
  width: s = 480,
  children: c
}) {
  if (!e)
    return null;
  const i = typeof s == "number" ? `${s}px` : s;
  return /* @__PURE__ */ t.createElement("div", { className: Ke.backdrop, onClick: n }, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: Ke.card,
      style: { width: i },
      onClick: (d) => d.stopPropagation()
    },
    /* @__PURE__ */ t.createElement("div", { className: Ke.header }, a && /* @__PURE__ */ t.createElement("span", { className: Ke.icon }, a), /* @__PURE__ */ t.createElement("div", { className: Ke.titleGroup }, /* @__PURE__ */ t.createElement("h2", { className: Ke.title }, o), r && /* @__PURE__ */ t.createElement("p", { className: Ke.subtitle }, r)), /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Ke.closeButton,
        onClick: n,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ t.createElement("div", { className: Ke.body }, c),
    l && /* @__PURE__ */ t.createElement("div", { className: Ke.footer }, l)
  ));
}
const dm = "_page_1f94v_5", _m = "_inner_1f94v_18", ba = {
  page: dm,
  inner: _m
};
function Xv({
  gnbHeight: e = 64,
  minWidth: n = 1024,
  className: a = "",
  style: o,
  children: r
}) {
  return /* @__PURE__ */ t.createElement(
    "main",
    {
      className: [ba.page, "axe-page", a].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...o }
    },
    /* @__PURE__ */ t.createElement("div", { className: ba.inner, style: { minWidth: n } }, r)
  );
}
const pm = "_orbitPortalRoot_177qv_2", fm = {
  orbitPortalRoot: pm
};
class Wt extends Za {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const n = this.props.portalClassName || fm.orbitPortalRoot, a = Array.from(document.body.childNodes).find((o) => o.className === n);
      if (!a) {
        const o = document.createElement("div");
        return o.className = n, document.body.appendChild(o), o;
      }
      return a;
    };
  }
  render() {
    return Ho(this.props.children, this.getPortalRoot());
  }
}
const ym = "_anchor_7h2m7_2", hm = "_tip_7h2m7_5", Ea = {
  anchor: ym,
  tip: hm
};
let bm = 0;
function Dn({
  content: e,
  children: n,
  placement: a = "bottom",
  delay: o = 250,
  focusable: r,
  describe: l = !0,
  className: s = ""
}) {
  const [c, i] = x(!1), [d, u] = x({ top: 0, left: 0 }), m = I(null), _ = I(null), p = I(null), f = I("");
  f.current || (f.current = `axe-tip-${++bm}`);
  const y = () => {
    p.current && (clearTimeout(p.current), p.current = null);
  }, E = (g) => {
    y(), g <= 0 ? i(!0) : p.current = setTimeout(() => i(!0), g);
  }, k = () => {
    y(), i(!1);
  };
  if (G(() => y, []), ht(() => {
    if (!c) return;
    const g = () => {
      const h = m.current, v = _.current;
      if (!h || !v) return;
      const b = h.getBoundingClientRect(), C = v.offsetHeight, B = v.offsetWidth;
      let A = a === "top" ? b.top - C - 6 : b.bottom + 6;
      a === "bottom" && A + C > window.innerHeight - 4 && b.top - C - 6 > 4 && (A = b.top - C - 6), a === "top" && A < 4 && b.bottom + 6 + C < window.innerHeight - 4 && (A = b.bottom + 6);
      const T = Math.max(4, Math.min(b.left + b.width / 2 - B / 2, window.innerWidth - B - 4));
      u((R) => R.top === A && R.left === T ? R : { top: A, left: T });
    };
    return g(), window.addEventListener("resize", g), window.addEventListener("scroll", g, !0), () => {
      window.removeEventListener("resize", g), window.removeEventListener("scroll", g, !0);
    };
  }, [c, a, e]), G(() => {
    if (!c) return;
    const g = (h) => {
      h.key === "Escape" && k();
    };
    return document.addEventListener("keydown", g), () => document.removeEventListener("keydown", g);
  }, [c]), !(e != null && e !== !1 && e !== "")) return n;
  const S = zn(n) ? Qa(n, c && l ? { "aria-describedby": f.current } : {}) : n;
  return /* @__PURE__ */ t.createElement(
    "span",
    {
      ref: m,
      className: [Ea.anchor, s].filter(Boolean).join(" "),
      tabIndex: r ? 0 : void 0,
      onMouseEnter: () => E(o),
      onMouseLeave: k,
      onFocus: () => E(0),
      onBlur: k
    },
    S,
    c && /* @__PURE__ */ t.createElement(Wt, null, /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: _,
        id: f.current,
        role: "tooltip",
        className: Ea.tip,
        style: { top: d.top, left: d.left },
        onMouseEnter: y,
        onMouseLeave: k
      },
      e
    ))
  );
}
const Em = "_bar_j0oph_1", gm = "_menu_j0oph_9", vm = "_title_j0oph_19", wm = "_info_j0oph_21", km = "_badge_j0oph_29", Nm = "_badge_muted_j0oph_30", $m = "_badge_ok_j0oph_31", xm = "_badge_warn_j0oph_32", Cm = "_meta_j0oph_34", Dm = "_actions_j0oph_18", Sm = "_notice_j0oph_48", Bm = "_notice_info_j0oph_53", Am = "_notice_ok_j0oph_54", Mm = "_notice_err_j0oph_55", Ge = {
  bar: Em,
  menu: gm,
  title: vm,
  info: wm,
  badge: km,
  badge_muted: Nm,
  badge_ok: $m,
  badge_warn: xm,
  meta: Cm,
  actions: Dm,
  notice: Sm,
  notice_info: Bm,
  notice_ok: Am,
  notice_err: Mm
};
function Ov({
  title: e,
  onMenu: n,
  info: a,
  badge: o,
  meta: r,
  notice: l,
  children: s
}) {
  var c;
  return /* @__PURE__ */ t.createElement("header", { className: Ge.bar }, n && /* @__PURE__ */ t.createElement("button", { type: "button", className: Ge.menu, "aria-label": "메뉴", onClick: n }, "☰"), /* @__PURE__ */ t.createElement("h1", { className: Ge.title }, e), a && /* @__PURE__ */ t.createElement(Dn, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ t.createElement("span", { className: Ge.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(o) ? o : [o]).filter(Boolean).map((i, d) => {
    var u;
    return /* @__PURE__ */ t.createElement("span", { key: d, className: [Ge.badge, Ge[`badge_${(u = i.tone) != null ? u : "muted"}`]].join(" ") }, i.label);
  }), r && /* @__PURE__ */ t.createElement("span", { className: Ge.meta }, r), /* @__PURE__ */ t.createElement("span", { className: Ge.actions }, l && l.text && /* @__PURE__ */ t.createElement("span", { className: [Ge.notice, Ge[`notice_${(c = l.tone) != null ? c : "info"}`]].join(" "), role: "status" }, l.text), s));
}
const Tm = "_btn_1l07w_1", Lm = "_sm_1l07w_18", jm = "_primary_1l07w_21", Im = "_dark_1l07w_23", Rm = "_danger_1l07w_25", Fm = "_soon_1l07w_29", qm = "_soonTag_1l07w_30", Pm = "_kbd_1l07w_45", Xm = "_iconBtn_1l07w_48", Om = "_link_1l07w_64", ft = {
  btn: Tm,
  sm: Lm,
  primary: jm,
  dark: Im,
  danger: Rm,
  soon: Fm,
  soonTag: qm,
  kbd: Pm,
  iconBtn: Xm,
  link: Om
}, Ft = Wo(function({
  variant: n = "default",
  size: a = "md",
  kbd: o,
  soon: r,
  children: l,
  className: s = "",
  type: c = "button",
  onClick: i,
  title: d,
  ...u
}, m) {
  const _ = /* @__PURE__ */ t.createElement(
    "button",
    {
      ref: m,
      type: c,
      className: [ft.btn, ft[n], a === "sm" ? ft.sm : "", r ? ft.soon : "", s].filter(Boolean).join(" "),
      "aria-disabled": r ? !0 : void 0,
      title: r ? void 0 : d,
      onClick: r ? (p) => p.preventDefault() : i,
      ...u
    },
    l,
    o && /* @__PURE__ */ t.createElement("kbd", { className: ft.kbd }, o),
    r && /* @__PURE__ */ t.createElement("em", { className: ft.soonTag }, "준비 중")
  );
  return r ? /* @__PURE__ */ t.createElement(Dn, { content: r }, _) : _;
});
function Un({ label: e, children: n, className: a = "", type: o = "button", ...r }) {
  return /* @__PURE__ */ t.createElement(Dn, { content: e, describe: !1 }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: o,
      className: [ft.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...r
    },
    n
  ));
}
function ta({ children: e, className: n = "", type: a = "button", ...o }) {
  return /* @__PURE__ */ t.createElement("button", { type: a, className: [ft.link, n].filter(Boolean).join(" "), ...o }, e);
}
const Wm = "_wrap_ngnft_1", zm = "_btn_ngnft_2", Hm = "_on_ngnft_6", Km = "_caret_ngnft_8", Gm = "_pop_ngnft_9", Um = "_sec_ngnft_14", Ym = "_item_ngnft_17", Vm = "_danger_ngnft_24", _t = {
  wrap: Wm,
  btn: zm,
  on: Hm,
  caret: Km,
  pop: Gm,
  sec: Um,
  item: Ym,
  danger: Vm
}, Jm = (e, n, a, o = {}) => ({ kind: "item", key: e, label: n, onClick: a, ...o }), Wv = (e, n, a) => ({ kind: "section", key: e, label: n, note: a });
function Zm({ label: e, entries: n, disabled: a, title: o }) {
  const [r, l] = x(!1), s = I(null), c = I(null), i = I(null), d = () => {
    var m, _;
    return Array.from((_ = (m = i.current) == null ? void 0 : m.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? _ : []);
  };
  G(() => {
    var m;
    r && ((m = d()[0]) == null || m.focus());
  }, [r]), G(() => {
    if (!r) return;
    const m = (p) => {
      s.current && !s.current.contains(p.target) && l(!1);
    }, _ = (p) => {
      var f;
      p.key === "Escape" && (l(!1), (f = c.current) == null || f.focus());
    };
    return document.addEventListener("mousedown", m), document.addEventListener("keydown", _), () => {
      document.removeEventListener("mousedown", m), document.removeEventListener("keydown", _);
    };
  }, [r]);
  const u = (m) => {
    const _ = d();
    if (_.length === 0) return;
    const p = _.indexOf(document.activeElement);
    let f = -1;
    if (m.key === "ArrowDown") f = (p + 1) % _.length;
    else if (m.key === "ArrowUp") f = (p <= 0 ? _.length : p) - 1;
    else if (m.key === "Home") f = 0;
    else if (m.key === "End") f = _.length - 1;
    else if (m.key === "Tab") {
      l(!1);
      return;
    } else return;
    m.preventDefault(), _[f].focus();
  };
  return /* @__PURE__ */ t.createElement("span", { className: _t.wrap, ref: s }, /* @__PURE__ */ t.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [_t.btn, r ? _t.on : ""].join(" "),
      disabled: a,
      title: o,
      "aria-haspopup": "menu",
      "aria-expanded": r,
      onClick: () => l((m) => !m),
      onKeyDown: (m) => {
        m.key === "ArrowDown" && !r && (m.preventDefault(), l(!0));
      }
    },
    e,
    /* @__PURE__ */ t.createElement("span", { className: _t.caret, "aria-hidden": "true" }, "▾")
  ), r && /* @__PURE__ */ t.createElement("div", { ref: i, className: _t.pop, role: "menu", onKeyDown: u }, n.map((m) => m.kind === "section" ? /* @__PURE__ */ t.createElement("div", { key: m.key, className: _t.sec }, m.label, m.note && /* @__PURE__ */ t.createElement("small", null, m.note)) : /* @__PURE__ */ t.createElement(
    "button",
    {
      key: m.key,
      type: "button",
      role: "menuitem",
      disabled: m.disabled,
      className: [_t.item, m.danger ? _t.danger : ""].join(" "),
      onClick: () => {
        var _;
        l(!1), (_ = c.current) == null || _.focus(), m.onClick();
      }
    },
    /* @__PURE__ */ t.createElement("span", null, m.label),
    m.disabled && m.reason && /* @__PURE__ */ t.createElement("small", null, m.reason)
  ))));
}
const Qm = "_bar_18g8l_2", ed = "_sticky_18g8l_12", td = "_start_18g8l_19", nd = "_end_18g8l_20", ad = "_status_18g8l_22", od = "_dirty_18g8l_23", Tt = {
  bar: Qm,
  sticky: ed,
  start: td,
  end: nd,
  status: ad,
  dirty: od
};
function zv({ start: e, children: n, status: a, dirty: o, inline: r, className: l = "" }) {
  return /* @__PURE__ */ t.createElement("div", { className: ["axe-save-bar", Tt.bar, r ? "" : Tt.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ t.createElement("span", { className: Tt.start }, e), /* @__PURE__ */ t.createElement("span", { className: Tt.end }, a && /* @__PURE__ */ t.createElement("span", { className: [Tt.status, o ? Tt.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), n));
}
const rd = {
  print: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ t.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ t.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ t.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ t.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ t.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ t.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ t.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ t.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ t.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ t.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ t.createElement("path", { d: "M10 11v6M14 11v6" }))
}, ld = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function sd({ name: e, className: n }) {
  return /* @__PURE__ */ t.createElement("span", { className: n, "aria-hidden": "true" }, ld[e]);
}
function vn({ name: e, size: n = 15, className: a }) {
  return /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: a,
      width: n,
      height: n,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    rd[e]
  );
}
const cd = "_root_j67qt_2", id = "_closed_j67qt_3", ud = "_tab_j67qt_6", md = "_collapse_j67qt_7", dd = "_body_j67qt_16", _d = "_card_j67qt_32", pd = "_head_j67qt_37", fd = "_cardOpen_j67qt_44", yd = "_headBtn_j67qt_47", hd = "_icon_j67qt_56", bd = "_badge_j67qt_57", Ed = "_trailing_j67qt_58", gd = "_chev_j67qt_59", vd = "_panelWrap_j67qt_63", wd = "_panelOpen_j67qt_67", kd = "_panelBody_j67qt_68", Nd = "_panelInner_j67qt_69", $d = "_panelSettled_j67qt_70", be = {
  root: cd,
  closed: id,
  tab: ud,
  collapse: md,
  body: dd,
  card: _d,
  head: pd,
  cardOpen: fd,
  headBtn: yd,
  icon: hd,
  badge: bd,
  trailing: Ed,
  chev: gd,
  panelWrap: vd,
  panelOpen: wd,
  panelBody: kd,
  panelInner: Nd,
  panelSettled: $d
}, xd = 1280, Cd = 8, co = "axe-side-bar:";
function Dd(e) {
  if (!e) return null;
  try {
    const n = window.localStorage.getItem(co + e);
    return n === "1" ? !0 : n === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function Sd(e, n) {
  if (e)
    try {
      window.localStorage.setItem(co + e, n ? "1" : "0");
    } catch {
    }
}
function Hv({
  enabled: e = !0,
  defaultOpen: n = !0,
  width: a = 260,
  collapseBelow: o = xd,
  storageKey: r,
  className: l = "",
  children: s
}) {
  var _;
  const c = I(Dd(r)), [i, d] = x((_ = c.current) != null ? _ : n), u = I(c.current !== null);
  if (G(() => {
    if (!e || !o || typeof window.matchMedia != "function") return;
    const p = window.matchMedia(`(max-width: ${o - 1}px)`), f = () => {
      u.current || d(!p.matches && n);
    };
    return f(), p.addEventListener ? p.addEventListener("change", f) : p.addListener(f), () => {
      p.removeEventListener ? p.removeEventListener("change", f) : p.removeListener(f);
    };
  }, [e, o, n]), !e) return null;
  const m = () => {
    u.current = !0, Sd(r, !i), d(!i);
  };
  return /* @__PURE__ */ t.createElement(
    "aside",
    {
      className: ["axe-side-bar", be.root, i ? "" : be.closed, l].filter(Boolean).join(" "),
      style: { width: i ? a : Cd }
    },
    /* @__PURE__ */ t.createElement("div", { className: be.tab }, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: be.collapse,
        onClick: m,
        title: i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ t.createElement(sd, { name: i ? "collapse" : "expand" })
    )),
    /* @__PURE__ */ t.createElement("div", { className: be.body }, s)
  );
}
const io = eo(null);
function Kv({ children: e, defaultOpenId: n = null, exclusive: a = !0 }) {
  const [o, r] = x(n);
  return a ? /* @__PURE__ */ t.createElement(io.Provider, { value: { openId: o, setOpenId: r } }, e) : /* @__PURE__ */ t.createElement(t.Fragment, null, e);
}
const uo = "axe-side-panel:";
function Bd(e) {
  if (!e) return null;
  try {
    const n = window.localStorage.getItem(uo + e);
    return n === "1" ? !0 : n === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function Ad(e, n) {
  if (e)
    try {
      window.localStorage.setItem(uo + e, n ? "1" : "0");
    } catch {
    }
}
function Gv({
  title: e,
  enabled: n = !0,
  defaultOpen: a = !0,
  icon: o,
  badge: r,
  trailing: l,
  storageKey: s,
  panelId: c,
  className: i = "",
  children: d
}) {
  var h;
  const u = to(io), m = !!u && c != null, _ = I(Bd(s)), [p, f] = x((h = _.current) != null ? h : a), y = m ? u.openId === c : p, [E, k] = x(y), [$, S] = x(y);
  if (!n) return null;
  y && !E && k(!0);
  const g = () => {
    const v = !y;
    Ad(s, v), k(!0), S(!1), m ? u.setOpenId(v ? c : null) : f(v);
  };
  return /* @__PURE__ */ t.createElement("section", { className: ["axe-side-card", be.card, y ? be.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("header", { className: be.head, onClick: g }, /* @__PURE__ */ t.createElement("button", { type: "button", className: be.headBtn, "aria-expanded": y }, o && /* @__PURE__ */ t.createElement("span", { className: be.icon, "aria-hidden": "true" }, o), /* @__PURE__ */ t.createElement("strong", null, e)), r && /* @__PURE__ */ t.createElement("span", { className: be.badge }, r), l && /* @__PURE__ */ t.createElement("span", { className: be.trailing, onClick: (v) => v.stopPropagation() }, l), /* @__PURE__ */ t.createElement(
    "svg",
    {
      className: be.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ t.createElement("path", { d: "M6 9l6 6 6-6" })
  )), E && /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [be.panelWrap, y ? be.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (v) => {
        v.target === v.currentTarget && v.propertyName === "grid-template-rows" && S(!0);
      }
    },
    /* @__PURE__ */ t.createElement("div", { className: [be.panelBody, y && $ ? be.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: be.panelInner }, d))
  ));
}
const Md = "_guide_qnh7l_1", Td = "_title_qnh7l_5", Ld = "_desc_qnh7l_6", jd = "_act_qnh7l_7", Id = "_why_qnh7l_13", Rd = "_steps_qnh7l_14", Fd = "_no_qnh7l_20", qd = "_cur_qnh7l_24", Pd = "_link_qnh7l_26", rt = {
  guide: Md,
  title: Td,
  desc: Ld,
  act: jd,
  why: Id,
  steps: Rd,
  no: Fd,
  cur: qd,
  link: Pd
};
function Uv({ title: e, desc: n, action: a, steps: o }) {
  return /* @__PURE__ */ t.createElement("section", { className: rt.guide, "aria-label": e }, /* @__PURE__ */ t.createElement("h2", { className: rt.title }, e), n && /* @__PURE__ */ t.createElement("p", { className: rt.desc }, n), a && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("button", { type: "button", className: rt.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ t.createElement("p", { className: rt.why }, a.reason)), o && o.length > 0 && /* @__PURE__ */ t.createElement("ol", { className: rt.steps }, o.map((r, l) => /* @__PURE__ */ t.createElement("li", { key: r.label, className: r.current ? rt.cur : void 0 }, /* @__PURE__ */ t.createElement("span", { className: rt.no }, l + 1), r.onClick && !r.current ? /* @__PURE__ */ t.createElement("button", { type: "button", className: rt.link, onClick: r.onClick }, r.label) : /* @__PURE__ */ t.createElement("span", null, r.label), r.hint && /* @__PURE__ */ t.createElement("small", null, r.hint)))));
}
const Xd = "_list_1w2rs_1", Od = "_row_1w2rs_2", Wd = "_label_1w2rs_6", zd = "_value_1w2rs_7", Hd = "_emphasis_1w2rs_8", Kd = "_changed_1w2rs_10", Lt = {
  list: Xd,
  row: Od,
  label: Wd,
  value: zd,
  emphasis: Hd,
  changed: Kd
};
function Yv({ items: e, className: n }) {
  return /* @__PURE__ */ t.createElement("dl", { className: [Lt.list, n != null ? n : ""].join(" ") }, e.map((a, o) => /* @__PURE__ */ t.createElement("div", { key: o, className: [Lt.row, a.emphasis ? Lt.emphasis : ""].join(" ") }, /* @__PURE__ */ t.createElement("dt", { className: Lt.label }, a.label), /* @__PURE__ */ t.createElement("dd", { className: [Lt.value, a.changed ? Lt.changed : ""].join(" ") }, a.value))));
}
const Gd = "_underline_145xy_2", Ud = "_active_145xy_24", Yd = "_segmented_145xy_33", In = {
  underline: Gd,
  active: Ud,
  segmented: Yd
};
function mo({
  items: e,
  value: n,
  onChange: a,
  variant: o = "underline",
  className: r = "",
  "aria-label": l
}) {
  return /* @__PURE__ */ t.createElement(
    "nav",
    {
      className: [o === "segmented" ? In.segmented : In.underline, r].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": l
    },
    e.map((s) => /* @__PURE__ */ t.createElement(
      "button",
      {
        key: s.key,
        type: "button",
        role: "tab",
        "aria-selected": s.key === n,
        className: s.key === n ? In.active : "",
        onClick: () => a(s.key)
      },
      s.label
    ))
  );
}
const Vd = "_bar_1e999_1", Jd = "_actions_1e999_17", Zd = "_field_1e999_24", Qd = "_fieldLabel_1e999_25", e_ = "_readout_1e999_33", t_ = "_search_1e999_44", n_ = "_detail_1e999_58", a_ = "_pill_1e999_70", o_ = "_hint_1e999_81", st = {
  bar: Vd,
  actions: Jd,
  field: Zd,
  fieldLabel: Qd,
  readout: e_,
  search: t_,
  detail: n_,
  pill: a_,
  hint: o_
};
function Vv({
  children: e,
  onSearch: n,
  searchLabel: a = "조회",
  searchDisabled: o,
  searchTitle: r,
  detailSearch: l = !1,
  onDetailSearch: s,
  detailLabel: c = "상세검색",
  trailing: i
}) {
  return /* @__PURE__ */ t.createElement("section", { className: st.bar }, e, /* @__PURE__ */ t.createElement("span", { className: st.actions }, i, l && /* @__PURE__ */ t.createElement("button", { type: "button", className: st.detail, onClick: s }, "⌕ ", c), n && /* @__PURE__ */ t.createElement("button", { type: "button", className: st.search, onClick: n, disabled: o, title: r }, "⌕ ", a)));
}
function r_({ label: e, children: n }) {
  return /* @__PURE__ */ t.createElement("label", { className: st.field }, /* @__PURE__ */ t.createElement("span", { className: st.fieldLabel }, e), n);
}
function Jv({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: st.readout }, e);
}
function Zv({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: st.pill, role: "status" }, e);
}
function Qv({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: st.hint }, e);
}
function l_(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function e0({ rows: e, value: n, onChange: a, disabled: o, label: r = "기수" }) {
  return /* @__PURE__ */ t.createElement(r_, { label: r }, /* @__PURE__ */ t.createElement(
    "select",
    {
      value: n != null ? n : "",
      "aria-label": r,
      disabled: o,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (l) => a(Number(l.target.value))
    },
    e.map((l) => /* @__PURE__ */ t.createElement("option", { key: l.gisu, value: l.gisu }, l_(l)))
  ));
}
class _o {
  constructor(n, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((o) => {
        try {
          for (const r of o) {
            const l = r.borderBoxSize[0];
            this._callback({ width: l.inlineSize, height: l.blockSize }, r);
          }
        } catch (r) {
          console.error(r);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = n, this._callback = a, this.initializeResizeObserver();
  }
}
const s_ = "_card_1u6a3_2", c_ = "_grow_1u6a3_19", i_ = "_head_1u6a3_21", u_ = "_title_1u6a3_30", m_ = "_trailing_1u6a3_31", d_ = "_scroll_1u6a3_9", __ = "_foot_1u6a3_47", p_ = "_strip_1u6a3_49", f_ = "_spacer_1u6a3_50", y_ = "_table_1u6a3_52", h_ = "_fixed_1u6a3_53", b_ = "_fz_1u6a3_71", E_ = "_fzEdge_1u6a3_83", g_ = "_frozen_1u6a3_90", v_ = "_statusCell_1u6a3_206", w_ = "_status_1u6a3_206", k_ = "_st_error_1u6a3_214", N_ = "_stIcon_1u6a3_215", $_ = "_spin_1u6a3_221", x_ = "_axeSpin_1u6a3_1", C_ = "_busy_1u6a3_231", D_ = "_statusRow_1u6a3_233", S_ = "_busyBar_1u6a3_234", B_ = "_axeBusy_1u6a3_1", ie = {
  card: s_,
  grow: c_,
  head: i_,
  title: u_,
  trailing: m_,
  scroll: d_,
  foot: __,
  strip: p_,
  spacer: f_,
  table: y_,
  fixed: h_,
  fz: b_,
  fzEdge: E_,
  frozen: g_,
  statusCell: v_,
  status: w_,
  st_error: k_,
  stIcon: N_,
  spin: $_,
  axeSpin: x_,
  busy: C_,
  statusRow: D_,
  busyBar: S_,
  axeBusy: B_
}, A_ = 120;
function M_(e) {
  if (!e || !e.length) return;
  let n = 0, a = 0;
  for (const o of e)
    if (o == null) a += 1;
    else if (typeof o == "number") n += o;
    else if (/^\d+(\.\d+)?px$/.test(o)) n += parseFloat(o);
    else return;
  return a > 0 ? n + a * A_ : void 0;
}
function ga({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ t.createElement("colgroup", null, e.map((n, a) => /* @__PURE__ */ t.createElement("col", { key: a, style: n == null ? void 0 : { width: n } })));
}
const va = /* @__PURE__ */ new Set();
function T_(e) {
  var o;
  if (typeof process == "undefined" || ((o = process.env) == null ? void 0 : o.NODE_ENV) === "production") return;
  const n = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var l, s;
    r.scrollWidth > r.clientWidth + 1 && n.push((s = (l = r.textContent) == null ? void 0 : l.trim()) != null ? s : "");
  }), !n.length) return;
  const a = n.slice(0, 5).join("|");
  va.has(a) || (va.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${n.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    n.slice(0, 5)
  ));
}
function wa(e, n, a) {
  if (!e) return;
  const o = /* @__PURE__ */ new Map();
  for (const r of Array.from(e.rows)) {
    o.forEach((s, c) => {
      s <= 1 ? o.delete(c) : o.set(c, s - 1);
    });
    let l = 0;
    for (const s of Array.from(r.cells)) {
      for (; o.has(l); ) l += 1;
      const c = s.colSpan || 1, i = n > 0 && l + c <= n;
      if (s.classList.toggle(ie.fz, i), s.classList.toggle(ie.fzEdge, i && l + c === n), s.style.left = i ? `${a[l]}px` : "", s.rowSpan > 1) for (let d = l; d < l + c; d += 1) o.set(d, s.rowSpan);
      l += c;
    }
  }
}
function t0({
  cols: e,
  footer: n,
  title: a,
  trailing: o,
  grow: r,
  fixed: l,
  stickyCols: s = 0,
  busy: c,
  className: i = "",
  children: d
}) {
  const u = l || e !== void 0 && e.length > 0, m = u ? M_(e) : void 0, { stick: _, offsets: p } = Fe(() => {
    const b = Math.max(Math.trunc(s), 0), C = [];
    if (b === 0 || !e) return { stick: 0, offsets: C };
    let B = 0, A = 0;
    for (let T = 0; T < b; T += 1) {
      const R = e[T];
      if (typeof R != "number") break;
      C.push(B), B += R, A += 1;
    }
    return { stick: A, offsets: C };
  }, [e, s]), f = [ie.table, u ? ie.fixed : "", _ > 0 ? ie.frozen : ""].filter(Boolean).join(" "), y = I(null), E = I(null), k = I(null), $ = I(null), S = I(0), g = () => {
    const b = y.current, C = k.current, B = $.current;
    if (!b || !C || !B) return;
    const A = b.scrollWidth;
    B.style.width = A + "px", C.style.display = A > b.clientWidth + 1 ? "" : "none";
    const T = b.offsetWidth - b.clientWidth;
    C.style.paddingRight = T + "px", E.current && (E.current.style.paddingRight = T + "px"), T_(b);
  };
  G(() => {
    const b = y.current;
    if (!b) return;
    const C = new _o(b, g);
    return () => C.detach();
  }, []), ht(() => {
    var b, C, B, A;
    (_ > 0 || S.current > 0) && (wa((C = (b = y.current) == null ? void 0 : b.querySelector("table")) != null ? C : null, _, p), wa((A = (B = E.current) == null ? void 0 : B.querySelector("table")) != null ? A : null, _, p)), S.current = _, g();
  });
  const h = (b) => {
    const C = b.target.scrollLeft;
    y.current && (y.current.scrollLeft = C), E.current && (E.current.scrollLeft = C);
  }, v = (b) => {
    const C = b.target.scrollLeft;
    E.current && (E.current.scrollLeft = C), k.current && (k.current.scrollLeft = C);
  };
  return /* @__PURE__ */ t.createElement("div", { className: [ie.card, r ? ie.grow : "", c ? ie.busy : "", i].filter(Boolean).join(" ") }, c && /* @__PURE__ */ t.createElement("div", { className: ie.busyBar, "aria-hidden": "true" }), (a !== void 0 || o !== void 0) && /* @__PURE__ */ t.createElement("header", { className: ie.head }, /* @__PURE__ */ t.createElement("span", { className: ie.title }, a), o && /* @__PURE__ */ t.createElement("span", { className: ie.trailing }, o)), /* @__PURE__ */ t.createElement("div", { className: ie.scroll, ref: y, onScroll: v }, /* @__PURE__ */ t.createElement("table", { className: f, "aria-busy": c || void 0, style: m ? { minWidth: m } : void 0 }, /* @__PURE__ */ t.createElement(ga, { cols: e }), d)), n && /* @__PURE__ */ t.createElement("div", { className: ie.foot, ref: E }, /* @__PURE__ */ t.createElement("table", { className: f, style: m ? { minWidth: m } : void 0 }, /* @__PURE__ */ t.createElement(ga, { cols: e }), /* @__PURE__ */ t.createElement("tbody", null, n))), /* @__PURE__ */ t.createElement("div", { className: ie.strip, ref: k, onScroll: h }, /* @__PURE__ */ t.createElement("div", { ref: $, className: ie.spacer })));
}
const L_ = 7.09, j_ = 3.88, I_ = 4.46, R_ = 16, F_ = 2;
function q_(e, n = {}) {
  var l;
  const a = Math.max(1, e), o = Math.floor((a - 1) / 3), r = a * L_ + o * j_ + (n.negative ? I_ : 0) + R_ + F_;
  return Math.max(Math.ceil(r), (l = n.min) != null ? l : 0);
}
function n0(e, n = {}) {
  var r, l;
  let a = 0, o = (r = n.negative) != null ? r : !1;
  for (const s of e) {
    if (s == null || s === "") continue;
    const c = typeof s == "number" ? s : Number(String(s).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (o = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((l = n.min) != null ? l : 96, 96) : q_(a, { ...n, negative: o });
}
function a0(e) {
  const n = document.createElement("span");
  n.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(n);
  const a = (s) => (n.textContent = s, n.getBoundingClientRect().width), o = a("000000000000"), r = a("000,000,000,000"), l = a("-000,000,000,000");
  return n.remove(), { digit: o / 12, comma: (r - o) / 3, minus: l - r };
}
function o0({
  colSpan: e,
  loading: n,
  error: a,
  count: o,
  empty: r = "조회 결과가 없습니다",
  idle: l = "조회조건을 정하고 조회하세요",
  loadingText: s = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", d = o == null || o === 0, u = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let m;
  if (i) m = "error";
  else if (n && d) m = "loading";
  else if (o == null) {
    if (l === null) return null;
    m = "idle";
  } else if (o === 0) m = "empty";
  else return null;
  const _ = /* @__PURE__ */ t.createElement(t.Fragment, null, m === "loading" && /* @__PURE__ */ t.createElement("span", { className: ie.spin, "aria-hidden": "true" }), m === "error" && /* @__PURE__ */ t.createElement("span", { className: ie.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ t.createElement("span", null, m === "error" ? u : m === "loading" ? s : m === "idle" ? l : r)), p = /* @__PURE__ */ t.createElement("div", { className: [ie.status, ie[`st_${m}`]].join(" "), role: "status" }, _);
  return e === void 0 ? /* @__PURE__ */ t.createElement("div", { className: c || void 0, "data-state": m }, p) : /* @__PURE__ */ t.createElement("tr", { className: [ie.statusRow, c].filter(Boolean).join(" "), "data-state": m }, /* @__PURE__ */ t.createElement("td", { colSpan: e, className: ie.statusCell }, p));
}
function r0(e) {
  return {
    tabIndex: 0,
    onKeyDown: (n) => {
      n.target === n.currentTarget && (n.key === "Enter" || n.key === " ") && (n.preventDefault(), e());
    }
  };
}
const P_ = "_cell_n9rrj_1", X_ = "_toggle_n9rrj_2", O_ = "_spacer_n9rrj_8", W_ = "_label_n9rrj_9", z_ = "_dim_n9rrj_10", Jt = {
  cell: P_,
  toggle: X_,
  spacer: O_,
  label: W_,
  dim: z_
};
function l0(e, { id: n, parentId: a, defaultOpen: o = !0 }) {
  const [r, l] = x(() => /* @__PURE__ */ new Set()), [s, c] = x(() => /* @__PURE__ */ new Set()), { parents: i, kids: d } = Fe(() => {
    const p = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Set(), y = new Set(e.map((E) => String(n(E))));
    for (const E of e) {
      const k = a(E), $ = k == null || !y.has(String(k)) ? null : String(k);
      p.set(String(n(E)), $), $ && f.add($);
    }
    return { parents: p, kids: f };
  }, [e, n, a]), u = ee((p) => o ? !r.has(p) : s.has(p), [o, r, s]), m = Fe(() => e.filter((p) => {
    var E, k;
    let f = (E = i.get(String(n(p)))) != null ? E : null;
    const y = /* @__PURE__ */ new Set();
    for (; f && !y.has(f); ) {
      if (!u(f)) return !1;
      y.add(f), f = (k = i.get(f)) != null ? k : null;
    }
    return !0;
  }), [e, i, n, u]), _ = ee((p, f) => {
    const y = (E, k) => {
      const $ = new Set(E);
      return k ? $.add(p) : $.delete(p), $;
    };
    o ? l((E) => y(E, !f)) : c((E) => y(E, f));
  }, [o]);
  return {
    visible: m,
    hasChildren: (p) => d.has(String(n(p))),
    isOpen: (p) => u(String(n(p))),
    toggle: (p) => {
      const f = String(n(p));
      _(f, !u(f));
    },
    expandAll: () => {
      l(/* @__PURE__ */ new Set()), c(new Set(d));
    },
    collapseAll: () => {
      l(new Set(d)), c(/* @__PURE__ */ new Set());
    },
    reveal: (p) => {
      var E, k;
      let f = (E = i.get(String(p))) != null ? E : null;
      const y = /* @__PURE__ */ new Set();
      for (; f && !y.has(f); )
        _(f, !0), y.add(f), f = (k = i.get(f)) != null ? k : null;
    }
  };
}
function s0({ depth: e, hasChildren: n, open: a, onToggle: o, dim: r, children: l }) {
  const s = (c) => {
    c.stopPropagation(), o();
  };
  return /* @__PURE__ */ t.createElement("span", { className: [Jt.cell, r ? Jt.dim : ""].filter(Boolean).join(" "), style: { paddingLeft: e * 16 } }, n ? /* @__PURE__ */ t.createElement("button", { type: "button", className: Jt.toggle, "aria-expanded": a, "aria-label": a ? "하위 접기" : "하위 펼치기", onClick: s }, a ? "▾" : "▸") : /* @__PURE__ */ t.createElement("span", { className: Jt.spacer, "aria-hidden": "true" }), /* @__PURE__ */ t.createElement("span", { className: Jt.label }, l));
}
const H_ = "_card_14vt3_1", K_ = "_accent_14vt3_8", G_ = "_grow_14vt3_9", U_ = "_head_14vt3_11", Y_ = "_body_14vt3_20", V_ = "_title_14vt3_28", J_ = "_trailing_14vt3_29", Z_ = "_summary_14vt3_32", Q_ = "_sumHead_14vt3_33", ep = "_sumTotal_14vt3_42", tp = "_tone_warn_14vt3_43", np = "_tone_ok_14vt3_44", ap = "_sumList_14vt3_46", op = "_sumEm_14vt3_55", rp = "_sumFoot_14vt3_57", lp = "_sumNote_14vt3_66", ge = {
  card: H_,
  accent: K_,
  grow: G_,
  head: U_,
  body: Y_,
  title: V_,
  trailing: J_,
  summary: Z_,
  sumHead: Q_,
  sumTotal: ep,
  tone_warn: tp,
  tone_ok: np,
  sumList: ap,
  sumEm: op,
  sumFoot: rp,
  sumNote: lp
};
function po({
  title: e,
  trailing: n,
  accent: a,
  grow: o,
  flush: r,
  className: l = "",
  children: s
}) {
  return /* @__PURE__ */ t.createElement(
    "section",
    {
      className: [ge.card, a ? ge.accent : "", o ? ge.grow : "", l].filter(Boolean).join(" ")
    },
    e !== void 0 && /* @__PURE__ */ t.createElement("header", { className: ge.head }, /* @__PURE__ */ t.createElement("span", { className: ge.title }, e), n && /* @__PURE__ */ t.createElement("span", { className: ge.trailing }, n)),
    r ? s : /* @__PURE__ */ t.createElement("div", { className: ["axe-card-body", ge.body].join(" ") }, s)
  );
}
function c0({
  title: e,
  total: n,
  items: a,
  footerLabel: o,
  footerValue: r,
  note: l,
  tone: s = "default",
  children: c
}) {
  return /* @__PURE__ */ t.createElement("section", { className: [ge.card, ge.accent, ge.summary, ge[`tone_${s}`]].join(" ") }, /* @__PURE__ */ t.createElement("header", { className: ge.sumHead }, /* @__PURE__ */ t.createElement("span", null, e), n !== void 0 && /* @__PURE__ */ t.createElement("strong", { className: ge.sumTotal }, n)), /* @__PURE__ */ t.createElement("ul", { className: ge.sumList }, a.map((i, d) => {
    var u;
    return /* @__PURE__ */ t.createElement("li", { key: (u = i.key) != null ? u : d, className: i.em ? ge.sumEm : "" }, /* @__PURE__ */ t.createElement("span", null, i.label), /* @__PURE__ */ t.createElement("strong", null, i.value));
  })), c, o !== void 0 && /* @__PURE__ */ t.createElement("footer", { className: ge.sumFoot }, /* @__PURE__ */ t.createElement("span", null, o), /* @__PURE__ */ t.createElement("strong", null, r)), l && /* @__PURE__ */ t.createElement("div", { className: ge.sumNote }, l));
}
const sp = "_root_mx4n4_1", cp = "_rootNone_mx4n4_5", ip = "_codeInput_mx4n4_7", up = "_pickBtn_mx4n4_10", mp = "_suggest_mx4n4_25", dp = "_suggestList_mx4n4_31", _p = "_suggestRow_mx4n4_32", pp = "_suggestOn_mx4n4_33", fp = "_suggestEmpty_mx4n4_38", yp = "_suggestMore_mx4n4_38", hp = "_popup_mx4n4_42", bp = "_popupHead_mx4n4_56", Ep = "_searchRow_mx4n4_66", gp = "_list_mx4n4_70", vp = "_current_mx4n4_79", wp = "_empty_mx4n4_83", kp = "_summaryBtn_mx4n4_91", Np = "_ov_mx4n4_112", $p = "_modal_mx4n4_123", xp = "_modalWide_mx4n4_123", Cp = "_head_mx4n4_135", Dp = "_sub_mx4n4_143", Sp = "_x_mx4n4_145", Bp = "_body_mx4n4_162", Ap = "_chips_mx4n4_170", Mp = "_chip_mx4n4_170", Tp = "_chipOn_mx4n4_184", Lp = "_search_mx4n4_66", jp = "_tbl_mx4n4_203", Ip = "_row_mx4n4_233", Rp = "_rowCursor_mx4n4_235", Fp = "_rowPicked_mx4n4_236", qp = "_rowCurrent_mx4n4_237", Pp = "_curTag_mx4n4_238", Xp = "_busy_mx4n4_239", Op = "_count_mx4n4_240", Wp = "_chk_mx4n4_242", zp = "_tdLeft_mx4n4_243", Hp = "_tdCenter_mx4n4_244", Kp = "_emptyCell_mx4n4_246", Gp = "_stop_mx4n4_248", Up = "_more_mx4n4_259", Yp = "_pager_mx4n4_271", Vp = "_note_mx4n4_284", Jp = "_foot_mx4n4_287", Zp = "_ghost_mx4n4_296", Qp = "_primary_mx4n4_308", X = {
  root: sp,
  rootNone: cp,
  codeInput: ip,
  pickBtn: up,
  suggest: mp,
  suggestList: dp,
  suggestRow: _p,
  suggestOn: pp,
  suggestEmpty: fp,
  suggestMore: yp,
  popup: hp,
  popupHead: bp,
  searchRow: Ep,
  list: gp,
  current: vp,
  empty: wp,
  summaryBtn: kp,
  ov: Np,
  modal: $p,
  modalWide: xp,
  head: Cp,
  sub: Dp,
  x: Sp,
  body: Bp,
  chips: Ap,
  chip: Mp,
  chipOn: Tp,
  search: Lp,
  tbl: jp,
  row: Ip,
  rowCursor: Rp,
  rowPicked: Fp,
  rowCurrent: qp,
  curTag: Pp,
  busy: Xp,
  count: Op,
  chk: Wp,
  tdLeft: zp,
  tdCenter: Hp,
  emptyCell: Kp,
  stop: Gp,
  more: Up,
  pager: Yp,
  note: Vp,
  foot: Jp,
  ghost: Zp,
  primary: Qp
};
function ef(e, n = "전체") {
  if (e.length === 0) return n;
  const a = `${e[0].cd}.${e[0].nm}`;
  return e.length === 1 ? a : `${a} 외 ${e.length - 1}건`;
}
const fo = 250, yn = 7;
let tf = 0;
function ka(e, n) {
  const a = n.trim().toLowerCase();
  if (!a) return e;
  const o = e.toLowerCase().indexOf(a);
  return o < 0 ? e : /* @__PURE__ */ t.createElement(t.Fragment, null, e.slice(0, o), /* @__PURE__ */ t.createElement("b", null, e.slice(o, o + a.length)), e.slice(o + a.length));
}
function i0({
  value: e = "",
  onChange: n,
  items: a,
  source: o,
  multiple: r = !1,
  selected: l,
  onConfirm: s,
  current: c,
  trigger: i,
  emptyLabel: d = "전체",
  open: u,
  onOpenChange: m,
  placeholder: _,
  title: p = "코드도움",
  variant: f,
  disabled: y,
  className: E = ""
}) {
  const k = o ? "source" : "static", $ = f != null ? f : k === "source" ? "modal" : "anchor", S = i != null ? i : r ? "summary" : "input", [g, h] = x(!1), v = u != null ? u : g, b = ee(
    (L) => {
      u === void 0 && h(L), m && m(L);
    },
    [u, m]
  ), C = I(null), B = I(null), A = I(null), [T, R] = x(null), F = () => {
    if (!y) {
      if ($ === "anchor") {
        const L = C.current;
        if (!L) return;
        const ne = L.getBoundingClientRect(), ce = 320, _e = ne.bottom + ce > window.innerHeight ? Math.max(8, ne.top - ce - 4) : ne.bottom + 4;
        R({ left: Math.min(ne.left, window.innerWidth - 320), top: _e });
      }
      b(!0);
    }
  }, U = ee(() => b(!1), [b]), P = (L) => {
    s ? s(L) : L[0] && n && n(L[0].cd, { code: L[0].cd, name: L[0].nm });
  }, [M, j] = x(null), [te, Z] = x(-1), [J, se] = x(null), oe = I(null), $e = I(0), D = I(`axe-cp-${++tf}`), z = I(o);
  z.current = o;
  const H = I(a);
  H.current = a;
  const V = ee(() => {
    oe.current != null && (window.clearTimeout(oe.current), oe.current = null), $e.current += 1, j(null), Z(-1);
  }, []);
  G(() => V, [V]);
  const ue = (L) => {
    oe.current != null && window.clearTimeout(oe.current), $e.current += 1;
    const ne = $e.current;
    if (!L.trim()) {
      j(null), Z(-1);
      return;
    }
    oe.current = window.setTimeout(async () => {
      var Qe;
      let ce = [], _e = !1;
      try {
        const ut = z.current;
        if (ut) {
          const qe = await ut.fetch({ q: L, ty: null, page: 0 });
          ce = qe.rows, _e = !!qe.hasMore || ce.length > yn;
        } else {
          const qe = L.trim().toLowerCase();
          ce = ((Qe = H.current) != null ? Qe : []).filter((Be) => {
            var dn;
            return Be.code.toLowerCase().includes(qe) || Be.name.toLowerCase().includes(qe) || ((dn = Be.sub) != null ? dn : "").toLowerCase().includes(qe);
          }).map((Be) => ({ cd: Be.code, nm: Be.name, sub: Be.sub })), _e = ce.length > yn;
        }
      } catch {
        return;
      }
      ne === $e.current && (j({ rows: ce.slice(0, yn), more: _e, q: L }), Z(-1));
    }, fo);
  }, O = (L) => {
    V(), P([L]);
  };
  return G(() => {
    if (!M) {
      se(null);
      return;
    }
    const L = () => {
      const ne = C.current;
      if (!ne) return;
      const ce = ne.getBoundingClientRect(), _e = Math.min(M.rows.length, yn) * 28 + 34, Qe = ce.bottom + _e > window.innerHeight - 8 && ce.top - _e - 2 > 8 ? ce.top - _e - 2 : ce.bottom + 2, ut = Math.max(ce.width, 260);
      se({ left: Math.max(8, Math.min(ce.left, window.innerWidth - ut - 8)), top: Qe, width: ut });
    };
    return L(), window.addEventListener("resize", L), window.addEventListener("scroll", L, !0), () => {
      window.removeEventListener("resize", L), window.removeEventListener("scroll", L, !0);
    };
  }, [M]), /* @__PURE__ */ t.createElement("span", { ref: C, className: [S === "none" ? X.rootNone : X.root, E].filter(Boolean).join(" ") }, S === "input" && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    "input",
    {
      className: X.codeInput,
      value: e,
      placeholder: _,
      disabled: y,
      onChange: (L) => {
        const ne = L.target.value.trim();
        n && n(ne), !y && (o || a) && ue(ne);
      },
      onKeyDown: (L) => {
        if (L.key === "F2") {
          L.preventDefault(), V(), F();
          return;
        }
        if (!M) return;
        const ne = M.rows.length;
        L.key === "ArrowDown" && ne ? (L.preventDefault(), Z((ce) => (ce + 1) % ne)) : L.key === "ArrowUp" && ne ? (L.preventDefault(), Z((ce) => (ce <= 0 ? ne : ce) - 1)) : L.key === "Enter" && te >= 0 && M.rows[te] ? (L.preventDefault(), O(M.rows[te])) : L.key === "Escape" && (L.preventDefault(), L.stopPropagation(), L.nativeEvent.stopImmediatePropagation(), V());
      },
      onBlur: V,
      title: "F2: 코드도움",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!M,
      "aria-controls": M ? D.current : void 0,
      "aria-activedescendant": M && te >= 0 ? `${D.current}-${te}` : void 0
    }
  ), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: X.pickBtn,
      "aria-label": "코드도움 열기",
      disabled: y,
      onClick: F,
      tabIndex: -1
    },
    /* @__PURE__ */ t.createElement(vn, { name: "search", size: 13 })
  )), S === "summary" && /* @__PURE__ */ t.createElement("button", { type: "button", className: X.summaryBtn, disabled: y, onClick: F }, /* @__PURE__ */ t.createElement("span", null, ef(l != null ? l : [], d)), /* @__PURE__ */ t.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ t.createElement(vn, { name: "search", size: 13 }))), M && J && S === "input" && !v && /* @__PURE__ */ t.createElement(Wt, null, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: X.suggest,
      style: { left: J.left, top: J.top, width: J.width },
      onMouseDown: (L) => L.preventDefault()
    },
    M.rows.length === 0 ? /* @__PURE__ */ t.createElement("div", { className: X.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ t.createElement("ul", { id: D.current, role: "listbox", className: X.suggestList }, M.rows.map((L, ne) => /* @__PURE__ */ t.createElement(
      "li",
      {
        key: L.cd,
        id: `${D.current}-${ne}`,
        role: "option",
        "aria-selected": ne === te,
        className: [X.suggestRow, ne === te ? X.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => Z(ne),
        onClick: () => O(L)
      },
      /* @__PURE__ */ t.createElement("code", null, ka(L.cd, M.q)),
      /* @__PURE__ */ t.createElement("span", null, ka(L.nm, M.q)),
      L.useYn === !1 && /* @__PURE__ */ t.createElement("em", null, "중단")
    ))),
    M.more && /* @__PURE__ */ t.createElement("div", { className: X.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), v && k === "static" && $ === "anchor" && T && /* @__PURE__ */ t.createElement(
    nf,
    {
      items: a != null ? a : [],
      value: e,
      title: p,
      popupRef: B,
      anchorRef: C,
      pos: T,
      onPick: (L) => {
        n && n(L.code, L), U();
      },
      onClose: U
    }
  ), v && (k === "source" || $ === "modal") && /* @__PURE__ */ t.createElement(
    of,
    {
      source: o,
      items: a,
      title: p,
      multiple: r,
      selected: l,
      current: c,
      searchRef: A,
      onConfirm: (L) => {
        P(L), U();
      },
      onClose: U
    }
  ));
}
function nf({
  items: e,
  value: n,
  title: a,
  popupRef: o,
  anchorRef: r,
  pos: l,
  onPick: s,
  onClose: c
}) {
  const [i, d] = x(""), u = Fe(() => {
    const m = i.trim().toLowerCase();
    return m ? e.filter(
      (_) => {
        var p;
        return _.code.toLowerCase().includes(m) || _.name.toLowerCase().includes(m) || ((p = _.sub) != null ? p : "").toLowerCase().includes(m);
      }
    ) : e;
  }, [e, i]);
  return G(() => {
    const m = (p) => {
      const f = p.target;
      o.current && !o.current.contains(f) && r.current && !r.current.contains(f) && c();
    }, _ = (p) => {
      p.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", m), document.addEventListener("keydown", _), () => {
      document.removeEventListener("mousedown", m), document.removeEventListener("keydown", _);
    };
  }, [o, r, c]), /* @__PURE__ */ t.createElement(Wt, null, /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: o,
      className: X.popup,
      style: { left: l.left, top: l.top },
      role: "dialog",
      "aria-label": "코드도움"
    },
    /* @__PURE__ */ t.createElement("header", { className: X.popupHead }, /* @__PURE__ */ t.createElement("strong", null, a), /* @__PURE__ */ t.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ t.createElement("div", { className: X.searchRow }, /* @__PURE__ */ t.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        placeholder: "코드·명칭 검색",
        onChange: (m) => d(m.target.value),
        onKeyDown: (m) => {
          m.key === "Enter" && u.length && s(u[0]), m.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ t.createElement("ul", { className: X.list }, u.map((m) => /* @__PURE__ */ t.createElement("li", { key: m.code }, /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => s(m), className: m.code === n ? X.current : "" }, /* @__PURE__ */ t.createElement("code", null, m.code), /* @__PURE__ */ t.createElement("span", null, m.name), m.sub && /* @__PURE__ */ t.createElement("small", null, m.sub)))), u.length === 0 && /* @__PURE__ */ t.createElement("li", { className: X.empty }, "검색 결과가 없습니다"))
  ));
}
function af(e, n) {
  const a = e.map((o) => ({ cd: o.code, nm: o.name, sub: o.sub }));
  return {
    key: "static",
    title: typeof n == "string" ? n : "코드도움",
    nameLabel: "명칭",
    fetch: ({ q: o }) => {
      const r = o.trim().toLowerCase();
      return r ? Promise.resolve({
        rows: a.filter(
          (l) => {
            var s;
            return l.cd.toLowerCase().includes(r) || l.nm.toLowerCase().includes(r) || String((s = l.sub) != null ? s : "").toLowerCase().includes(r);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function of({
  source: e,
  items: n,
  title: a,
  multiple: o,
  selected: r,
  current: l,
  searchRef: s,
  onConfirm: c,
  onClose: i
}) {
  const d = Fe(() => af(n != null ? n : [], a), [n, a]), u = e != null ? e : d, [m, _] = x(""), [p, f] = x(null), [y, E] = x(0), [k, $] = x([]), [S, g] = x(!1), [h, v] = x(!1), [b, C] = x(null), [B, A] = x(0), [T, R] = x(/* @__PURE__ */ new Map()), F = I(u);
  F.current = u, G(() => {
    _(""), f(null), E(0), A(0), C(null), R(new Map((r != null ? r : []).map((z) => [z.cd, z])));
    const D = window.setTimeout(() => {
      s.current && s.current.focus();
    }, 30);
    return () => window.clearTimeout(D);
  }, [u.key]), G(() => {
    let D = !0;
    v(!0);
    const z = () => {
      F.current.fetch({ q: m.trim(), ty: p, page: y }).then((V) => {
        var O, L;
        if (!D) return;
        $((O = V.rows) != null ? O : []), g(!!V.hasMore), C(null);
        const ue = l ? ((L = V.rows) != null ? L : []).findIndex((ne) => ne.cd === l) : -1;
        A(ue > 0 ? ue : 0);
      }).catch((V) => {
        D && ($([]), g(!1), C(V instanceof Error ? V.message : "코드도움 조회에 실패했습니다"));
      }).finally(() => {
        D && v(!1);
      });
    }, H = window.setTimeout(z, m.trim() ? fo : 0);
    return () => {
      D = !1, window.clearTimeout(H);
    };
  }, [u.key, m, p, y]);
  const U = I(null);
  G(() => {
    const D = U.current && U.current.children[B];
    D && "scrollIntoView" in D && D.scrollIntoView({ block: "nearest" });
  }, [B, k]);
  const P = Fe(() => {
    var z, H;
    const D = [
      { key: "cd", label: "코드", width: (z = u.codeWidth) != null ? z : "96px", align: "center" },
      {
        key: "nm",
        label: u.nameLabel,
        align: "left",
        render: (V) => /* @__PURE__ */ t.createElement(t.Fragment, null, V.nm, V.useYn === !1 && /* @__PURE__ */ t.createElement("span", { className: X.stop }, "중단"))
      }
    ];
    return u.typeLabel && D.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (V) => u.typeLabel ? u.typeLabel(V) : ""
    }), D.concat((H = u.extraColumns) != null ? H : []);
  }, [u]), M = ee((D) => {
    R((z) => {
      const H = new Map(z);
      return H.has(D.cd) ? H.delete(D.cd) : H.set(D.cd, D), H;
    });
  }, []), j = ee((D) => c([D]), [c]), te = ee(() => c(Array.from(T.values())), [T, c]), Z = k.length > 0 && k.every((D) => T.has(D.cd)), J = () => {
    R((D) => {
      const z = new Map(D);
      return Z ? k.forEach((H) => z.delete(H.cd)) : k.forEach((H) => z.set(H.cd, H)), z;
    });
  }, se = I(null), oe = I(i);
  oe.current = i, G(() => {
    const D = (z) => {
      z.key !== "Escape" || z.isComposing || (z.stopPropagation(), z.preventDefault(), oe.current());
    };
    return document.addEventListener("keydown", D, !0), () => document.removeEventListener("keydown", D, !0);
  }, []);
  const $e = (D) => {
    if (!(D.nativeEvent.isComposing || D.keyCode === 229)) {
      if (D.key === "Tab" && se.current) {
        const z = Array.from(se.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
        if (z.length) {
          const H = z[0], V = z[z.length - 1], ue = document.activeElement;
          D.shiftKey && ue === H ? (D.preventDefault(), V.focus()) : !D.shiftKey && ue === V && (D.preventDefault(), H.focus());
        }
        return;
      }
      if (D.key === "Escape") {
        D.stopPropagation(), i();
        return;
      }
      if (D.key === "ArrowDown" || D.key === "ArrowUp") {
        D.preventDefault(), A((z) => Math.max(0, Math.min(k.length - 1, z + (D.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (D.key === " " && o && k[B]) {
        D.preventDefault(), M(k[B]);
        return;
      }
      if (D.key === "Enter") {
        if (D.preventDefault(), h) return;
        o ? te() : k[B] && j(k[B]);
      }
    }
  };
  return /* @__PURE__ */ t.createElement(Wt, null, /* @__PURE__ */ t.createElement("div", { className: X.ov, onClick: i }, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: u.wide ? `${X.modal} ${X.modalWide}` : X.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": u.title,
      ref: se,
      onClick: (D) => D.stopPropagation(),
      onKeyDown: $e
    },
    /* @__PURE__ */ t.createElement("div", { className: X.head }, /* @__PURE__ */ t.createElement("h2", null, u.title), o && /* @__PURE__ */ t.createElement("span", { className: X.sub }, "복수 선택 가능"), /* @__PURE__ */ t.createElement("button", { type: "button", className: X.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ t.createElement("div", { className: X.body }, u.filters && u.filters.length > 0 && /* @__PURE__ */ t.createElement("div", { className: X.chips }, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: p === null ? `${X.chip} ${X.chipOn}` : X.chip,
        onClick: () => {
          f(null), E(0);
        }
      },
      "전체"
    ), u.filters.map((D) => /* @__PURE__ */ t.createElement(
      "button",
      {
        key: D.value,
        type: "button",
        className: p === D.value ? `${X.chip} ${X.chipOn}` : X.chip,
        onClick: () => {
          f(D.value), E(0);
        }
      },
      D.label
    ))), /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: s,
        className: X.search,
        value: m,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (D) => {
          _(D.target.value), E(0);
        }
      }
    ), /* @__PURE__ */ t.createElement("div", { className: X.tbl }, /* @__PURE__ */ t.createElement("table", null, /* @__PURE__ */ t.createElement("thead", null, /* @__PURE__ */ t.createElement("tr", null, o && /* @__PURE__ */ t.createElement("th", { className: X.chk }, /* @__PURE__ */ t.createElement(
      "input",
      {
        type: "checkbox",
        checked: Z,
        onChange: J,
        "aria-label": "표시된 행 전체 선택"
      }
    )), P.map((D) => /* @__PURE__ */ t.createElement("th", { key: D.key, style: D.width ? { width: D.width } : void 0 }, D.label)))), /* @__PURE__ */ t.createElement("tbody", { ref: U, className: h && k.length > 0 ? X.busy : void 0, "aria-busy": h }, k.length === 0 ? /* @__PURE__ */ t.createElement("tr", null, /* @__PURE__ */ t.createElement("td", { className: X.emptyCell, colSpan: P.length + (o ? 1 : 0) }, h ? "조회 중…" : b || u.emptyText || "검색 결과가 없습니다")) : k.map((D, z) => /* @__PURE__ */ t.createElement(
      "tr",
      {
        key: D.cd,
        className: [
          X.row,
          z === B ? X.rowCursor : "",
          T.has(D.cd) ? X.rowPicked : "",
          !o && l && D.cd === l ? X.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": z === B,
        onClick: () => {
          A(z), o ? M(D) : j(D);
        }
      },
      o && /* @__PURE__ */ t.createElement("td", { className: X.chk }, /* @__PURE__ */ t.createElement(
        "input",
        {
          type: "checkbox",
          checked: T.has(D.cd),
          onChange: () => M(D),
          onClick: (H) => H.stopPropagation(),
          "aria-label": `${D.cd} 선택`
        }
      )),
      P.map((H) => {
        var V, ue;
        return /* @__PURE__ */ t.createElement(
          "td",
          {
            key: H.key,
            className: H.align === "left" ? X.tdLeft : X.tdCenter,
            title: H.render ? void 0 : String((V = D[H.key]) != null ? V : "")
          },
          H.render ? H.render(D) : String((ue = D[H.key]) != null ? ue : ""),
          H.key === "cd" && !o && l && D.cd === l && /* @__PURE__ */ t.createElement("em", { className: X.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ t.createElement("p", { className: X.count, role: "status", "aria-live": "polite" }, h ? "조회 중…" : b ? "" : `${k.length}건`, !o && !h && !b && k.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 줄을 누르세요"), (S || y > 0) && /* @__PURE__ */ t.createElement("div", { className: X.more }, /* @__PURE__ */ t.createElement("span", null, S ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ t.createElement("span", { className: X.pager }, /* @__PURE__ */ t.createElement("button", { type: "button", disabled: y === 0, onClick: () => E((D) => Math.max(0, D - 1)) }, "이전"), /* @__PURE__ */ t.createElement("b", null, y + 1), S && /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => E((D) => D + 1) }, "다음"))), o && /* @__PURE__ */ t.createElement("p", { className: X.note }, "선택 ", /* @__PURE__ */ t.createElement("b", null, T.size), "건 — 선택이 없으면 ", /* @__PURE__ */ t.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ t.createElement("div", { className: X.foot }, o && /* @__PURE__ */ t.createElement("button", { type: "button", className: X.ghost, onClick: () => R(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ t.createElement("button", { type: "button", className: X.ghost, onClick: i }, "취소"), o && /* @__PURE__ */ t.createElement("button", { type: "button", className: X.primary, onClick: te }, "확인"))
  )));
}
const Na = "1900-01-01", $a = "2099-12-31", Rn = ["일", "월", "화", "수", "목", "금", "토"], wn = (e) => String(e).padStart(2, "0");
function Ie(e, n) {
  return new Date(Date.UTC(e, n, 0)).getUTCDate();
}
function We(e, n, a) {
  return `${String(e).padStart(4, "0")}-${wn(n)}-${wn(a)}`;
}
function le(e) {
  const n = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!n) return null;
  const a = +n[1], o = +n[2], r = +n[3];
  return o < 1 || o > 12 || r < 1 || r > Ie(a, o) ? null : { y: a, m: o, d: r };
}
function rf(e) {
  const n = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!n) return null;
  const a = +n[1], o = +n[2];
  return o < 1 || o > 12 ? null : { y: a, m: o, d: 1 };
}
function Zt(e, n) {
  return n === "month" ? rf(e) : le(e);
}
function xe(e, n) {
  return n === "month" ? `${String(e.y).padStart(4, "0")}-${wn(e.m)}` : We(e.y, e.m, e.d);
}
function Ce(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function qt(e, n) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + n));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function yt(e, n) {
  const a = e.y * 12 + (e.m - 1) + n, o = Math.floor(a / 12), r = (a % 12 + 12) % 12 + 1;
  return { y: o, m: r, d: Math.min(e.d, Ie(o, r)) };
}
function lf(e, n, a) {
  return e >= n && e <= a;
}
function jt(e, n) {
  return e.replace(/\D/g, "").slice(0, n === "month" ? 6 : 8);
}
function Fn(e, n) {
  const a = e.slice(0, 4), o = e.slice(4, 6), r = e.slice(6, 8);
  let l = a;
  return e.length > 4 && (l += "-" + o), n === "date" && e.length > 6 && (l += "-" + r), l;
}
function xa(e, n) {
  if (n <= 0) return 0;
  let a = 0;
  for (let o = 0; o < e.length; o++)
    if (/\d/.test(e[o]) && (a++, a === n))
      return o + 1;
  return e.length;
}
function En(e, n, a) {
  let o, r, l = 1;
  if (n === "month")
    if (e.length === 6)
      o = +e.slice(0, 4), r = +e.slice(4, 6);
    else if (e.length === 4)
      o = 2e3 + +e.slice(0, 2), r = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    o = +e.slice(0, 4), r = +e.slice(4, 6), l = +e.slice(6, 8);
  else if (e.length === 6)
    o = 2e3 + +e.slice(0, 2), r = +e.slice(2, 4), l = +e.slice(4, 6);
  else if (e.length === 4)
    o = a.y, r = +e.slice(0, 2), l = +e.slice(2, 4);
  else return null;
  return r < 1 || r > 12 || l < 1 || l > Ie(o, r) ? null : { y: o, m: r, d: l };
}
function sf(e, n, a) {
  const o = e.trim(), r = n === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(o) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(o);
  if (r) {
    const l = { y: +r[1], m: +r[2], d: n === "month" ? 1 : +r[3] };
    return l.m >= 1 && l.m <= 12 && l.d >= 1 && l.d <= Ie(l.y, l.m) ? l : null;
  }
  return En(o.replace(/\D/g, ""), n, a);
}
function cf(e, n) {
  const a = { y: e, m: n, d: 1 }, o = qt(a, -Ce(a));
  return Array.from({ length: 42 }, (r, l) => qt(o, l));
}
function uf(e, n) {
  const a = e.y, o = [], r = (d, u) => `${String(d).padStart(4, "0")}-${wn(u)}`, l = (d, u, m) => We(d, u, m);
  if (n === "month") {
    o.push({ label: "이번 달", from: r(a, e.m), to: r(a, e.m) });
    const d = yt(e, -1);
    o.push({ label: "지난달", from: r(d.y, d.m), to: r(d.y, d.m) }), o.push({ label: "올해", from: r(a, 1), to: r(a, 12) }), o.push({ label: "올해 누계", from: r(a, 1), to: r(a, e.m) }), o.push({ label: "전년도", from: r(a - 1, 1), to: r(a - 1, 12) });
    for (let u = 1; u <= 4; u++) o.push({ label: `${u}분기`, from: r(a, u * 3 - 2), to: r(a, u * 3) });
    return o.push({ label: "상반기", from: r(a, 1), to: r(a, 6) }), o.push({ label: "하반기", from: r(a, 7), to: r(a, 12) }), o;
  }
  const s = We(e.y, e.m, e.d);
  o.push({ label: "오늘", from: s, to: s });
  const c = qt(e, -Ce(e));
  o.push({ label: "이번 주", from: xe(c, "date"), to: xe(qt(c, 6), "date") }), o.push({ label: "이번 달", from: l(a, e.m, 1), to: l(a, e.m, Ie(a, e.m)) });
  const i = yt({ ...e, d: 1 }, -1);
  o.push({ label: "지난달", from: l(i.y, i.m, 1), to: l(i.y, i.m, Ie(i.y, i.m)) }), o.push({ label: "올해", from: l(a, 1, 1), to: l(a, 12, 31) }), o.push({ label: "올해 오늘까지", from: l(a, 1, 1), to: s }), o.push({ label: "전년도", from: l(a - 1, 1, 1), to: l(a - 1, 12, 31) });
  for (let d = 1; d <= 4; d++)
    o.push({ label: `${d}분기`, from: l(a, d * 3 - 2, 1), to: l(a, d * 3, Ie(a, d * 3)) });
  return o;
}
const mf = "_wrap_uxy72_1", df = "_disabled_uxy72_18", _f = "_input_uxy72_22", pf = "_month_uxy72_36", ff = "_weekday_uxy72_39", yf = "_sun_uxy72_40", hf = "_sat_uxy72_41", bf = "_icon_uxy72_43", Ef = "_readOnly_uxy72_57", gf = "_required_uxy72_62", vf = "_invalid_uxy72_63", wf = "_pop_uxy72_66", kf = "_calHead_uxy72_79", Nf = "_calTitleStatic_uxy72_80", $f = "_calTitle_uxy72_80", xf = "_grid_uxy72_90", Cf = "_wd_uxy72_91", Df = "_day_uxy72_95", Sf = "_mon_uxy72_36", Bf = "_out_uxy72_104", Af = "_sel_uxy72_105", Mf = "_today_uxy72_108", Tf = "_months_uxy72_111", Lf = "_foot_uxy72_114", jf = "_clear_uxy72_127", If = "_range_uxy72_130", Rf = "_tilde_uxy72_131", Ff = "_rangeErr_uxy72_132", K = {
  wrap: mf,
  disabled: df,
  input: _f,
  month: pf,
  weekday: ff,
  sun: yf,
  sat: hf,
  icon: bf,
  readOnly: Ef,
  required: gf,
  invalid: vf,
  pop: wf,
  calHead: kf,
  calTitleStatic: Nf,
  calTitle: $f,
  grid: xf,
  wd: Cf,
  day: Df,
  mon: Sf,
  out: Bf,
  sel: Af,
  today: Mf,
  months: Tf,
  foot: Lf,
  clear: jf,
  range: If,
  tilde: Rf,
  rangeErr: Ff
}, pt = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function Ca({
  value: e,
  onChange: n,
  mode: a = "date",
  min: o,
  max: r,
  disabled: l,
  readOnly: s,
  required: c,
  invalid: i,
  showWeekday: d,
  placeholder: u,
  id: m,
  name: _,
  onBlur: p,
  "aria-label": f,
  "aria-describedby": y,
  className: E = "",
  style: k
}) {
  const $ = a === "month", S = o || ($ ? Na.slice(0, 7) : Na), g = r || ($ ? $a.slice(0, 7) : $a), h = (N) => lf(N, S, g), v = !!l || !!s, [b, C] = x(e || ""), [B, A] = x(!1), [T, R] = x(!1), [F, U] = x($ ? "month" : "day"), [P, M] = x(() => {
    var q;
    const N = (q = Zt(e, a)) != null ? q : pt();
    return { y: N.y, m: N.m };
  }), [j, te] = x({ top: 0, left: 0 }), Z = I(null), J = I(null), se = I(null), oe = I(null);
  G(() => {
    C(e || ""), A(!1);
  }, [e]), G(() => {
    const N = Zt(e, a);
    N && M({ y: N.y, m: N.m });
  }, [e, a]), ht(() => {
    const N = J.current;
    oe.current != null && N && document.activeElement === N && N.setSelectionRange(oe.current, oe.current), oe.current = null;
  }, [b]), ht(() => {
    if (!T) return;
    const N = () => {
      const q = Z.current, Y = se.current;
      if (!q || !Y) return;
      const ae = q.getBoundingClientRect(), re = Y.offsetHeight, ye = Y.offsetWidth;
      let ve = ae.bottom + 4;
      ve + re > window.innerHeight - 8 && ae.top - re - 4 > 8 && (ve = ae.top - re - 4);
      const zt = Math.max(8, Math.min(ae.left, window.innerWidth - ye - 8));
      te((Tn) => Tn.top === ve && Tn.left === zt ? Tn : { top: ve, left: zt });
    };
    return N(), window.addEventListener("resize", N), window.addEventListener("scroll", N, !0), () => {
      window.removeEventListener("resize", N), window.removeEventListener("scroll", N, !0);
    };
  }, [T, F, P.y, P.m]), G(() => {
    if (!T) return;
    const N = (q) => {
      var ae, re;
      const Y = q.target;
      (ae = Z.current) != null && ae.contains(Y) || (re = se.current) != null && re.contains(Y) || R(!1);
    };
    return document.addEventListener("mousedown", N), () => document.removeEventListener("mousedown", N);
  }, [T]);
  const $e = (N) => {
    N !== (e || "") && n(N);
  }, D = (N) => {
    C(N), A(!1), $e(N);
  }, z = () => {
    const N = jt(b, a);
    if (!N) return;
    const q = En(N, a, pt()), Y = q ? xe(q, a) : null;
    if (Y && h(Y)) {
      D(Y);
      return;
    }
    C(e || ""), A(!1);
  }, H = (N, q) => {
    const Y = jt(N.slice(0, q), a).length, ae = jt(N, a), re = Fn(ae, a);
    if (oe.current = xa(re, Math.min(Y, ae.length)), C(re), !ae) {
      A(!1), $e("");
      return;
    }
    if (ae.length === ($ ? 6 : 8)) {
      const ye = En(ae, a, pt()), ve = ye ? xe(ye, a) : null;
      ve && h(ve) ? (A(!1), $e(ve)) : A(!0);
    } else A(!1);
  }, V = (N, q) => {
    var zt;
    const Y = pt(), ae = jt(b, a), re = (zt = En(ae, a, Y)) != null ? zt : Zt(e, a);
    let ye;
    re ? $ ? ye = yt(re, N === "year" ? 12 * q : q) : N === "day" ? ye = qt(re, q) : ye = yt(re, N === "month" ? q : 12 * q) : ye = Y;
    const ve = xe(ye, a);
    h(ve) && D(ve);
  }, ue = (N) => {
    var q;
    D(N), R(!1), (q = J.current) == null || q.focus();
  }, O = () => {
    var q;
    if (v) return;
    const N = (q = Zt(e, a)) != null ? q : pt();
    M({ y: N.y, m: N.m }), U($ ? "month" : "day"), R(!0);
  }, L = (N) => {
    var Y, ae;
    if (v) return;
    const q = N.currentTarget;
    switch (N.key) {
      case "Escape":
        T ? (R(!1), N.preventDefault(), N.stopPropagation(), N.nativeEvent.stopImmediatePropagation()) : b !== (e || "") && (C(e || ""), A(!1), N.preventDefault(), N.stopPropagation(), N.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => q.select()));
        break;
      case "ArrowDown":
        N.preventDefault(), N.altKey ? T ? R(!1) : O() : V("day", 1);
        break;
      case "ArrowUp":
        N.preventDefault(), V("day", -1);
        break;
      case "PageDown":
        N.preventDefault(), V("month", 1);
        break;
      case "PageUp":
        N.preventDefault(), V("month", -1);
        break;
      case "F2":
      case "F4":
        N.preventDefault(), T ? R(!1) : O();
        break;
      case "Enter":
        z(), T && R(!1);
        break;
      case "t":
      case "T":
        if (N.ctrlKey || N.metaKey || N.altKey) break;
        N.preventDefault(), D(xe(pt(), a));
        break;
      case "Backspace": {
        const re = (Y = q.selectionStart) != null ? Y : 0;
        if (re === ((ae = q.selectionEnd) != null ? ae : 0) && re > 0 && b[re - 1] === "-") {
          N.preventDefault();
          const ye = jt(b.slice(0, re), a).length, ve = jt(b, a);
          H(Fn(ve.slice(0, ye - 1) + ve.slice(ye), a), 0), oe.current = xa(Fn(ve.slice(0, ye - 1) + ve.slice(ye), a), ye - 1);
        }
        break;
      }
    }
  }, ne = (N) => {
    if (v) return;
    N.preventDefault();
    const q = sf(N.clipboardData.getData("text"), a, pt()), Y = q ? xe(q, a) : null;
    Y && h(Y) ? D(Y) : A(!0);
  }, ce = (N) => {
    var Y, ae;
    const q = N.relatedTarget;
    q && ((Y = Z.current) != null && Y.contains(q) || (ae = se.current) != null && ae.contains(q)) || (z(), R(!1), p && p());
  }, _e = Zt(e, a), Qe = pt(), ut = B || !!i, qe = d && !$ && _e ? Ce(_e) : null, Be = (N) => xe(N, a), dn = (N, q) => {
    const Y = xe({ y: N, m: q, d: 1 }, "date"), ae = xe({ y: N, m: q, d: Ie(N, q) }, "date"), re = $ ? S + "-01" : S, ye = $ ? g + "-31" : g;
    return ae >= re && Y <= ye;
  }, Ct = (N) => {
    const q = yt({ y: P.y, m: P.m, d: 1 }, N);
    M({ y: q.y, m: q.m });
  }, qo = () => /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: K.calHead }, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Ct(-12) }, "«"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => Ct(-1) }, "‹"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, className: K.calTitle, "aria-label": "연·월 선택", onClick: () => U("month") }, P.y, "년 ", P.m, "월"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => Ct(1) }, "›"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Ct(12) }, "»")), /* @__PURE__ */ t.createElement("div", { className: K.grid }, Rn.map((N, q) => /* @__PURE__ */ t.createElement("span", { key: N, className: [K.wd, q === 0 ? K.sun : "", q === 6 ? K.sat : ""].join(" ") }, N)), cf(P.y, P.m).map((N) => {
    const q = xe(N, "date"), Y = Ce(N), ae = [
      K.day,
      N.m !== P.m ? K.out : "",
      Y === 0 ? K.sun : "",
      Y === 6 ? K.sat : "",
      q === xe(Qe, "date") ? K.today : "",
      _e && q === xe(_e, "date") ? K.sel : ""
    ].join(" "), re = !h(q);
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: q,
        type: "button",
        tabIndex: -1,
        className: ae,
        disabled: re,
        "aria-label": `${N.y}년 ${N.m}월 ${N.d}일 ${Rn[Y]}요일`,
        "aria-pressed": !!_e && q === xe(_e, "date"),
        onClick: () => ue(q)
      },
      N.d
    );
  }))), Po = () => /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: K.calHead }, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Ct(-12) }, "«"), /* @__PURE__ */ t.createElement("span", { className: K.calTitleStatic }, P.y, "년"), /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Ct(12) }, "»")), /* @__PURE__ */ t.createElement("div", { className: K.months }, Array.from({ length: 12 }, (N, q) => q + 1).map((N) => {
    const q = !!_e && _e.y === P.y && _e.m === N, Y = [K.mon, q ? K.sel : "", Qe.y === P.y && Qe.m === N ? K.today : ""].join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: N,
        type: "button",
        tabIndex: -1,
        className: Y,
        disabled: !dn(P.y, N),
        "aria-pressed": q,
        onClick: () => {
          $ ? ue(Be({ y: P.y, m: N, d: 1 })) : (M({ y: P.y, m: N }), U("day"));
        }
      },
      N,
      "월"
    );
  }))), _n = xe(Qe, a), Xo = $ ? /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, disabled: !h(_n), onClick: () => ue(_n) }, "이번 달")) : /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, disabled: !h(_n), onClick: () => ue(_n) }, "오늘"), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !h(Be({ y: P.y, m: P.m, d: 1 })),
      onClick: () => ue(Be({ y: P.y, m: P.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !h(Be({ y: P.y, m: P.m, d: Ie(P.y, P.m) })),
      onClick: () => ue(Be({ y: P.y, m: P.m, d: Ie(P.y, P.m) }))
    },
    "월말"
  )), Oo = [
    K.wrap,
    l ? K.disabled : "",
    s ? K.readOnly : "",
    c && !e && !b ? K.required : "",
    ut ? K.invalid : "",
    $ ? K.month : "",
    E
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ t.createElement("span", { ref: Z, className: Oo, style: k, onBlur: ce }, /* @__PURE__ */ t.createElement(
    "input",
    {
      ref: J,
      id: m,
      name: _,
      className: K.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: b,
      placeholder: u != null ? u : $ ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: l,
      readOnly: s,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": T,
      "aria-label": f,
      "aria-describedby": y,
      "aria-invalid": ut || void 0,
      "aria-required": c || void 0,
      onChange: (N) => {
        var q;
        return H(N.target.value, (q = N.target.selectionStart) != null ? q : N.target.value.length);
      },
      onKeyDown: L,
      onPaste: ne
    }
  ), qe != null && /* @__PURE__ */ t.createElement("span", { className: [K.weekday, qe === 0 ? K.sun : "", qe === 6 ? K.sat : ""].join(" "), "aria-hidden": "true" }, "(", Rn[qe], ")"), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: K.icon,
      disabled: v,
      "aria-label": $ ? "월 선택 열기" : "달력 열기",
      onMouseDown: (N) => N.preventDefault(),
      onClick: () => {
        var N;
        (N = J.current) == null || N.focus(), T ? R(!1) : O();
      }
    },
    /* @__PURE__ */ t.createElement(vn, { name: "calendar", size: 15 })
  ), T && /* @__PURE__ */ t.createElement(Wt, null, /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: se,
      className: K.pop,
      style: { top: j.top, left: j.left },
      role: "dialog",
      "aria-label": $ ? "월 선택" : "날짜 선택",
      onMouseDown: (N) => N.preventDefault()
    },
    F === "day" && !$ ? qo() : Po(),
    /* @__PURE__ */ t.createElement("div", { className: K.foot }, Xo, !c && /* @__PURE__ */ t.createElement("button", { type: "button", tabIndex: -1, className: K.clear, onClick: () => ue("") }, "지우기"))
  )));
}
const kt = (e) => String(e).padStart(2, "0");
function yo() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${kt(e.getMonth() + 1)}-${kt(e.getDate())}`;
}
function u0(e) {
  if (!e) return "";
  const n = new Date(e);
  return Number.isNaN(n.getTime()) ? String(e) : `${n.getFullYear()}-${kt(n.getMonth() + 1)}-${kt(n.getDate())} ${kt(n.getHours())}:${kt(n.getMinutes())}:${kt(n.getSeconds())}`;
}
function m0(e, n) {
  return !!e && !!n && e <= n;
}
function d0({
  from: e,
  to: n,
  onChange: a,
  mode: o = "date",
  min: r,
  max: l,
  disabled: s,
  label: c = "기간",
  presets: i = !0,
  showWeekday: d
}) {
  const u = !!e && !!n && e > n, m = /* @__PURE__ */ new Date(), _ = i === !1 ? [] : Array.isArray(i) ? i : uf({ y: m.getFullYear(), m: m.getMonth() + 1, d: m.getDate() }, o), p = (f) => (!r || f.from >= r) && (!l || f.to <= l);
  return /* @__PURE__ */ t.createElement("span", { className: K.range }, /* @__PURE__ */ t.createElement(
    Ca,
    {
      value: e,
      mode: o,
      min: r,
      max: l,
      disabled: s,
      showWeekday: d,
      "aria-label": `${c} 시작`,
      onChange: (f) => a(f, n)
    }
  ), /* @__PURE__ */ t.createElement("span", { className: K.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ t.createElement(
    Ca,
    {
      value: n,
      mode: o,
      min: r,
      max: l,
      disabled: s,
      showWeekday: d,
      "aria-label": `${c} 끝`,
      onChange: (f) => a(e, f)
    }
  ), _.length > 0 && /* @__PURE__ */ t.createElement(
    Zm,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: s,
      entries: _.map((f) => Jm(
        f.label,
        f.label,
        () => a(f.from, f.to),
        p(f) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), u && /* @__PURE__ */ t.createElement("span", { className: K.rangeErr, role: "alert" }, "시작이 끝보다 늦습니다"));
}
const ho = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function bo(e, n = ho) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let o = null;
  for (const r of n) r.start <= e.slice(0, 10) && (!o || r.start > o.start) && (o = r);
  return o ? { era: o, year: +a[1] - +o.start.slice(0, 4) + 1 } : null;
}
function qf(e, n = {}) {
  const a = bo(e, n.eras);
  return a ? `${a.era.name}${a.year === 1 && n.gannen !== !1 ? "元" : a.year}年` : null;
}
function _0(e, n) {
  const a = bo(e, n);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Ne = 1440, kn = (e) => String(e).padStart(2, "0");
function de(e) {
  const n = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return n ? Date.UTC(+n[1], +n[2] - 1, +n[3], n[4] ? +n[4] : 0, n[5] ? +n[5] : 0) / 6e4 : NaN;
}
function $t(e) {
  const n = new Date(e * 6e4);
  return We(n.getUTCFullYear(), n.getUTCMonth() + 1, n.getUTCDate());
}
function nn(e) {
  const n = new Date(e * 6e4);
  return `${$t(e)}T${kn(n.getUTCHours())}:${kn(n.getUTCMinutes())}`;
}
function Je(e) {
  const n = (e % Ne + Ne) % Ne;
  return `${kn(Math.floor(n / 60))}:${kn(n % 60)}`;
}
function Ee(e, n) {
  const a = le(e);
  if (!a) return e;
  const o = qt(a, n);
  return We(o.y, o.m, o.d);
}
function Pt(e, n) {
  return Math.round((de(n) - de(e)) / Ne);
}
function ln(e) {
  const n = le(e);
  if (!n) return !1;
  const a = Ce(n);
  return a === 0 || a === 6;
}
function Pf(e) {
  var r;
  const n = de(e.start);
  if (Number.isNaN(n)) return null;
  const a = (r = e.allDay) != null ? r : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const l = $t(n), s = e.end ? $t(de(e.end)) : l, c = s < l ? l : s;
    return { ev: e, s: de(l), e: de(c) + Ne, allDay: a, sDay: l, eDay: c };
  }
  let o = e.end ? de(e.end) : n + 60;
  return (Number.isNaN(o) || o <= n) && (o = n + 30), { ev: e, s: n, e: o, allDay: a, sDay: $t(n), eDay: $t(o - 1) };
}
function Sn(e, n, a, o) {
  const r = [];
  for (const l of e) {
    const s = o && l.id === o.id ? { ...l, start: o.start, end: o.end } : l, c = Pf(s);
    c && c.eDay >= n && c.sDay <= a && r.push(c);
  }
  return r.sort(Xf);
}
function Xf(e, n) {
  if (e.sDay !== n.sDay) return e.sDay < n.sDay ? -1 : 1;
  const a = Pt(n.sDay, n.eDay) - Pt(e.sDay, e.eDay);
  return a || (e.allDay !== n.allDay ? e.allDay ? -1 : 1 : e.s !== n.s ? e.s - n.s : e.ev.title.localeCompare(n.ev.title));
}
function Of(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function Eo(e) {
  return e.allDay || e.e - e.s >= Ne;
}
function Nn(e, n) {
  const a = le(e);
  if (!a) return e;
  const o = (Ce(a) - n + 7) % 7;
  return Ee(e, -o);
}
function Bn(e, n) {
  const a = Pt(e, n);
  return Array.from({ length: Math.max(0, a + 1) }, (o, r) => Ee(e, r));
}
function go(e, n) {
  const a = le(e), o = We(a.y, a.m, 1), r = We(a.y, a.m, Ie(a.y, a.m)), l = Nn(o, n), s = Ee(Nn(r, n), 6), c = Bn(l, s), i = [];
  for (let d = 0; d < c.length; d += 7) i.push(c.slice(d, d + 7));
  return i;
}
function na(e, n, a) {
  if (e === "month") {
    const o = go(n, a);
    return { from: o[0][0], to: o[o.length - 1][6] };
  }
  if (e === "agenda") {
    const o = le(n);
    return { from: We(o.y, o.m, 1), to: We(o.y, o.m, Ie(o.y, o.m)) };
  }
  if (e === "week") {
    const o = Nn(n, a);
    return { from: o, to: Ee(o, 6) };
  }
  return { from: n, to: n };
}
function Wf(e, n, a, o = !1) {
  const r = le(n);
  if (!r) return n;
  if (e === "month" || e === "agenda") {
    const s = yt(r, a);
    return We(s.y, s.m, s.d);
  }
  if (e === "week") return Ee(n, 7 * a);
  let l = Ee(n, a);
  for (; o && ln(l); ) l = Ee(l, a);
  return l;
}
function zf(e, n, a, o) {
  if (!le(n)) return "";
  if (e === "month" || e === "agenda") return o.ym(`${n.slice(0, 7)}-01`);
  if (e === "day") return o.dayTitle(n);
  const { from: r, to: l } = na("week", n, a);
  return o.year(r) !== o.year(l) ? `${o.ymd(r)} – ${o.ymd(l)}` : r.slice(5, 7) !== l.slice(5, 7) ? `${o.ymd(r)} – ${o.md(l)}` : `${o.ymd(r)} – ${o.d(l)}`;
}
function vo(e, n) {
  const a = [], o = [];
  for (const r of e) {
    let l = -1, s = -1;
    for (let i = 0; i < n.length; i++)
      n[i] >= r.sDay && n[i] <= r.eDay && (l < 0 && (l = i), s = i);
    if (l < 0) continue;
    let c = o.findIndex((i) => i < l);
    c < 0 ? (c = o.length, o.push(s)) : o[c] = s, a.push({ item: r, col: l, span: s - l + 1, lane: c, contL: r.sDay < n[l], contR: r.eDay > n[s] });
  }
  return a;
}
function Hf(e, n, a) {
  const o = new Array(n).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) o[i]++;
  const r = Math.max(1, a), l = e.filter((c) => {
    if (c.lane < r - 1) return !0;
    if (c.lane > r - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (o[i] > r) return !1;
    return !0;
  }), s = new Array(n).fill(0);
  for (const c of l) for (let i = c.col; i < c.col + c.span; i++) s[i]++;
  return { shown: l, more: o.map((c, i) => c - s[i]) };
}
const Kf = 20;
function Gf(e, n) {
  const a = de(n), o = a + Ne, r = e.filter((d) => !Eo(d) && d.s < o && d.e > a).map((d) => ({
    item: d,
    top: Math.max(d.s, a) - a,
    bottom: Math.min(d.e, o) - a,
    col: 0,
    cols: 1,
    contTop: d.s < a,
    contBottom: d.e > o
  })).sort((d, u) => d.top - u.top || u.bottom - d.bottom);
  let l = [], s = [], c = -1;
  const i = () => {
    for (const d of l) d.cols = s.length;
    l = [], s = [];
  };
  for (const d of r) {
    d.top >= c && i();
    const u = Math.max(d.bottom, d.top + Kf);
    let m = s.findIndex((_) => _ <= d.top);
    m < 0 ? (m = s.length, s.push(u)) : s[m] = u, d.col = m, l.push(d), c = Math.max(c, u);
  }
  return i(), r;
}
function Da(e, n) {
  return Math.round(e / n) * n;
}
function Yn(e, n) {
  if (e.allDay) {
    const a = Math.round(n / Ne);
    return { start: Ee(e.sDay, a), end: Ee(e.eDay, a) };
  }
  return { start: nn(e.s + n), end: nn(e.e + n) };
}
function aa(e, n = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return n;
    const s = le(e.sDay), c = le(e.eDay);
    return `${s.m}/${s.d} – ${c.m}/${c.d}`;
  }
  const a = de(e.sDay), o = Je(e.s - a);
  if (e.sDay === e.eDay) return `${o} – ${e.e - a === Ne ? "24:00" : Je(e.e - a)}`;
  const r = le(e.sDay), l = le($t(e.e));
  return `${r.m}/${r.d} ${o} – ${l.m}/${l.d} ${Je(e.e - de($t(e.e)))}`;
}
const we = (e) => {
  const n = le(e);
  return { ...n, w: Ce(n) };
};
function Sa(e, n, a, o, r) {
  const l = `${+e.slice(0, 4)}${a}`;
  if (n === "gregorian") return l;
  const s = qf(e, { eras: o, gannen: r });
  return s ? n === "era" ? s : `${l}(${s})` : l;
}
function Uf(e = "ko", n = {}) {
  var i, d;
  const a = (i = n.year) != null ? i : e === "ja" ? "era" : "gregorian", o = (d = n.eras) != null ? d : ho, r = n.gannen !== !1;
  if (e === "ja") {
    const u = ["日", "月", "火", "水", "木", "金", "土"], m = (p) => Sa(p, a, "年", o, r), _ = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: u,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (p) => `前の${_[p]} (P)`,
      next: (p) => `次の${_[p]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (p) => `他${p}件`,
      eventCount: (p) => `予定${p}件`,
      dayOfSpan: (p, f) => `${p}/${f}日目`,
      openDay: (p) => {
        const f = we(p);
        return `${f.m}月${f.d}日を日表示`;
      },
      year: m,
      ym: (p) => `${m(p)}${we(p).m}月`,
      ymd: (p) => {
        const f = we(p);
        return `${m(p)}${f.m}月${f.d}日`;
      },
      md: (p) => {
        const f = we(p);
        return `${f.m}月${f.d}日`;
      },
      d: (p) => `${we(p).d}日`,
      m: (p) => `${we(p).m}月`,
      dayTitle: (p) => {
        const f = we(p);
        return `${m(p)}${f.m}月${f.d}日(${u[f.w]})`;
      },
      dayAria: (p) => {
        const f = we(p);
        return `${f.m}月${f.d}日 ${u[f.w]}曜日`;
      }
    };
  }
  const l = ["일", "월", "화", "수", "목", "금", "토"], s = (u) => Sa(u, a, "년", o, r), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: l,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (u) => `이전 ${c[u]} (P)`,
    next: (u) => `다음 ${c[u]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (u) => `+${u}개`,
    eventCount: (u) => `일정 ${u}건`,
    dayOfSpan: (u, m) => `${u}/${m}일째`,
    openDay: (u) => {
      const m = we(u);
      return `${m.m}월 ${m.d}일 일 보기`;
    },
    year: s,
    ym: (u) => `${s(u)} ${we(u).m}월`,
    ymd: (u) => {
      const m = we(u);
      return `${s(u)} ${m.m}월 ${m.d}일`;
    },
    md: (u) => {
      const m = we(u);
      return `${m.m}월 ${m.d}일`;
    },
    d: (u) => `${we(u).d}일`,
    m: (u) => `${we(u).m}월`,
    dayTitle: (u) => {
      const m = we(u);
      return `${s(u)} ${m.m}월 ${m.d}일 (${l[m.w]})`;
    },
    dayAria: (u) => {
      const m = we(u);
      return `${m.m}월 ${m.d}일 ${l[m.w]}요일`;
    }
  };
}
const wo = Uf("ko"), Yf = "_cal_1rwx2_2", Vf = "_toolbar_1rwx2_20", Jf = "_navBtns_1rwx2_28", Zf = "_title_1rwx2_29", Qf = "_toolRight_1rwx2_36", e1 = "_toggle_1rwx2_37", t1 = "_body_1rwx2_58", n1 = "_busy_1rwx2_59", a1 = "_sun_1rwx2_71", o1 = "_sat_1rwx2_72", r1 = "_tAccent_1rwx2_75", l1 = "_tOk_1rwx2_76", s1 = "_tWarn_1rwx2_77", c1 = "_tDanger_1rwx2_78", i1 = "_tViolet_1rwx2_79", u1 = "_tGray_1rwx2_80", m1 = "_month_1rwx2_83", d1 = "_mHead_1rwx2_84", _1 = "_wdName_1rwx2_85", p1 = "_mBody_1rwx2_91", f1 = "_mWeek_1rwx2_92", y1 = "_mCells_1rwx2_94", h1 = "_cell_1rwx2_96", b1 = "_out_1rwx2_104", E1 = "_dayNum_1rwx2_105", g1 = "_creatable_1rwx2_106", v1 = "_selDay_1rwx2_109", w1 = "_cellHead_1rwx2_111", k1 = "_isToday_1rwx2_124", N1 = "_holiday_1rwx2_125", $1 = "_addHint_1rwx2_130", x1 = "_barLayer_1rwx2_138", C1 = "_chip_1rwx2_139", D1 = "_more_1rwx2_139", S1 = "_tEv_1rwx2_155", B1 = "_aRow_1rwx2_155", A1 = "_popItem_1rwx2_155", M1 = "_bar_1rwx2_138", T1 = "_contL_1rwx2_165", L1 = "_contR_1rwx2_166", j1 = "_dotChip_1rwx2_167", I1 = "_dot_1rwx2_167", R1 = "_chipTime_1rwx2_170", F1 = "_chipTitle_1rwx2_171", q1 = "_movable_1rwx2_173", P1 = "_ghost_1rwx2_176", X1 = "_time_1rwx2_189", O1 = "_tHead_1rwx2_190", W1 = "_tAllDay_1rwx2_190", z1 = "_gutter_1rwx2_193", H1 = "_tHeadDays_1rwx2_197", K1 = "_tAllDayCells_1rwx2_197", G1 = "_tDay_1rwx2_198", U1 = "_tDayBtn_1rwx2_202", Y1 = "_tWd_1rwx2_206", V1 = "_tDayNum_1rwx2_208", J1 = "_tAllDayRow_1rwx2_216", Z1 = "_allDayCell_1rwx2_218", Q1 = "_tBody_1rwx2_222", ey = "_tGrid_1rwx2_223", ty = "_tGutter_1rwx2_224", ny = "_tCols_1rwx2_230", ay = "_tCol_1rwx2_230", oy = "_tSel_1rwx2_238", ry = "_tEvTitle_1rwx2_258", ly = "_tEvTime_1rwx2_259", sy = "_tEvShort_1rwx2_261", cy = "_contTop_1rwx2_263", iy = "_contBottom_1rwx2_264", uy = "_resize_1rwx2_265", my = "_now_1rwx2_268", dy = "_agenda_1rwx2_272", _y = "_aDay_1rwx2_273", py = "_aDate_1rwx2_275", fy = "_aDateBtn_1rwx2_276", yy = "_aDayNum_1rwx2_280", hy = "_aDayWd_1rwx2_286", by = "_aList_1rwx2_288", Ey = "_aTime_1rwx2_295", gy = "_aTitle_1rwx2_296", vy = "_aSpan_1rwx2_297", wy = "_aLoc_1rwx2_298", ky = "_empty_1rwx2_303", Ny = "_pop_1rwx2_155", $y = "_popHead_1rwx2_321", xy = "_popDay_1rwx2_322", Cy = "_popClose_1rwx2_329", Dy = "_popList_1rwx2_334", w = {
  cal: Yf,
  toolbar: Vf,
  navBtns: Jf,
  title: Zf,
  toolRight: Qf,
  toggle: e1,
  body: t1,
  busy: n1,
  sun: a1,
  sat: o1,
  tAccent: r1,
  tOk: l1,
  tWarn: s1,
  tDanger: c1,
  tViolet: i1,
  tGray: u1,
  month: m1,
  mHead: d1,
  wdName: _1,
  mBody: p1,
  mWeek: f1,
  mCells: y1,
  cell: h1,
  out: b1,
  dayNum: E1,
  creatable: g1,
  selDay: v1,
  cellHead: w1,
  isToday: k1,
  holiday: N1,
  addHint: $1,
  barLayer: x1,
  chip: C1,
  more: D1,
  tEv: S1,
  aRow: B1,
  popItem: A1,
  bar: M1,
  contL: T1,
  contR: L1,
  dotChip: j1,
  dot: I1,
  chipTime: R1,
  chipTitle: F1,
  movable: q1,
  ghost: P1,
  time: X1,
  tHead: O1,
  tAllDay: W1,
  gutter: z1,
  tHeadDays: H1,
  tAllDayCells: K1,
  tDay: G1,
  tDayBtn: U1,
  tWd: Y1,
  tDayNum: V1,
  tAllDayRow: J1,
  allDayCell: Z1,
  tBody: Q1,
  tGrid: ey,
  tGutter: ty,
  tCols: ny,
  tCol: ay,
  tSel: oy,
  tEvTitle: ry,
  tEvTime: ly,
  tEvShort: sy,
  contTop: cy,
  contBottom: iy,
  resize: uy,
  now: my,
  agenda: dy,
  aDay: _y,
  aDate: py,
  aDateBtn: fy,
  aDayNum: yy,
  aDayWd: hy,
  aList: by,
  aTime: Ey,
  aTitle: gy,
  aSpan: vy,
  aLoc: wy,
  empty: ky,
  pop: Ny,
  popHead: $y,
  popDay: xy,
  popClose: Cy,
  popList: Dy
}, $n = 22, Sy = {
  accent: w.tAccent,
  ok: w.tOk,
  warn: w.tWarn,
  danger: w.tDanger,
  violet: w.tViolet,
  gray: w.tGray
};
function An(e) {
  var n;
  return e.color ? "" : Sy[(n = e.tone) != null ? n : "accent"];
}
function Mn(e) {
  if (e.color)
    return { "--ev": e.color };
}
function ko(e, n) {
  return [e.ev.title, aa(e, n.allDay), e.ev.location].filter(Boolean).join(", ");
}
const an = (e, n) => !!e.onEventChange && !n.locked;
function gn(e, n, a) {
  var o;
  for (const r of document.elementsFromPoint(e, n)) {
    const l = (o = r.closest) == null ? void 0 : o.call(r, `[${a}]`);
    if (l) return l;
  }
  return null;
}
function xn(e, n) {
  const a = e.clientX, o = e.clientY;
  let r = !1;
  const l = (u) => {
    !r && Math.hypot(u.clientX - a, u.clientY - o) < 4 || (r = !0, n.move(u));
  }, s = () => {
    window.removeEventListener("pointermove", l), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", d, !0);
  }, c = (u) => {
    s(), n.end(u, r);
  }, i = () => {
    s(), n.cancel();
  }, d = (u) => {
    u.key === "Escape" && (u.preventDefault(), u.stopPropagation(), i());
  };
  window.addEventListener("pointermove", l), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", d, !0);
}
function No(e) {
  const [n, a] = x(null), [o, r] = x(null), l = I(!1);
  return { preview: n, items: (m, _) => Sn(e.events, m, _, n), onItemDown: (m, _) => {
    var y;
    if (m.button !== 0 || !an(e, _.ev)) return;
    const p = (y = gn(m.clientX, m.clientY, "data-cal-day")) == null ? void 0 : y.dataset.calDay;
    if (!p) return;
    l.current = !1;
    let f = 0;
    xn(m, {
      move: (E) => {
        var $;
        l.current = !0;
        const k = ($ = gn(E.clientX, E.clientY, "data-cal-day")) == null ? void 0 : $.dataset.calDay;
        k && (f = Pt(p, k), a({ id: _.ev.id, ...Yn(_, f * Ne) }));
      },
      end: (E, k) => {
        var $;
        a(null), k && f && (($ = e.onEventChange) == null || $.call(e, _.ev, Yn(_, f * Ne)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (m, _) => {
    if (m.button !== 0 || !e.onCreate) return;
    m.preventDefault();
    let p = _;
    r({ a: _, b: _ }), xn(m, {
      move: (f) => {
        var E;
        const y = (E = gn(f.clientX, f.clientY, "data-cal-day")) == null ? void 0 : E.dataset.calDay;
        y && (p = y, r({ a: _, b: y }));
      },
      end: () => {
        var E;
        r(null);
        const [f, y] = _ <= p ? [_, p] : [p, _];
        (E = e.onCreate) == null || E.call(e, { start: f, end: y, allDay: !0 });
      },
      cancel: () => r(null)
    });
  }, clickItem: (m, _) => {
    var p;
    if (l.current) {
      l.current = !1;
      return;
    }
    (p = e.onEventClick) == null || p.call(e, _, m);
  }, inSel: (m) => !!o && m >= (o.a < o.b ? o.a : o.b) && m <= (o.a < o.b ? o.b : o.a) };
}
function $o({
  segs: e,
  cols: n,
  top: a,
  ctx: o,
  drag: r
}) {
  return /* @__PURE__ */ t.createElement("div", { className: w.barLayer }, e.map((l) => {
    var m;
    const s = l.item, c = s.ev, i = Of(s), d = Je(s.s - de(s.sDay)), u = [
      w.chip,
      i ? w.bar : w.dotChip,
      An(c),
      l.contL ? w.contL : "",
      l.contR ? w.contR : "",
      ((m = r.preview) == null ? void 0 : m.id) === c.id ? w.ghost : "",
      an(o, c) ? w.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: `${c.id}:${l.col}`,
        type: "button",
        className: u,
        style: {
          left: `calc(${l.col / n * 100}% + 2px)`,
          width: `calc(${l.span / n * 100}% - 4px)`,
          top: a + l.lane * $n,
          ...Mn(c)
        },
        "aria-label": ko(s, o.L),
        onPointerDown: (_) => r.onItemDown(_, s),
        onClick: (_) => r.clickItem(_.currentTarget, c)
      },
      i ? /* @__PURE__ */ t.createElement("span", { className: w.chipTitle }, !s.allDay && !l.contL && /* @__PURE__ */ t.createElement("span", { className: w.chipTime }, d), c.title) : /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("i", { className: w.dot, "aria-hidden": !0 }), /* @__PURE__ */ t.createElement("span", { className: w.chipTime }, d), /* @__PURE__ */ t.createElement("span", { className: w.chipTitle }, c.title))
    );
  }));
}
const qn = 26;
function By({ ctx: e }) {
  const { L: n, cursor: a, today: o, weekStartsOn: r, showWeekends: l, holidays: s } = e, c = a.slice(0, 7), i = Fe(
    () => go(a, r).map((g) => l ? g : g.filter((h) => !ln(h))),
    [a, r, l]
  ), d = i[0].length, u = No(e), m = u.items(i[0][0], i[i.length - 1][d - 1]), _ = I(null), [p, f] = x(0);
  ht(() => {
    const g = _.current;
    if (!g) return;
    const h = () => f(g.clientHeight / i.length);
    if (h(), typeof ResizeObserver == "undefined") return;
    const v = new ResizeObserver(h);
    return v.observe(g), () => v.disconnect();
  }, [i.length]);
  const y = p ? Math.max(1, Math.floor((p - qn - 4) / $n)) : 3, E = I(!1), k = I(null);
  G(() => {
    var g, h;
    E.current && (E.current = !1, (h = (g = k.current) == null ? void 0 : g.querySelector(`[data-cal-day="${a}"]`)) == null || h.focus());
  }, [a, c]);
  const $ = (g, h) => {
    let v = Ee(g, h);
    for (; !l && ln(v); ) v = Ee(v, h > 0 ? 1 : -1);
    return v;
  }, S = (g, h, v) => {
    let b = null;
    if (g.key === "ArrowLeft") b = $(h, -1);
    else if (g.key === "ArrowRight") b = $(h, 1);
    else if (g.key === "ArrowUp") b = $(h, -7);
    else if (g.key === "ArrowDown") b = $(h, 7);
    else if (g.key === "Home") b = v[0];
    else if (g.key === "End") b = v[v.length - 1];
    else if (g.key === "Enter" || g.key === " ") {
      g.preventDefault(), e.goto("day", h);
      return;
    }
    b && (g.preventDefault(), E.current = !0, e.setCursor(b));
  };
  return /* @__PURE__ */ t.createElement("div", { className: w.month, role: "grid", "aria-label": n.ym(`${c}-01`), ref: k }, /* @__PURE__ */ t.createElement("div", { className: w.mHead, role: "row" }, i[0].map((g) => {
    const h = Ce(le(g));
    return /* @__PURE__ */ t.createElement("div", { key: g, role: "columnheader", className: [w.wdName, h === 0 ? w.sun : "", h === 6 ? w.sat : ""].join(" ") }, n.weekdays[h]);
  })), /* @__PURE__ */ t.createElement("div", { className: w.mBody, ref: _ }, i.map((g) => {
    const { shown: h, more: v } = Hf(vo(m, g), d, y);
    return /* @__PURE__ */ t.createElement("div", { key: g[0], className: w.mWeek, role: "row" }, /* @__PURE__ */ t.createElement("div", { className: w.mCells, style: { gridTemplateColumns: `repeat(${d}, minmax(0, 1fr))` } }, g.map((b) => {
      const C = le(b), B = Ce(C), A = s[b], T = m.filter((F) => F.sDay <= b && F.eDay >= b).length, R = [
        w.cell,
        b.slice(0, 7) !== c ? w.out : "",
        B === 0 || A ? w.sun : B === 6 ? w.sat : "",
        b === o ? w.isToday : "",
        u.inSel(b) ? w.selDay : "",
        e.onCreate ? w.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ t.createElement(
        "div",
        {
          key: b,
          role: "gridcell",
          "data-cal-day": b,
          tabIndex: b === a ? 0 : -1,
          "aria-selected": b === a,
          "aria-current": b === o ? "date" : void 0,
          "aria-label": `${n.dayAria(b)}${A ? ` ${A}` : ""}, ${n.eventCount(T)}`,
          className: R,
          onPointerDown: (F) => u.onCellDown(F, b),
          onKeyDown: (F) => S(F, b, g)
        },
        /* @__PURE__ */ t.createElement("div", { className: w.cellHead }, /* @__PURE__ */ t.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: w.dayNum,
            "aria-label": n.openDay(b),
            onPointerDown: (F) => F.stopPropagation(),
            onClick: () => e.goto("day", b)
          },
          C.d === 1 ? n.md(b) : C.d
        ), A && /* @__PURE__ */ t.createElement("span", { className: w.holiday, title: A }, A), e.onCreate && /* @__PURE__ */ t.createElement("span", { className: w.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ t.createElement($o, { segs: h, cols: d, top: qn, ctx: e, drag: u }), v.map((b, C) => b > 0 ? /* @__PURE__ */ t.createElement(
      "button",
      {
        key: g[C],
        type: "button",
        className: w.more,
        style: {
          left: `calc(${C / d * 100}% + 2px)`,
          width: `calc(${100 / d}% - 4px)`,
          top: qn + (y - 1) * $n
        },
        onClick: (B) => e.openMore(g[C], B.currentTarget)
      },
      n.more(b)
    ) : null));
  })));
}
const Ve = 44, Ay = Array.from({ length: 23 }, (e, n) => n + 1);
function Ba() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function Pn(e, n) {
  const a = n.getBoundingClientRect();
  return Math.max(0, Math.min(Ne, (e - a.top) / Ve * 60));
}
function Aa({ ctx: e, days: n }) {
  const a = n.length, o = e.slotMinutes, r = No(e), [l, s] = x(null), [c, i] = x(null), d = I(!1), u = Sn(e.events, n[0], n[a - 1], l != null ? l : r.preview), m = vo(u.filter(Eo), n), _ = m.reduce((h, v) => Math.max(h, v.lane + 1), 0), p = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [f, y] = x(Ba);
  G(() => {
    const h = window.setInterval(() => y(Ba()), 6e4);
    return () => window.clearInterval(h);
  }, []);
  const E = I(null), k = n.includes(e.today);
  ht(() => {
    const h = E.current;
    if (!h) return;
    const v = k ? Math.max(0, Math.floor((f - de(e.today)) / 60) - 1) : e.scrollToHour;
    h.scrollTop = v * Ve;
  }, [n[0], a]);
  const $ = (h, v) => {
    if (h.button !== 0 || !e.onCreate) return;
    h.preventDefault();
    const b = h.currentTarget, C = Math.min(Ne - o, Math.floor(Pn(h.clientY, b) / o) * o);
    let B = C;
    i({ day: v, a: C, b: C + o }), xn(h, {
      move: (A) => {
        B = Math.min(Ne - o, Math.floor(Pn(A.clientY, b) / o) * o), i({ day: v, a: Math.min(C, B), b: Math.max(C, B) + o });
      },
      end: (A, T) => {
        var P;
        i(null);
        const R = de(v), F = T ? Math.min(C, B) : C, U = T ? Math.max(C, B) + o : Math.min(C + 60, Ne);
        (P = e.onCreate) == null || P.call(e, { start: nn(R + F), end: nn(R + U), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, S = (h, v, b) => {
    if (h.stopPropagation(), h.button !== 0 || !an(e, v.ev)) return;
    const C = (T, R) => {
      const F = gn(T, R, "data-cal-col");
      return F ? de(F.dataset.calCol) + Pn(R, F) : null;
    }, B = C(h.clientX, h.clientY);
    if (B == null) return;
    d.current = !1;
    let A = null;
    xn(h, {
      move: (T) => {
        d.current = !0;
        const R = C(T.clientX, T.clientY);
        if (R != null) {
          if (b === "move") {
            const F = Da(R - B, o);
            A = F ? Yn(v, F) : null;
          } else {
            const F = Math.max(v.s + o, Da(R, o));
            A = F !== v.e ? { start: v.ev.start, end: nn(F) } : null;
          }
          s(A ? { id: v.ev.id, ...A } : null);
        }
      },
      end: (T, R) => {
        var F;
        s(null), R && A && ((F = e.onEventChange) == null || F.call(e, v.ev, A));
      },
      cancel: () => s(null)
    });
  }, g = (h, v) => {
    var b;
    if (d.current) {
      d.current = !1;
      return;
    }
    (b = e.onEventClick) == null || b.call(e, v, h);
  };
  return /* @__PURE__ */ t.createElement("div", { className: w.time }, /* @__PURE__ */ t.createElement("div", { className: w.tHead }, /* @__PURE__ */ t.createElement("div", { className: w.gutter }), /* @__PURE__ */ t.createElement("div", { className: w.tHeadDays, style: p }, n.map((h) => {
    const v = le(h), b = Ce(v), C = e.holidays[h];
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        key: h,
        className: [w.tDay, h === e.today ? w.isToday : "", b === 0 || C ? w.sun : b === 6 ? w.sat : ""].join(" ")
      },
      /* @__PURE__ */ t.createElement("button", { type: "button", className: w.tDayBtn, onClick: () => e.goto("day", h), "aria-label": e.L.openDay(h) }, /* @__PURE__ */ t.createElement("span", { className: w.tWd }, e.L.weekdays[b]), /* @__PURE__ */ t.createElement("span", { className: w.tDayNum }, v.d)),
      C && /* @__PURE__ */ t.createElement("span", { className: w.holiday, title: C }, C)
    );
  }))), /* @__PURE__ */ t.createElement("div", { className: w.tAllDay }, /* @__PURE__ */ t.createElement("div", { className: w.gutter }, e.L.allDay), /* @__PURE__ */ t.createElement("div", { className: w.tAllDayRow, style: { height: Math.max(1, _) * $n + 6 } }, /* @__PURE__ */ t.createElement("div", { className: w.tAllDayCells, style: p }, n.map((h) => /* @__PURE__ */ t.createElement(
    "div",
    {
      key: h,
      "data-cal-day": h,
      className: [w.allDayCell, r.inSel(h) ? w.selDay : "", e.onCreate ? w.creatable : ""].join(" "),
      onPointerDown: (v) => r.onCellDown(v, h)
    }
  ))), /* @__PURE__ */ t.createElement($o, { segs: m, cols: a, top: 3, ctx: e, drag: r }))), /* @__PURE__ */ t.createElement("div", { className: w.tBody, ref: E }, /* @__PURE__ */ t.createElement("div", { className: w.tGrid, style: { height: 24 * Ve } }, /* @__PURE__ */ t.createElement("div", { className: w.tGutter, "aria-hidden": !0 }, Ay.map((h) => /* @__PURE__ */ t.createElement("span", { key: h, style: { top: h * Ve } }, Je(h * 60)))), /* @__PURE__ */ t.createElement("div", { className: w.tCols, style: { ...p, backgroundSize: `100% ${Ve}px` } }, n.map((h) => {
    const v = Gf(u, h);
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        key: h,
        "data-cal-col": h,
        className: [w.tCol, h === e.today ? w.isToday : "", e.onCreate ? w.creatable : ""].join(" "),
        onPointerDown: (b) => $(b, h)
      },
      (c == null ? void 0 : c.day) === h && /* @__PURE__ */ t.createElement("div", { className: w.tSel, style: { top: c.a / 60 * Ve, height: (c.b - c.a) / 60 * Ve } }, Je(c.a), " – ", c.b === Ne ? "24:00" : Je(c.b)),
      v.map((b) => {
        const C = b.item.ev, B = (b.bottom - b.top) / 60 * Ve, A = [
          w.tEv,
          An(C),
          B < 34 ? w.tEvShort : "",
          b.contTop ? w.contTop : "",
          b.contBottom ? w.contBottom : "",
          (l == null ? void 0 : l.id) === C.id ? w.ghost : "",
          an(e, C) ? w.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ t.createElement(
          "button",
          {
            key: C.id,
            type: "button",
            className: A,
            style: {
              top: b.top / 60 * Ve,
              height: Math.max(18, B - 1),
              left: `calc(${b.col / b.cols * 100}% + 1px)`,
              width: `calc(${100 / b.cols}% - 4px)`,
              ...Mn(C)
            },
            "aria-label": ko(b.item, e.L),
            onPointerDown: (T) => S(T, b.item, "move"),
            onClick: (T) => g(T.currentTarget, C)
          },
          /* @__PURE__ */ t.createElement("span", { className: w.tEvTitle }, C.title),
          /* @__PURE__ */ t.createElement("span", { className: w.tEvTime }, aa(b.item, e.L.allDay)),
          an(e, C) && !b.contBottom && /* @__PURE__ */ t.createElement("span", { className: w.resize, "aria-hidden": !0, onPointerDown: (T) => S(T, b.item, "resize") })
        );
      }),
      h === e.today && /* @__PURE__ */ t.createElement("div", { className: w.now, style: { top: (f - de(h)) / 60 * Ve }, "aria-hidden": !0 })
    );
  })))));
}
function Ma(e, n, a) {
  return e.sDay === e.eDay ? aa(e, a) : e.allDay ? a : n === e.sDay ? `${Je(e.s - de(n))} ~` : n === e.eDay ? `~ ${Je(e.e - de(n))}` : a;
}
function My({ ctx: e }) {
  const { L: n } = e, { from: a, to: o } = na("agenda", e.cursor, e.weekStartsOn), r = Sn(e.events, a, o), l = Bn(a, o).filter((s) => e.showWeekends || !ln(s)).map((s) => {
    const c = de(s), i = (u) => Ma(u, s, "") === "" ? -1 : Math.max(u.s, c), d = r.filter((u) => u.sDay <= s && u.eDay >= s);
    return { day: s, list: d.sort((u, m) => i(u) - i(m)) };
  }).filter((s) => s.list.length > 0);
  return l.length ? /* @__PURE__ */ t.createElement("div", { className: w.agenda }, l.map(({ day: s, list: c }) => {
    const i = le(s), d = e.holidays[s], u = Ce(i), m = n.weekdays[u];
    return /* @__PURE__ */ t.createElement("section", { key: s, className: [w.aDay, s === e.today ? w.isToday : ""].join(" "), "aria-label": n.dayAria(s) }, /* @__PURE__ */ t.createElement("div", { className: [w.aDate, u === 0 || d ? w.sun : u === 6 ? w.sat : ""].join(" ") }, /* @__PURE__ */ t.createElement("button", { type: "button", className: w.aDateBtn, onClick: () => e.goto("day", s) }, /* @__PURE__ */ t.createElement("span", { className: w.aDayNum }, i.d), /* @__PURE__ */ t.createElement("span", { className: w.aDayWd }, n.m(s), " · ", m)), d && /* @__PURE__ */ t.createElement("span", { className: w.holiday }, d)), /* @__PURE__ */ t.createElement("ul", { className: w.aList }, c.map((_) => {
      const p = _.ev, f = Pt(_.sDay, _.eDay) + 1;
      return /* @__PURE__ */ t.createElement("li", { key: p.id }, /* @__PURE__ */ t.createElement(
        "button",
        {
          type: "button",
          className: [w.aRow, An(p)].join(" "),
          style: Mn(p),
          onClick: (y) => {
            var E;
            return (E = e.onEventClick) == null ? void 0 : E.call(e, p, y.currentTarget);
          }
        },
        /* @__PURE__ */ t.createElement("i", { className: w.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ t.createElement("span", { className: w.aTime }, Ma(_, s, n.allDay)),
        /* @__PURE__ */ t.createElement("span", { className: w.aTitle }, p.title, f > 1 && /* @__PURE__ */ t.createElement("em", { className: w.aSpan }, n.dayOfSpan(Pt(_.sDay, s) + 1, f))),
        p.location && /* @__PURE__ */ t.createElement("span", { className: w.aLoc }, p.location)
      ));
    })));
  })) : /* @__PURE__ */ t.createElement("div", { className: w.empty }, n.empty);
}
const Xn = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function Ta(e, n, a) {
  const [o, r] = x(n), l = e !== void 0 ? e : o;
  return [l, (c) => {
    e === void 0 && r(c), c !== l && (a == null || a(c));
  }];
}
const La = ({ dir: e }) => /* @__PURE__ */ t.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ t.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function p0({
  events: e,
  view: n,
  defaultView: a,
  onViewChange: o,
  date: r,
  defaultDate: l,
  onDateChange: s,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: d = !0,
  weekendToggle: u = !0,
  holidays: m,
  slotMinutes: _ = 30,
  scrollToHour: p = 8,
  onRangeChange: f,
  onEventClick: y,
  onCreate: E,
  onEventChange: k,
  locale: $ = wo,
  loading: S,
  headerExtra: g,
  className: h = "",
  style: v,
  "aria-label": b
}) {
  var ue;
  const C = yo(), [B, A] = Ta(n, (ue = a != null ? a : c[0]) != null ? ue : "month", o), [T, R] = Ta(r, l != null ? l : C, s), F = le(T) ? T : C, [U, P] = x(d), [M, j] = x(null), te = I(null), Z = I(!1);
  G(() => {
    var L;
    if (!Z.current) return;
    Z.current = !1;
    const O = te.current;
    !O || O.contains(document.activeElement) || ((L = O.querySelector('[data-cal-day][tabindex="0"]')) != null ? L : O).focus();
  });
  const { from: J, to: se } = na(B, F, i), oe = I(f);
  oe.current = f, G(() => {
    var O;
    (O = oe.current) == null || O.call(oe, { from: J, to: se, view: B });
  }, [J, se, B]);
  const $e = (O, L) => {
    R(L), c.includes(O) && A(O);
  }, D = {
    events: e,
    L: $,
    cursor: F,
    today: C,
    weekStartsOn: i,
    showWeekends: U,
    holidays: m != null ? m : {},
    slotMinutes: _,
    scrollToHour: p,
    setCursor: R,
    goto: $e,
    openMore: (O, L) => j({ day: O, anchor: L }),
    onEventClick: y,
    onCreate: E,
    onEventChange: k
  }, z = (O) => R(Wf(B, F, O, B === "day" && !U)), H = (O) => {
    if (O.defaultPrevented || O.ctrlKey || O.metaKey || O.altKey || O.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const L = O.nativeEvent.code;
    if (L === "KeyT") R(C);
    else if (L === "KeyN" || L === "KeyJ" || O.key === "PageDown") z(1);
    else if (L === "KeyP" || L === "KeyK" || O.key === "PageUp") z(-1);
    else if (Xn[L] && c.includes(Xn[L])) A(Xn[L]);
    else if (L === "KeyC" && E)
      E(B === "month" || B === "agenda" ? { start: F, end: F, allDay: !0 } : { start: `${F}T09:00`, end: `${F}T10:00`, allDay: !1 });
    else return;
    O.preventDefault(), Z.current = !0;
  }, V = Fe(
    () => Bn(J, se).filter((O) => U || !ln(O)),
    [J, se, U]
  );
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [w.cal, h].filter(Boolean).join(" "),
      style: v,
      role: "region",
      "aria-label": b != null ? b : $.region,
      "aria-busy": S || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: H,
      ref: te,
      tabIndex: -1
    },
    /* @__PURE__ */ t.createElement("div", { className: w.toolbar }, /* @__PURE__ */ t.createElement(Ft, { onClick: () => R(C), title: `${$.today} (T)` }, $.today), /* @__PURE__ */ t.createElement("span", { className: w.navBtns }, /* @__PURE__ */ t.createElement(Un, { label: $.prev(B), onClick: () => z(-1) }, /* @__PURE__ */ t.createElement(La, { dir: "l" })), /* @__PURE__ */ t.createElement(Un, { label: $.next(B), onClick: () => z(1) }, /* @__PURE__ */ t.createElement(La, { dir: "r" }))), /* @__PURE__ */ t.createElement("h2", { className: w.title, "aria-live": "polite" }, zf(B, F, i, $)), /* @__PURE__ */ t.createElement("span", { className: w.toolRight }, g, u && B !== "day" && /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: w.toggle,
        "aria-pressed": !U,
        onClick: () => P((O) => !O)
      },
      $.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ t.createElement(
      mo,
      {
        variant: "segmented",
        "aria-label": $.viewTabs,
        items: c.map((O) => ({ key: O, label: $.views[O] })),
        value: B,
        onChange: (O) => A(O)
      }
    ))),
    /* @__PURE__ */ t.createElement("div", { className: w.body }, S && /* @__PURE__ */ t.createElement("div", { className: w.busy, role: "progressbar", "aria-label": $.loading }), B === "month" && /* @__PURE__ */ t.createElement(By, { ctx: D }), B === "week" && /* @__PURE__ */ t.createElement(Aa, { ctx: D, days: V }), B === "day" && /* @__PURE__ */ t.createElement(Aa, { ctx: D, days: [F] }), B === "agenda" && /* @__PURE__ */ t.createElement(My, { ctx: D })),
    M && /* @__PURE__ */ t.createElement(Ty, { ctx: D, day: M.day, anchor: M.anchor, onClose: () => j(null) })
  );
}
function Ty({ ctx: e, day: n, anchor: a, onClose: o }) {
  const r = I(null), [l, s] = x({ top: -9999, left: -9999 }), c = le(n), i = Sn(e.events, n, n);
  return ht(() => {
    var p;
    const d = r.current;
    if (!d) return;
    const u = a.getBoundingClientRect(), m = d.offsetWidth, _ = d.offsetHeight;
    s({
      left: Math.max(8, Math.min(u.left + u.width / 2 - m / 2, window.innerWidth - m - 8)),
      top: Math.max(8, Math.min(u.top - 60, window.innerHeight - _ - 8))
    }), (p = d.querySelector("[data-cal-pop-item]")) == null || p.focus();
  }, [a]), G(() => {
    const d = () => {
      o(), a.isConnected && a.focus();
    }, u = (_) => {
      var p;
      (p = r.current) != null && p.contains(_.target) || o();
    }, m = (_) => {
      _.key === "Escape" && (_.preventDefault(), d());
    };
    return document.addEventListener("mousedown", u), document.addEventListener("keydown", m), () => {
      document.removeEventListener("mousedown", u), document.removeEventListener("keydown", m);
    };
  }, [a, o]), /* @__PURE__ */ t.createElement(Wt, null, /* @__PURE__ */ t.createElement("div", { ref: r, className: w.pop, style: l, role: "dialog", "aria-label": `${e.L.md(n)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ t.createElement("div", { className: w.popHead }, /* @__PURE__ */ t.createElement("button", { type: "button", className: w.popDay, onClick: () => {
    o(), e.goto("day", n);
  } }, /* @__PURE__ */ t.createElement("span", null, e.L.weekdays[Ce(c)]), /* @__PURE__ */ t.createElement("b", null, c.d)), /* @__PURE__ */ t.createElement("button", { type: "button", className: w.popClose, "aria-label": e.L.close, onClick: o }, "✕")), /* @__PURE__ */ t.createElement("ul", { className: w.popList }, i.map((d) => {
    const u = d.ev, m = d.allDay || d.sDay !== d.eDay;
    return /* @__PURE__ */ t.createElement("li", { key: u.id }, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [w.popItem, m ? w.bar : w.dotChip, An(u)].join(" "),
        style: Mn(u),
        onClick: () => {
          var _;
          o(), (_ = e.onEventClick) == null || _.call(e, u, a);
        }
      },
      !m && /* @__PURE__ */ t.createElement("i", { className: w.dot, "aria-hidden": !0 }),
      !d.allDay && /* @__PURE__ */ t.createElement("span", { className: w.chipTime }, Je(Math.max(d.s, de(n)) - de(n))),
      /* @__PURE__ */ t.createElement("span", { className: w.chipTitle }, u.title)
    ));
  }))));
}
const Ly = "_mini_q7p5n_3", jy = "_nav_q7p5n_5", Iy = "_navBtn_q7p5n_6", Ry = "_todayBtn_q7p5n_6", Fy = "_title_q7p5n_6", qy = "_day_q7p5n_25", Py = "_mon_q7p5n_25", Xy = "_grid_q7p5n_29", Oy = "_wdRow_q7p5n_30", Wy = "_row_q7p5n_30", zy = "_sun_q7p5n_35", Hy = "_sat_q7p5n_36", Ky = "_num_q7p5n_45", Gy = "_sel_q7p5n_46", Uy = "_out_q7p5n_50", Yy = "_isToday_q7p5n_52", Vy = "_dots_q7p5n_55", Jy = "_months_q7p5n_59", Q = {
  mini: Ly,
  nav: jy,
  navBtn: Iy,
  todayBtn: Ry,
  title: Fy,
  day: qy,
  mon: Py,
  grid: Xy,
  wdRow: Oy,
  row: Wy,
  sun: zy,
  sat: Hy,
  num: Ky,
  sel: Gy,
  out: Uy,
  isToday: Yy,
  dots: Vy,
  months: Jy
}, ja = (e, n) => `${String(e).padStart(4, "0")}-${String(n).padStart(2, "0")}`;
function f0({
  month: e,
  onMonthChange: n,
  value: a,
  onPick: o,
  marks: r = {},
  markLabel: l,
  holidays: s = {},
  weekStartsOn: c = 0,
  locale: i = wo,
  today: d,
  children: u,
  className: m = "",
  "aria-label": _
}) {
  const p = d != null ? d : yo(), f = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${p.slice(0, 7)}-01`, y = le(f), E = Nn(f, c), k = Bn(E, Ee(E, 41)), $ = l != null ? l : i.eventCount, [S, g] = x("day"), [h, v] = x(y.y), b = (M) => !!M && M.slice(0, 7) === f.slice(0, 7), [C, B] = x(() => b(a) ? a : b(p) ? p : f);
  G(() => {
    b(C) || B(b(a) ? a : b(p) ? p : f);
  }, [f]);
  const A = I(!1), T = I(null);
  G(() => {
    var M, j;
    A.current && (A.current = !1, (j = (M = T.current) == null ? void 0 : M.querySelector(`[data-day="${C}"]`)) == null || j.focus());
  }, [C, f]);
  const R = (M) => {
    A.current = !0, B(M), b(M) || n(M.slice(0, 7));
  }, F = (M) => {
    const j = yt(y, M);
    n(ja(j.y, j.m));
  }, U = (M, j) => {
    const te = le(j), Z = (Ce(te) - c + 7) % 7;
    let J = null;
    if (M.key === "ArrowLeft") J = Ee(j, -1);
    else if (M.key === "ArrowRight") J = Ee(j, 1);
    else if (M.key === "ArrowUp") J = Ee(j, -7);
    else if (M.key === "ArrowDown") J = Ee(j, 7);
    else if (M.key === "Home") J = Ee(j, -Z);
    else if (M.key === "End") J = Ee(j, 6 - Z);
    else if (M.key === "PageUp" || M.key === "PageDown") {
      const se = yt(te, M.key === "PageUp" ? -1 : 1);
      J = We(se.y, se.m, se.d);
    }
    J && (M.preventDefault(), R(J));
  }, P = () => {
    v(y.y), g("month");
  };
  return /* @__PURE__ */ t.createElement("div", { className: [Q.mini, m].filter(Boolean).join(" "), role: _ ? "group" : void 0, "aria-label": _ }, S === "day" ? /* @__PURE__ */ t.createElement("div", { className: Q.nav }, /* @__PURE__ */ t.createElement("button", { type: "button", className: Q.navBtn, "aria-label": i.prevMonth, onClick: () => F(-1) }, "‹"), /* @__PURE__ */ t.createElement("button", { type: "button", className: Q.title, "aria-label": `${i.ym(f)}, ${i.pickMonth}`, "aria-live": "polite", onClick: P }, i.ym(f)), /* @__PURE__ */ t.createElement("button", { type: "button", className: Q.navBtn, "aria-label": i.nextMonth, onClick: () => F(1) }, "›"), /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Q.todayBtn,
      disabled: b(p),
      onClick: () => {
        n(p.slice(0, 7)), R(p);
      }
    },
    i.today
  )) : /* @__PURE__ */ t.createElement("div", { className: Q.nav }, /* @__PURE__ */ t.createElement("button", { type: "button", className: Q.navBtn, "aria-label": i.prevYear, onClick: () => v((M) => M - 1) }, "‹"), /* @__PURE__ */ t.createElement("span", { className: Q.title, "aria-live": "polite" }, i.year(`${h}-12-31`)), /* @__PURE__ */ t.createElement("button", { type: "button", className: Q.navBtn, "aria-label": i.nextYear, onClick: () => v((M) => M + 1) }, "›"), /* @__PURE__ */ t.createElement("button", { type: "button", className: Q.todayBtn, onClick: () => g("day"), "aria-label": i.close }, "✕")), S === "month" ? /* @__PURE__ */ t.createElement("div", { className: Q.months, onKeyDown: (M) => {
    M.key === "Escape" && (M.preventDefault(), g("day"));
  } }, Array.from({ length: 12 }, (M, j) => {
    const te = ja(h, j + 1), Z = te === f.slice(0, 7);
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: te,
        type: "button",
        className: [Q.mon, Z ? Q.sel : "", te === p.slice(0, 7) ? Q.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": Z,
        autoFocus: Z,
        onClick: () => {
          n(te), g("day");
        }
      },
      i.m(`${te}-01`)
    );
  })) : /* @__PURE__ */ t.createElement("div", { className: Q.grid, role: "grid", "aria-label": i.ym(f), ref: T }, /* @__PURE__ */ t.createElement("div", { className: Q.wdRow, role: "row" }, k.slice(0, 7).map((M) => {
    const j = Ce(le(M));
    return /* @__PURE__ */ t.createElement("span", { key: M, role: "columnheader", className: j === 0 ? Q.sun : j === 6 ? Q.sat : "" }, i.weekdays[j]);
  })), [0, 1, 2, 3, 4, 5].map((M) => /* @__PURE__ */ t.createElement("div", { key: M, className: Q.row, role: "row" }, k.slice(M * 7, M * 7 + 7).map((j) => {
    var oe;
    const te = Ce(le(j)), Z = s[j], J = (oe = r[j]) != null ? oe : 0, se = [
      Q.day,
      b(j) ? "" : Q.out,
      te === 0 || Z ? Q.sun : te === 6 ? Q.sat : "",
      j === p ? Q.isToday : "",
      j === a ? Q.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: j,
        type: "button",
        role: "gridcell",
        "data-day": j,
        className: se,
        tabIndex: j === C ? 0 : -1,
        "aria-selected": j === a,
        "aria-current": j === p ? "date" : void 0,
        "aria-label": [i.dayAria(j), Z, J ? $(J) : ""].filter(Boolean).join(", "),
        onKeyDown: ($e) => U($e, j),
        onFocus: () => B(j),
        onClick: () => o(j)
      },
      /* @__PURE__ */ t.createElement("span", { className: Q.num }, +j.slice(8)),
      /* @__PURE__ */ t.createElement("span", { className: Q.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(J, 3) }, ($e, D) => /* @__PURE__ */ t.createElement("i", { key: D })))
    );
  })))), u);
}
function Zy(e) {
  return e.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function Qy(e) {
  return e.replace(/[０-９]/g, (n) => String.fromCharCode(n.charCodeAt(0) - 65248)).replace(/[－ー−]/g, "-").replace(/，/g, ",").replace(/．/g, ".");
}
function xo(e, n = !0) {
  e = Qy(e);
  const a = n && /^\s*-/.test(e), o = e.split(".", 1)[0].replace(/[^\d]/g, "");
  return o ? (a ? "-" : "") + o.replace(/^0+(?=\d)/, "") : a ? "-" : "";
}
function eh(e) {
  var o;
  if (e == null || e === "") return "";
  const n = typeof e == "number" ? String(e) : e.trim(), a = /^(-?)(\d+)(\.\d+)?$/.exec(n);
  return a ? a[1] + Zy(a[2]) + ((o = a[3]) != null ? o : "") : n;
}
function th(e) {
  const n = xo(e);
  if (n === "" || n === "-") return;
  const a = Number(n);
  return Number.isFinite(a) ? a : void 0;
}
function nh(e) {
  const n = e.match(/\d/g);
  return n ? n.length : 0;
}
function y0({
  value: e,
  onChangeAm: n,
  allowNegative: a = !0,
  className: o,
  ...r
}) {
  const l = I(null), s = I(null);
  return ht(() => {
    const c = l.current, i = s.current;
    if (s.current = null, !c || i === null) return;
    let d = 0, u = 0;
    for (; d < c.value.length && u < i; )
      /\d/.test(c.value[d]) && (u += 1), d += 1;
    c.setSelectionRange(d, d);
  }), /* @__PURE__ */ t.createElement(
    "input",
    {
      ...r,
      ref: l,
      type: "text",
      inputMode: "numeric",
      className: o,
      value: eh(e),
      onChange: (c) => {
        var u;
        const i = c.target;
        s.current = nh(i.value.slice(0, (u = i.selectionStart) != null ? u : i.value.length));
        const d = xo(i.value, a);
        n({ text: d, num: th(d) });
      }
    }
  );
}
const ah = "_box_damu4_3", oh = "_banner_damu4_9", rh = "_verify_damu4_10", lh = "_t_info_damu4_15", sh = "_t_warn_damu4_16", ch = "_t_danger_damu4_17", ih = "_error_damu4_22", uh = "_note_damu4_30", mh = "_noteI_damu4_42", dh = "_noteBody_damu4_43", _h = "_badge_damu4_49", ph = "_b_muted_damu4_53", fh = "_b_ok_damu4_54", yh = "_b_warn_damu4_55", hh = "_b_off_damu4_56", Re = {
  box: ah,
  banner: oh,
  verify: rh,
  t_info: lh,
  t_warn: sh,
  t_danger: ch,
  error: ih,
  note: uh,
  noteI: mh,
  noteBody: dh,
  badge: _h,
  b_muted: ph,
  b_ok: fh,
  b_warn: yh,
  b_off: hh
};
function h0({ tone: e = "warn", className: n = "", children: a }) {
  return /* @__PURE__ */ t.createElement("div", { className: [Re.box, Re.banner, Re[`t_${e}`], n].filter(Boolean).join(" ") }, a);
}
function b0({ tone: e = "ok", className: n = "", children: a }) {
  const o = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ t.createElement("div", { className: [Re.box, Re.verify, Re[`t_${o}`], n].filter(Boolean).join(" ") }, a);
}
function Co({ className: e = "", children: n }) {
  return n == null || n === !1 || n === "" ? null : /* @__PURE__ */ t.createElement("p", { className: [Re.error, e].filter(Boolean).join(" "), role: "alert" }, typeof n == "string" ? /* @__PURE__ */ t.createElement(bh, { text: n }) : n);
}
function E0({ label: e = "안내", className: n = "", children: a }) {
  return /* @__PURE__ */ t.createElement("details", { className: [Re.note, n].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("summary", null, /* @__PURE__ */ t.createElement("span", { className: Re.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ t.createElement("div", { className: Re.noteBody }, a));
}
function g0({ tone: e = "muted", className: n = "", children: a }) {
  return /* @__PURE__ */ t.createElement("span", { className: ["axe-badge", Re.badge, Re[`b_${e}`], n].filter(Boolean).join(" ") }, a);
}
function bh({ text: e }) {
  return e ? /* @__PURE__ */ t.createElement(t.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((n, a) => a % 2 ? /* @__PURE__ */ t.createElement("b", { key: a }, n) : /* @__PURE__ */ t.createElement(Ja, { key: a }, n))) : null;
}
const Eh = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function gh(e, n = Eh) {
  const a = I(e);
  return a.current = e, G(() => {
    if (!e) return;
    const o = (r) => {
      r.preventDefault(), r.returnValue = "";
    };
    return window.addEventListener("beforeunload", o), () => window.removeEventListener("beforeunload", o);
  }, [e]), ee(() => !a.current || window.confirm(n), [n]);
}
const vh = "_overlay_1c9bs_2", wh = "_modal_1c9bs_7", kh = "_wide_1c9bs_14", Nh = "_head_1c9bs_15", $h = "_title_1c9bs_19", xh = "_close_1c9bs_20", Ch = "_body_1c9bs_24", Dh = "_flush_1c9bs_25", Sh = "_error_1c9bs_26", Bh = "_foot_1c9bs_28", Ue = {
  overlay: vh,
  modal: wh,
  wide: kh,
  head: Nh,
  title: $h,
  close: xh,
  body: Ch,
  flush: Dh,
  error: Sh,
  foot: Bh
}, Nt = [];
function Ia(e) {
  const n = Nt[Nt.length - 1];
  e.key !== "Escape" || !n || !n.esc || (e.preventDefault(), n.close());
}
const Ah = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Ra(e) {
  return Array.from(e.querySelectorAll(Ah)).filter((n) => n.getClientRects().length > 0 && getComputedStyle(n).visibility !== "hidden");
}
let Fa = 0, qa = "";
function Do({
  title: e,
  onClose: n,
  children: a,
  wide: o,
  footer: r,
  headerExtra: l,
  flush: s,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !1,
  error: d,
  confirmDiscard: u = !0
}) {
  const [m, _] = x(!1), p = u ? () => {
    m || _(!0);
  } : void 0, f = gh(u && m, "입력한 내용을 저장하지 않고 닫을까요?"), y = () => {
    f() && n();
  }, E = I(y);
  E.current = y;
  const k = I({ close: () => E.current(), esc: i });
  k.current.esc = i, G(() => {
    const h = k.current;
    return Nt.push(h), Nt.length === 1 && window.addEventListener("keydown", Ia), () => {
      const v = Nt.lastIndexOf(h);
      v >= 0 && Nt.splice(v, 1), Nt.length === 0 && window.removeEventListener("keydown", Ia);
    };
  }, []);
  const $ = I(null), S = I(null);
  G(() => {
    const h = $.current, v = document.activeElement;
    return h && !h.contains(document.activeElement) && (S.current && Ra(S.current)[0] || null || h).focus(), Fa++ === 0 && (qa = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Fa === 0 && (document.body.style.overflow = qa), v && v.isConnected && typeof v.focus == "function" && v.focus();
    };
  }, []);
  const g = (h) => {
    const v = $.current;
    if (h.key !== "Tab" || !v || !v.contains(h.target)) return;
    const b = Ra(v);
    if (b.length === 0) {
      h.preventDefault(), v.focus();
      return;
    }
    const C = b[0], B = b[b.length - 1], A = document.activeElement;
    h.shiftKey && (A === C || A === v) ? (h.preventDefault(), B.focus()) : !h.shiftKey && A === B && (h.preventDefault(), C.focus());
  };
  return /* @__PURE__ */ t.createElement("div", { className: Ue.overlay, onClick: c ? y : void 0 }, /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: $,
      tabIndex: -1,
      className: [Ue.modal, o ? Ue.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (h) => h.stopPropagation(),
      onKeyDown: g
    },
    /* @__PURE__ */ t.createElement("header", { className: Ue.head }, /* @__PURE__ */ t.createElement("strong", { className: Ue.title }, e), l, /* @__PURE__ */ t.createElement("button", { type: "button", className: Ue.close, onClick: y, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: S,
        className: [Ue.body, s ? Ue.flush : ""].filter(Boolean).join(" "),
        onInputCapture: p,
        onChangeCapture: p
      },
      a
    ),
    d != null && d !== !1 && d !== "" && /* @__PURE__ */ t.createElement("div", { className: Ue.error }, /* @__PURE__ */ t.createElement(Co, null, d)),
    r && /* @__PURE__ */ t.createElement("footer", { className: Ue.foot }, r)
  ));
}
function v0(e = 4e3) {
  const [n, a] = x(""), [o, r] = x(!1), l = I(void 0), s = ee((d) => {
    window.clearTimeout(l.current), r(!1), a(d), l.current = window.setTimeout(() => a(""), e);
  }, [e]), c = ee((d) => {
    window.clearTimeout(l.current), r(!0), a(d);
  }, []), i = ee(() => {
    window.clearTimeout(l.current), r(!1), a("");
  }, []);
  return [n, s, c, o, i];
}
const Mh = "_message_psco6_1", Th = "_details_psco6_2", Lh = "_warn_psco6_7", jh = "_field_psco6_8", hn = {
  message: Mh,
  details: Th,
  warn: Lh,
  field: jh
};
function w0() {
  var p, f;
  const [e, n] = x(null), [a, o] = x(""), r = I(null), l = I(null), s = I(null), c = ee((y) => new Promise((E) => {
    n({ kind: "confirm", opts: y, resolve: E });
  }), []), i = ee((y) => new Promise((E) => {
    var k, $, S, g;
    o((g = (S = y.defaultValue) != null ? S : ($ = (k = y.choices) == null ? void 0 : k[0]) == null ? void 0 : $.value) != null ? g : ""), n({ kind: "prompt", opts: y, resolve: E });
  }), []);
  G(() => {
    var y, E, k;
    e && (e.kind === "prompt" ? (y = s.current) == null || y.focus() : e.opts.danger ? (E = l.current) == null || E.focus() : (k = r.current) == null || k.focus());
  }, [e]);
  const d = (y) => {
    e && (e.kind === "confirm" ? e.resolve(y) : e.resolve(y ? a : null), n(null));
  }, u = e == null ? void 0 : e.opts, m = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), _ = e && u ? /* @__PURE__ */ t.createElement(
    Do,
    {
      title: u.title,
      onClose: () => d(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      footer: /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(Ft, { ref: l, onClick: () => d(!1) }, (p = u.cancelLabel) != null ? p : "취소"), /* @__PURE__ */ t.createElement(
        Ft,
        {
          ref: r,
          variant: u.danger ? "danger" : "primary",
          disabled: m,
          onClick: () => d(!0)
        },
        (f = u.confirmLabel) != null ? f : "확인"
      ))
    },
    u.message && /* @__PURE__ */ t.createElement("div", { className: hn.message }, u.message),
    u.details && u.details.length > 0 && /* @__PURE__ */ t.createElement("ul", { className: hn.details }, u.details.map((y, E) => /* @__PURE__ */ t.createElement("li", { key: E }, y))),
    u.irreversible && /* @__PURE__ */ t.createElement("p", { className: hn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ t.createElement("label", { className: hn.field }, /* @__PURE__ */ t.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ t.createElement("select", { ref: s, value: a, onChange: (y) => o(y.target.value) }, e.opts.choices.map((y) => /* @__PURE__ */ t.createElement("option", { key: y.value, value: y.value }, y.label))) : /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: s,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (y) => o(y.target.value),
        onKeyDown: (y) => {
          y.key === "Enter" && !m && (y.preventDefault(), d(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: _ };
}
function k0(e, n) {
  const a = n ? `${n}에 실패했습니다 — ` : "", o = e > 0 ? ` (오류 ${e})` : "";
  return a + Ih(e) + o;
}
function Ih(e) {
  return e === 0 ? "서버에 연결하지 못했습니다. 네트워크 상태를 확인한 뒤 다시 시도하세요" : e === 400 || e === 422 ? "서버가 요청 내용을 받아들이지 않았습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 필요합니다. 다시 로그인해 주세요" : e === 403 ? "이 작업을 할 권한이 없습니다. 필요하면 관리자에게 권한을 요청하세요" : e === 404 ? "요청한 자료나 기능을 찾지 못했습니다. 화면을 새로고침한 뒤 다시 시도하고, 계속되면 관리자에게 알려 주세요" : e === 409 ? "다른 곳에서 먼저 바뀌었습니다. 다시 조회한 뒤 시도하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "서버에서 처리하지 못했습니다. 잠시 후 다시 시도하고, 계속되면 관리자에게 알려 주세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
const Rh = "_section_1qksw_3", Fh = "_row_1qksw_10", qh = "_label_1qksw_15", Ph = "_value_1qksw_20", Xh = "_invalid_1qksw_41", Oh = "_help_1qksw_43", Wh = "_err_1qksw_43", zh = "_req_1qksw_47", Hh = "_opt_1qksw_48", Kh = "_sr_1qksw_49", Gh = "_ro_1qksw_10", Uh = "_readonly_1qksw_56", Yh = "_hint_1qksw_63", Vh = "_toggle_1qksw_71", Jh = "_table_1qksw_78", Zh = "_isReq_1qksw_93", ke = {
  section: Rh,
  row: Fh,
  label: qh,
  value: Ph,
  invalid: Xh,
  help: Oh,
  err: Wh,
  req: zh,
  opt: Hh,
  sr: Kh,
  ro: Gh,
  readonly: Uh,
  hint: Yh,
  toggle: Vh,
  table: Jh,
  isReq: Zh
};
let Qh = 0;
const eb = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function N0({
  label: e,
  children: n,
  hint: a,
  ro: o,
  htmlFor: r,
  required: l,
  optional: s,
  help: c,
  error: i,
  className: d = ""
}) {
  var S, g, h, v;
  const u = I(`axe-fr${++Qh}`).current, m = c ? `${u}-help` : void 0, _ = i ? `${u}-err` : void 0, p = [m, _].filter(Boolean).join(" ") || void 0, f = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let y = n;
  const E = ca.count(n) === 1 ? ca.toArray(n)[0] : null, k = zn(E) && typeof E.type != "string" && !!E.type.axeFormControl;
  if (zn(E) && (typeof E.type == "string" && eb.has(E.type) || k)) {
    const b = E, C = b.props;
    y = Qa(b, {
      id: (S = C.id) != null ? S : r,
      "aria-describedby": (g = C["aria-describedby"]) != null ? g : p,
      "aria-invalid": (h = C["aria-invalid"]) != null ? h : i ? !0 : void 0,
      "aria-required": (v = C["aria-required"]) != null ? v : l ? !0 : void 0
    });
  }
  const $ = /* @__PURE__ */ t.createElement(t.Fragment, null, e, l && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: ke.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ t.createElement("span", { className: ke.sr }, "필수")), s && /* @__PURE__ */ t.createElement("span", { className: ke.opt }, "(선택)"));
  return /* @__PURE__ */ t.createElement("div", { className: ["axe-form-row", ke.row, o ? ke.ro : "", i ? ke.invalid : "", l ? ke.isReq : "", d].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("span", { className: `axe-form-label ${ke.label}` }, r ? /* @__PURE__ */ t.createElement("label", { htmlFor: r }, $) : $, a && /* @__PURE__ */ t.createElement(Dn, { content: f, describe: !1 }, /* @__PURE__ */ t.createElement("span", { className: `axe-form-hint ${ke.hint}`, role: "img", "aria-label": `도움말: ${f}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ t.createElement("span", { className: `axe-form-value ${ke.value}` }, y, c && /* @__PURE__ */ t.createElement("span", { id: m, className: ke.help }, c), i && /* @__PURE__ */ t.createElement("span", { id: _, className: ke.err }, i)));
}
function $0({ title: e, children: n, className: a = "", variant: o = "stack" }) {
  return /* @__PURE__ */ t.createElement("section", { className: ["axe-form-section", o === "table" ? `axe-form-table ${ke.table}` : "", ke.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("h3", null, e), n);
}
function x0({ children: e }) {
  return /* @__PURE__ */ t.createElement("span", { className: ke.readonly }, e);
}
function C0({ checked: e, onChange: n, disabled: a, label: o, className: r = "" }) {
  return /* @__PURE__ */ t.createElement("label", { className: [ke.toggle, r].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (l) => n(l.target.checked) }), /* @__PURE__ */ t.createElement("span", null, o));
}
const tb = "_mono_1kw8v_2", nb = "_invalid_1kw8v_3", Pa = {
  mono: tb,
  invalid: nb
};
function ab({
  value: e,
  onChange: n,
  disabled: a,
  maxLength: o,
  placeholder: r,
  mono: l,
  invalid: s,
  multiline: c,
  rows: i = 4,
  label: d,
  id: u,
  "aria-describedby": m,
  "aria-invalid": _,
  "aria-required": p,
  className: f = ""
}) {
  const y = [l ? Pa.mono : "", s ? Pa.invalid : "", f].filter(Boolean).join(" ") || void 0, E = {
    id: u,
    className: y,
    value: e != null ? e : "",
    maxLength: o,
    placeholder: r,
    disabled: a,
    "aria-label": d,
    "aria-describedby": m,
    "aria-invalid": _ != null ? _ : s || void 0,
    "aria-required": p,
    onChange: (k) => n(k.target.value === "" ? null : k.target.value)
  };
  return c ? /* @__PURE__ */ t.createElement("textarea", { ...E, rows: i }) : /* @__PURE__ */ t.createElement("input", { type: "text", ...E });
}
ab.axeFormControl = !0;
function ob({
  value: e,
  onChange: n,
  options: a,
  allLabel: o,
  disabled: r,
  label: l,
  id: s,
  "aria-describedby": c,
  "aria-invalid": i,
  "aria-required": d,
  className: u
}) {
  return /* @__PURE__ */ t.createElement(
    "select",
    {
      id: s,
      className: u,
      value: e == null ? "" : String(e),
      disabled: r,
      "aria-label": l,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": d,
      onChange: (m) => n(m.target.value === "" ? null : Number(m.target.value))
    },
    o != null && /* @__PURE__ */ t.createElement("option", { value: "" }, o),
    (Array.isArray(a) ? a : Object.entries(a)).map(([m, _]) => /* @__PURE__ */ t.createElement("option", { key: m, value: m }, _))
  );
}
ob.axeFormControl = !0;
function D0() {
  const [e, n] = x(null), [a, o] = x(!1), [r, l] = x(!1), s = ee((u) => {
    n((m) => m === null ? m : { ...m, ...u }), l(!0);
  }, []), c = ee((u, m) => {
    n((_) => _ === null ? _ : { ..._, [u]: m }), l(!0);
  }, []), i = ee((u) => {
    n(u), o(!1), l(!1);
  }, []), d = ee((u) => {
    n(u), o(!0), l(!0);
  }, []);
  return { draft: e, isNew: a, dirty: r, set: c, patch: s, load: i, start: d };
}
function S0() {
  const e = I(!1), [n, a] = x(!1), o = ee(async (r) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await r();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [n, o];
}
const rb = "_panel_1w7xx_2", lb = "_band_1w7xx_7", sb = "_chev_1w7xx_11", cb = "_title_1w7xx_17", ib = "_note_1w7xx_19", ub = "_chip_1w7xx_21", mb = "_other_1w7xx_32", db = "_reset_1w7xx_33", _b = "_form_1w7xx_42", lt = {
  panel: rb,
  band: lb,
  chev: sb,
  title: cb,
  note: ib,
  chip: ub,
  other: mb,
  reset: db,
  form: _b
};
function B0({
  chips: e,
  onReset: n,
  open: a,
  onToggle: o,
  toggleLabel: r = "상세검색",
  title: l = "적용된 조건",
  note: s,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: d = "상세검색",
  className: u = ""
}) {
  const m = I(null);
  if (i && !a && e.length === 0) return null;
  const _ = (f, y = 0) => {
    var g, h, v;
    const E = (g = document.querySelector(`section[aria-label="${CSS.escape(d)}"]`)) != null ? g : m.current, k = E == null ? void 0 : E.querySelectorAll("button[data-chip-clear]"), $ = (v = k && ((h = k[f]) != null ? h : k[f - 1])) != null ? v : E == null ? void 0 : E.querySelector("button[aria-expanded]"), S = !document.activeElement || document.activeElement === document.body;
    $ && $ !== document.activeElement && (y === 0 || S) && $.focus(), y < 4 && setTimeout(() => _(f, y + 1), 250);
  }, p = (f) => {
    e[f].onClear(), requestAnimationFrame(() => _(f));
  };
  return /* @__PURE__ */ t.createElement("section", { className: [lt.panel, u].filter(Boolean).join(" "), "aria-label": d }, /* @__PURE__ */ t.createElement("div", { className: lt.band, ref: m }, o && /* @__PURE__ */ t.createElement("button", { type: "button", className: lt.chev, "aria-expanded": !!a, onClick: o }, /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", r), l !== null && /* @__PURE__ */ t.createElement("span", { className: lt.title, "aria-live": "polite" }, l, " ", /* @__PURE__ */ t.createElement("b", null, e.length), "개"), e.map((f, y) => {
    var E;
    return /* @__PURE__ */ t.createElement("span", { key: f.key, className: [lt.chip, f.tone === "other" ? lt.other : ""].filter(Boolean).join(" ") }, f.text, /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(E = f.label) != null ? E : typeof f.text == "string" ? f.text : "조건"} 해제`,
        onClick: () => p(y)
      },
      "✕"
    ));
  }), n && e.length > 0 && /* @__PURE__ */ t.createElement("button", { type: "button", className: lt.reset, onClick: () => {
    n(), requestAnimationFrame(() => _(0));
  } }, "초기화"), s && /* @__PURE__ */ t.createElement("span", { className: lt.note }, s)), a && c && /* @__PURE__ */ t.createElement("div", { className: lt.form }, c));
}
const pb = "_zone_1y6sp_2", fb = "_drag_1y6sp_8", yb = "_busy_1y6sp_9", hb = "_attached_1y6sp_10", bb = "_left_1y6sp_12", Eb = "_icon_1y6sp_13", gb = "_title_1y6sp_18", vb = "_desc_1y6sp_19", wb = "_right_1y6sp_20", kb = "_count_1y6sp_21", Nb = "_pick_1y6sp_22", Xe = {
  zone: pb,
  drag: fb,
  busy: yb,
  attached: hb,
  left: bb,
  icon: Eb,
  title: gb,
  desc: vb,
  right: wb,
  count: kb,
  pick: Nb
};
function A0({
  onFiles: e,
  title: n = "파일 업로드",
  desc: a,
  countText: o,
  accept: r,
  multiple: l = !0,
  disabled: s,
  attached: c,
  pickLabel: i = "파일 선택",
  className: d = ""
}) {
  const u = I(null), [m, _] = x(!1), p = (f) => {
    !f || f.length === 0 || s || e(Array.from(f));
  };
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: [Xe.zone, m ? Xe.drag : "", s ? Xe.busy : "", c ? Xe.attached : "", d].filter(Boolean).join(" "),
      onClick: () => {
        var f;
        s || (f = u.current) == null || f.click();
      },
      onDragOver: (f) => {
        f.preventDefault(), s || _(!0);
      },
      onDragLeave: () => _(!1),
      onDrop: (f) => {
        f.preventDefault(), _(!1), p(f.dataTransfer.files);
      }
    },
    /* @__PURE__ */ t.createElement("div", { className: Xe.left }, /* @__PURE__ */ t.createElement("div", { className: Xe.icon, "aria-hidden": "true" }, /* @__PURE__ */ t.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ t.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ t.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ t.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: Xe.title }, n), a && /* @__PURE__ */ t.createElement("div", { className: Xe.desc }, a))),
    /* @__PURE__ */ t.createElement("div", { className: Xe.right }, o && /* @__PURE__ */ t.createElement("span", { className: Xe.count, "aria-live": "polite" }, o), /* @__PURE__ */ t.createElement(
      "button",
      {
        type: "button",
        className: Xe.pick,
        disabled: s,
        onClick: (f) => {
          var y;
          f.stopPropagation(), (y = u.current) == null || y.click();
        }
      },
      i
    ), /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: u,
        type: "file",
        accept: r,
        multiple: l,
        hidden: !0,
        onChange: (f) => {
          p(f.target.files), f.target.value = "";
        }
      }
    ))
  );
}
function $b(e, n) {
  var l, s;
  const a = (l = e.headers.get("Content-Disposition")) != null ? l : "", o = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (o)
    try {
      return decodeURIComponent(o[1]);
    } catch {
    }
  const r = /filename="?([^";]+)"?/i.exec(a);
  return (s = r == null ? void 0 : r[1]) != null ? s : n;
}
function So(e, n) {
  const a = URL.createObjectURL(e), o = document.createElement("a");
  o.href = a, o.download = n, document.body.appendChild(o), o.click(), o.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function M0(e, n, a) {
  So(await e.blob(), a != null ? a : $b(e, n));
}
const xb = /^([△▲\-−]?)\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, Cb = /^\(\s*[¥￥]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function Db(e, n = {}) {
  var r, l;
  const a = e.trim();
  if (n.parenNegative) {
    const s = Cb.exec(a);
    if (s) return `-${s[1].replace(/,/g, "")}${(r = s[2]) != null ? r : ""}`;
  }
  const o = xb.exec(a);
  return o ? (o[1] ? "-" : "") + o[2].replace(/,/g, "") + ((l = o[3]) != null ? l : "") : null;
}
function Sb(e, n = {}) {
  const a = [];
  return e.querySelectorAll("table").forEach((o) => {
    const r = [];
    Array.from(o.rows).forEach((l) => {
      if (l.hasAttribute("data-state") || l.getAttribute("aria-hidden") === "true") return;
      const s = [];
      let c = 0;
      const i = () => {
        for (; r[c] && r[c].n > 0; )
          r[c].n -= 1, r[c].skip || s.push(""), c += 1;
      };
      Array.from(l.cells).forEach((d) => {
        i();
        const u = Ab(d), m = u ? "" : Mb(d, n), _ = Math.max(1, d.colSpan || 1), p = Math.max(1, d.rowSpan || 1);
        for (let f = 0; f < _; f += 1)
          u || s.push(f === 0 ? m : ""), r[c] = { n: p - 1, skip: u }, c += 1;
      }), i(), s.some((d) => d !== "") && a.push(s.map(Tb).join(","));
    });
  }), a.join(`\r
`);
}
function Bb(e, n) {
  const a = n.toLowerCase().endsWith(".csv") ? n : `${n}.csv`;
  So(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function Ab(e) {
  var n;
  return ((n = e.textContent) != null ? n : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function Mb(e, n) {
  var r, l, s;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let o = ((l = (r = a.innerText) != null ? r : a.textContent) != null ? l : "").replace(/\s+/g, " ").trim();
  if (!o) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (o = c.value.trim());
  }
  return o === "—" || o === "-" || o === "–" ? "" : (s = Db(o, n)) != null ? s : o;
}
function Tb(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
function T0({ target: e, fileName: n, label: a = "CSV 내려받기", disabled: o, parenNegative: r }) {
  return /* @__PURE__ */ t.createElement(
    Un,
    {
      label: a,
      disabled: o,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: () => {
        const l = e.current;
        l && Bb(Sb(l, { parenNegative: r }), typeof n == "function" ? n() : n);
      }
    },
    /* @__PURE__ */ t.createElement(vn, { name: "download", size: 14 }),
    "CSV"
  );
}
const Lb = "_card_1adld_1", jb = "_sub_1adld_2", Ib = "_state_1adld_3", Rb = "_list_1adld_7", Fb = "_row_1adld_8", qb = "_warn_1adld_20", Pb = "_danger_1adld_21", vt = {
  card: Lb,
  sub: jb,
  state: Ib,
  list: Rb,
  row: Fb,
  warn: qb,
  danger: Pb
};
function L0({
  title: e,
  sub: n,
  trailing: a,
  state: o = "ready",
  error: r,
  onRetry: l,
  loadingText: s = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ t.createElement(
    po,
    {
      flush: !0,
      className: [vt.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ t.createElement(t.Fragment, null, e, n ? /* @__PURE__ */ t.createElement("small", { className: vt.sub }, n) : null),
      trailing: a
    },
    o === "loading" && /* @__PURE__ */ t.createElement("div", { className: vt.state }, s),
    o === "error" && /* @__PURE__ */ t.createElement("div", { className: vt.state }, /* @__PURE__ */ t.createElement(Co, null, r != null ? r : "불러오지 못했습니다"), l && /* @__PURE__ */ t.createElement(ta, { onClick: l }, "다시 시도")),
    o === "ready" && /* @__PURE__ */ t.createElement("div", { className: vt.list }, c.map((d, u) => {
      var p, f;
      const m = [vt.row, d.tone ? vt[d.tone] : ""].filter(Boolean).join(" "), _ = /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", null, d.label), /* @__PURE__ */ t.createElement("strong", null, d.value, d.unit ? /* @__PURE__ */ t.createElement("small", null, d.unit) : null));
      return d.onClick ? /* @__PURE__ */ t.createElement("button", { type: "button", key: (p = d.key) != null ? p : u, className: m, onClick: d.onClick }, _) : /* @__PURE__ */ t.createElement("div", { key: (f = d.key) != null ? f : u, className: m }, _);
    }))
  );
}
const Xb = "_group_1yilh_1", Ob = "_tile_1yilh_2", Wb = "_click_1yilh_8", zb = "_ok_1yilh_11", Hb = "_warn_1yilh_12", Kb = "_danger_1yilh_13", Gb = "_info_1yilh_14", Ub = "_accent_1yilh_15", Yb = "_label_1yilh_16", Vb = "_value_1yilh_18", Jb = "_desc_1yilh_20", wt = {
  group: Xb,
  tile: Ob,
  click: Wb,
  ok: zb,
  warn: Hb,
  danger: Kb,
  info: Gb,
  accent: Ub,
  label: Yb,
  value: Vb,
  desc: Jb
};
function j0({
  label: e,
  value: n,
  unit: a,
  desc: o,
  tone: r = "info",
  onClick: l,
  className: s = ""
}) {
  const c = [wt.tile, wt[r], l ? wt.click : "", s].filter(Boolean).join(" "), i = /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: wt.label }, /* @__PURE__ */ t.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ t.createElement("span", { className: wt.value }, n, a ? /* @__PURE__ */ t.createElement("small", null, a) : null), o ? /* @__PURE__ */ t.createElement("span", { className: wt.desc }, o) : null);
  return l ? /* @__PURE__ */ t.createElement("button", { type: "button", className: c, onClick: l }, i) : /* @__PURE__ */ t.createElement("div", { className: c }, i);
}
function I0({ children: e, className: n = "" }) {
  return /* @__PURE__ */ t.createElement("div", { className: [wt.group, n].filter(Boolean).join(" ") }, e);
}
const Zb = "_card_1lav2_1", Qb = "_n_1lav2_2", eE = "_list_1lav2_7", tE = "_row_1lav2_8", nE = "_go_1lav2_15", aE = "_name_1lav2_16", oE = "_empty_1lav2_17", rE = "_star_1lav2_18", lE = "_clear_1lav2_27", Ye = {
  card: Zb,
  n: Qb,
  list: eE,
  row: tE,
  go: nE,
  name: aE,
  empty: oE,
  star: rE,
  clear: lE
};
function R0({
  mine: e,
  recent: n,
  onOpen: a,
  onClearRecent: o,
  mineHint: r = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: l = ""
}) {
  const [s, c] = x("mine"), i = s === "mine" ? e : n;
  return /* @__PURE__ */ t.createElement(
    po,
    {
      flush: !0,
      className: [Ye.card, l].filter(Boolean).join(" "),
      title: /* @__PURE__ */ t.createElement(
        mo,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: s,
          onChange: (d) => c(d),
          items: [
            { key: "mine", label: /* @__PURE__ */ t.createElement(t.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ t.createElement("em", { className: Ye.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ t.createElement(t.Fragment, null, "최근 사용", n.length > 0 && /* @__PURE__ */ t.createElement("em", { className: Ye.n }, n.length)) }
          ]
        }
      ),
      trailing: s === "recent" && n.length > 0 && o ? /* @__PURE__ */ t.createElement(ta, { className: Ye.clear, onClick: o }, "지우기") : void 0
    },
    i.length > 0 ? /* @__PURE__ */ t.createElement("ul", { className: Ye.list }, i.map((d) => /* @__PURE__ */ t.createElement("li", { key: d.path }, /* @__PURE__ */ t.createElement("button", { type: "button", className: Ye.row, onClick: () => a(d) }, /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true", className: Ye.go }, "↗"), /* @__PURE__ */ t.createElement("span", { className: Ye.name }, d.label))))) : /* @__PURE__ */ t.createElement("div", { className: Ye.empty }, /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true", className: Ye.star }, "★"), /* @__PURE__ */ t.createElement("strong", null, s === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ t.createElement("p", null, s === "mine" ? r : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function Xa(e) {
  var n;
  try {
    const a = JSON.parse((n = window.localStorage.getItem(e)) != null ? n : "[]");
    return Array.isArray(a) ? a.filter((o) => o && typeof o.path == "string" && typeof o.label == "string") : [];
  } catch {
    return [];
  }
}
function On(e, n) {
  try {
    window.localStorage.setItem(e, JSON.stringify(n));
  } catch {
  }
}
function F0({ mineKey: e, recentKey: n, recentMax: a = 6 }) {
  const [o, r] = x(() => Xa(e)), [l, s] = x(() => Xa(n)), c = ee((m) => o.some((_) => _.path === m), [o]), i = ee((m) => r((_) => {
    const p = _.some((f) => f.path === m.path) ? _.filter((f) => f.path !== m.path) : [..._, m];
    return On(e, p), p;
  }), [e]), d = ee((m) => s((_) => {
    const p = [m, ..._.filter((f) => f.path !== m.path)].slice(0, a);
    return On(n, p), p;
  }), [n, a]), u = ee(() => {
    s([]), On(n, []);
  }, [n]);
  return { mine: o, recent: l, isMine: c, toggleMine: i, remember: d, clearRecent: u };
}
const sE = "_banner_7tqhk_2", cE = "_heading_7tqhk_7", iE = "_sparkleBox_7tqhk_8", uE = "_eyebrow_7tqhk_12", mE = "_headline_7tqhk_13", dE = "_desc_7tqhk_15", _E = "_err_7tqhk_16", pE = "_chips_7tqhk_18", fE = "_footer_7tqhk_28", yE = "_kicker_7tqhk_35", hE = "_list_7tqhk_36", bE = "_row_7tqhk_37", EE = "_icon_7tqhk_39", gE = "_text_7tqhk_40", vE = "_cap_7tqhk_41", wE = "_body_7tqhk_43", kE = "_reason_7tqhk_44", NE = "_empty_7tqhk_45", pe = {
  banner: sE,
  heading: cE,
  sparkleBox: iE,
  eyebrow: uE,
  headline: mE,
  desc: dE,
  err: _E,
  chips: pE,
  footer: fE,
  kicker: yE,
  list: hE,
  row: bE,
  icon: EE,
  text: gE,
  cap: vE,
  body: wE,
  reason: kE,
  empty: NE
};
function Oa({ size: e = 18 }) {
  return /* @__PURE__ */ t.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ t.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function q0({
  eyebrow: e,
  headline: n,
  desc: a,
  error: o,
  groups: r,
  maxChips: l = 4,
  onOpen: s,
  note: c,
  noteError: i,
  allLabel: d = "전체 업무 제안 보기",
  allDisabled: u,
  className: m = ""
}) {
  const _ = r.slice(0, l), p = r.length - _.length;
  return /* @__PURE__ */ t.createElement("section", { className: [pe.banner, m].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: pe.heading }, /* @__PURE__ */ t.createElement("span", { className: pe.sparkleBox }, /* @__PURE__ */ t.createElement(Oa, { size: 22 })), /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: pe.eyebrow }, /* @__PURE__ */ t.createElement(Oa, { size: 11 }), " ", e), /* @__PURE__ */ t.createElement("h2", { className: pe.headline }, n), a ? /* @__PURE__ */ t.createElement("p", { className: [pe.desc, o ? pe.err : ""].filter(Boolean).join(" ") }, a) : null)), r.length > 0 && /* @__PURE__ */ t.createElement("div", { className: pe.chips }, _.map((f) => /* @__PURE__ */ t.createElement("button", { type: "button", key: f.key, title: f.label, onClick: () => s(f.key) }, /* @__PURE__ */ t.createElement("i", { style: f.color ? { background: f.color } : void 0, "aria-hidden": "true" }), f.label, " ", /* @__PURE__ */ t.createElement("strong", { style: f.color ? { color: f.color } : void 0 }, f.count, "건"))), p > 0 && /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => s(null) }, "+", p, "종류 더")), /* @__PURE__ */ t.createElement("div", { className: pe.footer }, /* @__PURE__ */ t.createElement(
    "span",
    {
      className: i ? pe.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ t.createElement(ta, { onClick: () => s(null), disabled: u }, d, " ", /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function $E({ items: e, onRun: n, onSkip: a, busy: o, emptyText: r = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ t.createElement("div", { className: pe.empty }, r) : /* @__PURE__ */ t.createElement("ul", { className: pe.list }, e.map((l) => {
    var s, c;
    return /* @__PURE__ */ t.createElement("li", { key: l.id, className: pe.row }, /* @__PURE__ */ t.createElement("span", { className: pe.icon, "aria-hidden": "true" }, (s = l.icon) != null ? s : "💡"), /* @__PURE__ */ t.createElement("div", { className: pe.text }, /* @__PURE__ */ t.createElement("div", { className: pe.cap }, l.title, l.meta ? /* @__PURE__ */ t.createElement("small", null, " · ", l.meta) : null), /* @__PURE__ */ t.createElement("div", { className: pe.body }, l.body), l.reason ? /* @__PURE__ */ t.createElement("div", { className: pe.reason }, l.reason) : null), /* @__PURE__ */ t.createElement(Ft, { variant: "primary", disabled: o, onClick: () => n(l) }, (c = l.actionLabel) != null ? c : "실행"), /* @__PURE__ */ t.createElement(Ft, { disabled: o, onClick: () => a(l) }, "무시"));
  }));
}
function P0({ title: e, kicker: n = "ProActive AI 업무 제안", items: a, onClose: o, onRun: r, onSkip: l }) {
  const s = I(!1), [c, i] = x(!1), [d, u] = x(""), m = async (_) => {
    if (!s.current) {
      s.current = !0, i(!0), u("");
      try {
        await _();
      } catch (p) {
        u(p instanceof Error ? p.message : "처리에 실패했습니다");
      } finally {
        s.current = !1, i(!1);
      }
    }
  };
  return /* @__PURE__ */ t.createElement(
    Do,
    {
      title: e,
      onClose: o,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ t.createElement("span", { className: pe.kicker }, "✦ ", n),
      error: d,
      footer: /* @__PURE__ */ t.createElement(Ft, { onClick: o }, "닫기")
    },
    /* @__PURE__ */ t.createElement($E, { items: a, busy: c, onRun: (_) => m(() => r(_)), onSkip: (_) => m(() => l(_)) })
  );
}
const xE = "_wrap_1wvdc_2", CE = "_header_1wvdc_7", DE = "_iconBox_1wvdc_8", SE = "_headText_1wvdc_12", BE = "_eyebrow_1wvdc_13", AE = "_headline_1wvdc_14", ME = "_headerExtra_1wvdc_16", TE = "_grid_1wvdc_19", LE = "_card_1wvdc_20", jE = "_badge_1wvdc_29", IE = "_toneRed_1wvdc_33", RE = "_toneViolet_1wvdc_34", FE = "_toneGreen_1wvdc_35", qE = "_toneBlue_1wvdc_36", PE = "_title_1wvdc_38", XE = "_summary_1wvdc_42", OE = "_action_1wvdc_46", WE = "_notice_1wvdc_53", zE = "_err_1wvdc_56", me = {
  wrap: xE,
  header: CE,
  iconBox: DE,
  headText: SE,
  eyebrow: BE,
  headline: AE,
  headerExtra: ME,
  grid: TE,
  card: LE,
  badge: jE,
  toneRed: IE,
  toneViolet: RE,
  toneGreen: FE,
  toneBlue: qE,
  title: PE,
  summary: XE,
  action: OE,
  notice: WE,
  err: zE
};
function Wa({ size: e = 16 }) {
  return /* @__PURE__ */ t.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ t.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const HE = {
  red: me.toneRed,
  violet: me.toneViolet,
  green: me.toneGreen,
  blue: me.toneBlue
};
function X0({
  items: e,
  onOpen: n,
  eyebrow: a = "PROACTIVE AI",
  headline: o = "지금 처리할 수 있는 업무를 발견했습니다",
  error: r,
  loading: l,
  emptyText: s = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: c,
  className: i = ""
}) {
  return /* @__PURE__ */ t.createElement("section", { className: [me.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: me.header }, /* @__PURE__ */ t.createElement("span", { className: me.iconBox }, /* @__PURE__ */ t.createElement(Wa, { size: 18 })), /* @__PURE__ */ t.createElement("div", { className: me.headText }, /* @__PURE__ */ t.createElement("div", { className: me.eyebrow }, a), /* @__PURE__ */ t.createElement("h2", { className: me.headline }, o)), c ? /* @__PURE__ */ t.createElement("div", { className: me.headerExtra }, c) : null), r ? /* @__PURE__ */ t.createElement("div", { className: me.notice + " " + me.err, role: "alert" }, r) : null, e.length === 0 ? r ? null : l ? /* @__PURE__ */ t.createElement("div", { className: me.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ t.createElement("div", { className: me.notice }, s) : /* @__PURE__ */ t.createElement("div", { className: me.grid }, e.map((d) => {
    var u, m;
    return /* @__PURE__ */ t.createElement("button", { type: "button", key: d.id, className: me.card, onClick: () => n(d) }, /* @__PURE__ */ t.createElement("span", { className: [me.badge, HE[(u = d.tone) != null ? u : "violet"]].join(" ") }, /* @__PURE__ */ t.createElement(Wa, { size: 9 }), d.badge), /* @__PURE__ */ t.createElement("span", { className: me.title }, d.title), d.summary ? /* @__PURE__ */ t.createElement("span", { className: me.summary, title: typeof d.summary == "string" ? d.summary : void 0 }, d.summary) : null, /* @__PURE__ */ t.createElement("span", { className: me.action }, (m = d.actionLabel) != null ? m : "상세 보기", " ", /* @__PURE__ */ t.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const KE = "_screen_1bsma_1", GE = "_shell_1bsma_8", UE = "_command_1bsma_10", YE = "_body_1bsma_20", VE = "_overview_1bsma_22", JE = "_areaHead_1bsma_25", It = {
  screen: KE,
  shell: GE,
  command: UE,
  body: YE,
  overview: VE,
  areaHead: JE
};
function O0({ search: e, panel: n, children: a, className: o = "" }) {
  var r;
  return /* @__PURE__ */ t.createElement("main", { className: [It.screen, o].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("div", { className: It.shell }, e && /* @__PURE__ */ t.createElement("div", { className: It.command }, /* @__PURE__ */ t.createElement(
    Oi,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (r = e.hint) != null ? r : /* @__PURE__ */ t.createElement("kbd", null, "F10")
    }
  ), n), /* @__PURE__ */ t.createElement("div", { className: It.body }, a)));
}
function W0({ children: e, className: n = "" }) {
  return /* @__PURE__ */ t.createElement("div", { className: [It.overview, n].filter(Boolean).join(" ") }, e);
}
function z0({ title: e, hint: n }) {
  return /* @__PURE__ */ t.createElement("div", { className: It.areaHead }, /* @__PURE__ */ t.createElement("h2", null, e), n && /* @__PURE__ */ t.createElement("span", null, n));
}
const ZE = "_group_oodts_1", QE = "_grid_oodts_7", eg = "_row_oodts_8", tg = "_item_oodts_9", ng = "_launch_oodts_14", ag = "_name_oodts_17", og = "_desc_oodts_18", rg = "_badge_oodts_19", lg = "_disabled_oodts_23", sg = "_tab_oodts_25", cg = "_star_oodts_25", ig = "_on_oodts_30", ug = "_empty_oodts_32", Te = {
  group: ZE,
  grid: QE,
  row: eg,
  item: tg,
  launch: ng,
  name: ag,
  desc: og,
  badge: rg,
  disabled: lg,
  tab: sg,
  star: cg,
  on: ig,
  empty: ug
};
function mg() {
  return /* @__PURE__ */ t.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ t.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function dg() {
  return /* @__PURE__ */ t.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ t.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function H0({ title: e, items: n, emptyText: a, className: o = "" }) {
  return /* @__PURE__ */ t.createElement("section", { className: [Te.group, o].filter(Boolean).join(" ") }, /* @__PURE__ */ t.createElement("h3", null, e), /* @__PURE__ */ t.createElement("div", { className: Te.grid }, n.map((r) => /* @__PURE__ */ t.createElement("div", { className: Te.row, key: r.key }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: [Te.item, r.disabled ? Te.disabled : ""].filter(Boolean).join(" "),
      disabled: r.disabled,
      onClick: r.onOpen
    },
    /* @__PURE__ */ t.createElement("span", { className: Te.launch }, /* @__PURE__ */ t.createElement(mg, null)),
    /* @__PURE__ */ t.createElement("span", { className: Te.name }, r.label),
    r.desc && /* @__PURE__ */ t.createElement("span", { className: Te.desc }, r.desc),
    r.badge != null && /* @__PURE__ */ t.createElement("em", { className: Te.badge }, r.badge)
  ), r.onOpenNewTab && !r.disabled && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: Te.tab,
      "aria-label": `${r.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: r.onOpenNewTab
    },
    /* @__PURE__ */ t.createElement(dg, null)
  ), r.onToggleStar && !r.disabled && /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: [Te.star, r.starred ? Te.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!r.starred,
      "aria-label": `${r.label} ${r.starred ? "마이메뉴에서 빼기" : "마이메뉴에 담기"}`,
      onClick: r.onToggleStar
    },
    r.starred ? "★" : "☆"
  ))), n.length === 0 && a != null && /* @__PURE__ */ t.createElement("p", { className: Te.empty }, a)));
}
const za = 30, _g = BigInt(10);
function Xt(e) {
  let n = BigInt(1);
  for (let a = 0; a < e; a += 1) n = n * _g;
  return n;
}
function ct(e, n = 0) {
  return { u: e, s: n };
}
const Bo = ct(BigInt(0));
function Ao(e, n) {
  if (e.s === n.s) return [e.u, n.u, e.s];
  const a = Math.max(e.s, n.s);
  return [e.u * Xt(a - e.s), n.u * Xt(a - n.s), a];
}
function sn(e, n) {
  const [a, o, r] = Ao(e, n);
  return ct(a + o, r);
}
function oa(e, n) {
  const [a, o, r] = Ao(e, n);
  return ct(a - o, r);
}
function Ze(e, n) {
  return ct(e.u * n.u, e.s + n.s);
}
function xt(e, n) {
  if (n.u === BigInt(0)) return null;
  const a = e.u * Xt(n.s + za), o = n.u * Xt(e.s);
  return ct(a / o, za);
}
function Mo(e) {
  return ct(-e.u, e.s);
}
function it(e, n, a) {
  if (n >= e.s)
    return ct(e.u * Xt(n - e.s), n);
  const o = Xt(e.s - n), r = e.u < BigInt(0), l = r ? -e.u : e.u, s = l / o, c = l % o;
  let i;
  return c === BigInt(0) || a === "down" ? i = s : a === "up" ? i = s + BigInt(1) : i = c * BigInt(2) >= o ? s + BigInt(1) : s, ct(r ? -i : i, n);
}
function fe(e) {
  const n = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(n)) return null;
  const a = n.startsWith("-"), o = n.replace(/^[+-]/, ""), r = o.indexOf("."), l = r < 0 ? o : o.slice(0, r) + o.slice(r + 1), s = r < 0 ? 0 : o.length - r - 1, c = BigInt(l === "" ? "0" : l);
  return ct(a ? -c : c, s);
}
function ra(e) {
  var a;
  const n = fe(String(e));
  return n || ((a = fe(e.toFixed(20))) != null ? a : Bo);
}
function ze(e, n = e.s, a = !1) {
  const o = it(e, Math.max(n, 0), "half"), r = o.u < BigInt(0), l = (r ? -o.u : o.u).toString().padStart(n + 1, "0"), s = l.length - n;
  let c = l.slice(0, s);
  const i = l.slice(s);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (r ? "-" : "") + c + (n > 0 ? "." + i : "");
}
function Vn(e) {
  const n = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!n) return null;
  const a = Number(n[1]), o = Number(n[2]), r = Number(n[3]);
  return o < 1 || o > 12 || r < 1 || r > la(a, o) ? null : { y: a, m: o, d: r };
}
function pg(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function la(e, n) {
  return n === 2 ? pg(e) ? 29 : 28 : [4, 6, 9, 11].includes(n) ? 30 : 31;
}
function Rt({ y: e, m: n, d: a }) {
  const o = Math.floor((14 - n) / 12), r = e + 4800 - o, l = n + 12 * o - 3;
  return a + Math.floor((153 * l + 2) / 5) + 365 * r + Math.floor(r / 4) - Math.floor(r / 100) + Math.floor(r / 400) - 32045;
}
function To(e, n) {
  const a = Rt(e) + n + 32044, o = Math.floor((4 * a + 3) / 146097), r = a - Math.floor(146097 * o / 4), l = Math.floor((4 * r + 3) / 1461), s = r - Math.floor(1461 * l / 4), c = Math.floor((5 * s + 2) / 153);
  return {
    d: s - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * o + l - 4800 + Math.floor(c / 10)
  };
}
function Lo(e, n, a = "exclude-first") {
  const o = Rt(e) > Rt(n), r = o ? n : e, l = o ? e : n, s = a === "include-first", c = Rt(l) - Rt(r) + (s ? 1 : 0), i = s ? To(l, 1) : l;
  let d = i.y - r.y, u = i.m - r.m, m = i.d - r.d;
  if (m < 0) {
    u -= 1;
    const _ = i.m === 1 ? 12 : i.m - 1, p = i.m === 1 ? i.y - 1 : i.y;
    m += la(p, _);
  }
  return u < 0 && (d -= 1, u += 12), { days: c, y: d, m: u, d: m, swapped: o };
}
function Cn(e, n) {
  return To(e, n);
}
function Ha(e, n) {
  const a = e.y * 12 + (e.m - 1) + n, o = Math.floor(a / 12), r = a % 12 + 1;
  return { y: o, m: r, d: Math.min(e.d, la(o, r)) };
}
const fg = ["월", "화", "수", "목", "금", "토", "일"];
function Jn(e) {
  return fg[Rt(e) % 7];
}
function je(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const Qt = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], Wn = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function Ka(e) {
  var n;
  return (n = Wn[e]) != null ? n : e in Wn ? Wn[e] : null;
}
function Zn(e, n) {
  return e.find((a) => a.code === n);
}
function jo(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function Io(e, n, a, o) {
  const r = Zn(e, a), l = Zn(e, o);
  if (!r || !l) return null;
  const s = fe(r.krw), c = fe(l.krw), i = fe(String(r.per)), d = fe(String(l.per));
  if (!s || !c || !i || !d) return null;
  const u = xt(Ze(n, s), i);
  if (!u) return null;
  const m = xt(Ze(u, d), c);
  return m ? {
    value: it(m, 2, "half"),
    notice: `${jo(r)} · 샘플 고시(원천 미결)`
  } : null;
}
function yg(e, n) {
  let a = null;
  for (const r of e)
    if (r.value) {
      if (a === null) {
        a = r.sign === "-" ? Mo(r.value) : r.value;
        continue;
      }
      switch (r.sign) {
        case "+":
          a = sn(a, r.value);
          break;
        case "-":
          a = oa(a, r.value);
          break;
        case "*":
          a = Ze(a, r.value);
          break;
        default: {
          const l = xt(a, r.value);
          if (!l) return { ok: !1, error: "divide-by-zero" };
          a = l;
          break;
        }
      }
    }
  const o = a != null ? a : Bo;
  return { ok: !0, value: n ? it(o, n.digits, n.mode) : o };
}
const Ga = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function on() {
  return { sign: "+", text: "" };
}
function hg(e) {
  const n = e.replace(/[^\d.-]/g, ""), a = n.startsWith("-"), o = n.replace(/-/g, ""), r = o.indexOf("."), l = r < 0 ? o : o.slice(0, r), s = r < 0 ? "" : "." + o.slice(r + 1).replace(/\./g, "");
  return (a ? "-" : "") + l.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + s;
}
function bg(e) {
  return e.map((n) => ({ sign: n.sign, value: fe(n.text) }));
}
function Eg(e) {
  const { lines: n, onLines: a, active: o, onActive: r, digits: l, onDigits: s, mode: c, onMode: i } = e, d = I([]), u = Math.min(o, n.length - 1);
  G(() => {
    var S;
    (S = d.current[u]) == null || S.focus();
  }, [u, n.length]);
  const m = yg(bg(n), { digits: l, mode: c }), _ = m.ok ? ze(m.value, l, !0) : "0으로 나눌 수 없음", p = (S, g) => {
    a(n.map((h, v) => v === S ? { ...h, ...g } : h));
  }, f = (S = n.length, g = "") => {
    const h = [...n];
    h.splice(S, 0, { ...on(), text: g }), a(h), r(S);
  }, y = (S) => {
    if (n.length === 1) {
      a([on()]);
      return;
    }
    a(n.filter((g, h) => h !== S)), r(Math.max(0, S - 1));
  }, E = () => {
    m.ok && f(n.length, ze(m.value, l, !0));
  }, k = (S, g) => {
    const h = S.key, v = gg(h);
    if (v && !(h === "-" && n[g].text === "")) {
      S.preventDefault(), p(g, { sign: v });
      return;
    }
    if (h === "v" || h === "V") {
      S.preventDefault(), E();
      return;
    }
    h === "Enter" ? (S.preventDefault(), g === n.length - 1 ? f() : r(g + 1)) : h === "ArrowDown" ? (S.preventDefault(), r(Math.min(g + 1, n.length - 1))) : h === "ArrowUp" ? (S.preventDefault(), r(Math.max(g - 1, 0))) : h === "Insert" ? (S.preventDefault(), f(g + 1)) : h === "Delete" && n[g].text === "" ? (S.preventDefault(), y(g)) : h === "F4" && (S.preventDefault(), $());
  }, $ = () => {
    a([on()]), r(0);
  };
  return /* @__PURE__ */ t.createElement("div", { className: "bical-general" }, /* @__PURE__ */ t.createElement("div", { className: "bical-side" }, /* @__PURE__ */ t.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: () => f(u + 1) }, "라인추가 (Ins)"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: () => y(u) }, "라인삭제 (Del)"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: E }, "현재금액추가 (V)"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-key", onClick: $ }, "초기화 (F4)")), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ t.createElement("div", { className: "bical-keys" }, Ga.map((S) => {
    var g;
    return /* @__PURE__ */ t.createElement(
      "button",
      {
        key: S.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((g = n[u]) == null ? void 0 : g.sign) === S.key,
        onClick: () => p(u, { sign: S.key })
      },
      S.label,
      " (",
      S.hot,
      ")"
    );
  })), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: l, onChange: (S) => s(Number(S.target.value)) }, [0, 1, 2, 3, 4].map((S) => /* @__PURE__ */ t.createElement("option", { key: S, value: S }, S))), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: c, onChange: (S) => i(S.target.value) }, /* @__PURE__ */ t.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ t.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ t.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ t.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ t.createElement("div", { className: "bical-grid" }, n.map((S, g) => {
    var h;
    return /* @__PURE__ */ t.createElement("div", { key: g, className: `bical-line${g === u ? " bical-line--active" : ""}` }, /* @__PURE__ */ t.createElement("span", { className: "bical-caret" }, g === u ? "❯" : ""), /* @__PURE__ */ t.createElement("span", { className: "bical-sign" }, (h = Ga.find((v) => v.key === S.sign)) == null ? void 0 : h.label), /* @__PURE__ */ t.createElement(
      "input",
      {
        ref: (v) => {
          d.current[g] = v;
        },
        value: S.text,
        inputMode: "decimal",
        "aria-label": `${g + 1}번째 금액`,
        onFocus: () => r(g),
        onChange: (v) => p(g, { text: hg(v.target.value) }),
        onKeyDown: (v) => k(v, g)
      }
    ));
  })), /* @__PURE__ */ t.createElement("div", { className: `bical-result${m.ok ? "" : " bical-error"}` }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, _))));
}
function gg(e) {
  const n = e.toLowerCase();
  return n === "a" || e === "+" ? "+" : n === "s" || e === "-" ? "-" : n === "d" || e === "*" ? "*" : n === "f" || e === "/" ? "/" : null;
}
function vg(e) {
  const n = [];
  let a = 0;
  for (; a < e.length; ) {
    const o = e[a];
    if (o === " " || o === "	" || o === `
`)
      a += 1;
    else if (o >= "0" && o <= "9" || o === "." || o === ",") {
      let r = a;
      for (; r < e.length && (e[r] >= "0" && e[r] <= "9" || e[r] === "." || e[r] === ","); ) r += 1;
      const l = fe(e.slice(a, r));
      if (!l) return null;
      n.push({ t: "num", v: l }), a = r;
    } else if (o === "+" || o === "-" || o === "*" || o === "/")
      n.push({ t: "op", v: o }), a += 1;
    else if (o === "(")
      n.push({ t: "(" }), a += 1;
    else if (o === ")")
      n.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return n;
}
class wg {
  constructor(n) {
    this.tokens = n, this.at = 0;
  }
  parse() {
    const n = this.expr();
    return n.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : n;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let n = this.term();
    if (!n.ok) return n;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return n;
      this.at += 1;
      const o = this.term();
      if (!o.ok) return o;
      n = { ok: !0, value: a.v === "+" ? sn(n.value, o.value) : oa(n.value, o.value) };
    }
  }
  term() {
    let n = this.unary();
    if (!n.ok) return n;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return n;
      this.at += 1;
      const o = this.unary();
      if (!o.ok) return o;
      if (a.v === "*")
        n = { ok: !0, value: Ze(n.value, o.value) };
      else {
        const r = xt(n.value, o.value);
        if (!r) return { ok: !1, error: "divide-by-zero" };
        n = { ok: !0, value: r };
      }
    }
  }
  unary() {
    const n = this.peek();
    if (n && n.t === "op" && (n.v === "+" || n.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: n.v === "-" ? Mo(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const n = this.peek();
    if (!n) return { ok: !1, error: "syntax" };
    if (n.t === "num")
      return this.at += 1, { ok: !0, value: n.v };
    if (n.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const o = this.peek();
      return !o || o.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function kg(e) {
  const n = vg(e);
  return !n || n.length === 0 ? { ok: !1, error: "syntax" } : new wg(n).parse();
}
const rn = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (샘플 고시)"
], Ng = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function $g(e, n) {
  return e.replace(/오늘/g, je(n)).replace(/내일/g, je(Cn(n, 1))).replace(/어제/g, je(Cn(n, -1)));
}
function xg(e) {
  const n = [];
  for (const a of e.matchAll(Ng)) {
    const o = Vn(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    o && n.push(o);
  }
  return n;
}
const Cg = /부터|까지|에서|일수|며칠|기간|차이|~/;
function Dg(e, n) {
  if (n.length < 2 || !Cg.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), o = Lo(n[0], n[1], a ? "include-first" : "exclude-first"), r = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${je(n[0])} ~ ${je(n[1])} 기간(${r})` + (o.swapped ? " · 역순 입력" : ""),
    value: `${o.days}일 (${o.y}년 ${o.m}개월 ${o.d}일)`
  };
}
const Sg = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function Bg(e, n) {
  if (n.length !== 1) return null;
  const a = Sg.exec(e);
  if (!a) return null;
  const o = Number(a[1]), r = a[3] === "전" || a[3] === "이전", l = r ? -o : o, s = n[0];
  let c;
  return a[2] === "일" ? c = Cn(s, l) : a[2] === "주" ? c = Cn(s, l * 7) : a[2] === "년" ? c = Ha(s, l * 12) : c = Ha(s, l), {
    ok: !0,
    explain: `${je(s)} 에서 ${o}${a[2]} ${r ? "전" : "후"}`,
    value: `${je(c)} (${Jn(c)})`
  };
}
function Ag(e, n) {
  if (n.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const o = a[2] ? Ro(a[2]) : null, r = fe(a[1]);
  if (!r) return null;
  const l = o ? Ze(r, o) : r, s = Ka(a[3]);
  if (!s) return null;
  const i = s !== "KRW" ? "KRW" : Ka(Mg(e));
  if (!i || i === s) return null;
  const d = Io(n, l, s, i);
  return d ? {
    ok: !0,
    explain: `${ze(l, l.s, !0)} ${s} → ${i} · ${d.notice}`,
    value: `${ze(d.value, 2, !0)} ${i}`
  } : null;
}
function Mg(e) {
  const n = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return n ? n[1] : "원";
}
const Tg = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function Ro(e) {
  var n;
  return (n = fe(Tg[e])) != null ? n : ra(1);
}
const Lg = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, jg = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function Ig(e) {
  return e.replace(Lg, (n) => {
    let a = fe("0"), o = !1;
    for (const r of n.matchAll(jg)) {
      const l = fe(r[1]);
      l && (o = !0, a = sn(a, r[2] ? Ze(l, Ro(r[2])) : l));
    }
    return o ? ze(a, a.s) : n;
  });
}
const Rg = /원화|원|엔|씩|개월|개|명|건/g;
function Fg(e) {
  return Ig(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(Rg, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const qg = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function Pg(e, n, a) {
  const o = fe("1"), r = ze(Ze(n, ra(100)), 0);
  if (a === "add")
    return {
      value: it(Ze(e, sn(o, n)), 0, "half"),
      explain: `消費税 ${r}% 가산(税抜 기준)`
    };
  const l = xt(Ze(e, n), sn(o, n));
  return {
    value: l ? it(l, 0, "down") : e,
    explain: `消費税 ${r}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function Xg(e, n) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: rn };
  const o = $g(a, n.today), r = xg(o), l = Dg(o, r);
  if (l) return l;
  const s = Bg(o, r);
  if (s) return s;
  const c = Ag(o, (i = n.rates) != null ? i : []);
  return c || Og(o, n);
}
function Og(e, n) {
  var d, u;
  const a = qg.exec(e), o = a ? e.slice(0, a.index) : e, r = Fg(o);
  if (!r) return { ok: !1, supported: rn };
  const l = kg(r);
  if (!l.ok)
    return { ok: !1, supported: rn };
  if (!a)
    return { ok: !0, explain: r, value: Ua(l.value), expr: r };
  const s = (u = (d = Wg(a[2])) != null ? d : n.taxRate) != null ? u : null;
  if (!s)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세율(a_fa_param)을 읽어 오면 계산합니다", ...rn]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = Pg(l.value, s, c);
  return {
    ok: !0,
    explain: `${r} · ${i.explain}`,
    value: Ua(i.value),
    expr: r
  };
}
function Wg(e) {
  var a;
  if (!e) return null;
  const n = fe(e);
  return n && (a = xt(n, ra(100))) != null ? a : null;
}
function Ua(e) {
  const n = it(e, 2, "half"), a = it(n, 0, "down");
  return oa(n, a).u === BigInt(0) ? ze(n, 0, !0) : ze(n, 2, !0);
}
const Oe = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function Ya(e, n) {
  const a = Oe[e].units.find((r) => r.key === n);
  if (!a) return null;
  const o = fe(a.factor);
  if (!o) throw new Error(`단위 환산표가 깨졌습니다 — ${a.key}`);
  return o;
}
function zg(e, n, a, o, r = 4, l = "half") {
  const s = Ya(e, n), c = Ya(e, a);
  if (!s || !c) return null;
  const i = xt(Ze(o, s), c);
  return i ? it(i, r, l) : null;
}
const Hg = [0, 1, 2, 3, 4, 6], Kg = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function Gg(e) {
  const { tab: n, onTab: a, seed: o, onClose: r, history: l, onHistory: s } = e, [c, i] = x(() => o == null ? [on()] : [{ sign: "+", text: ze(ev(o), 0, !0) }]), [d, u] = x(0), [m, _] = x(0), [p, f] = x("half"), y = I(null);
  G(() => {
    const k = ($) => {
      $.key === "Escape" && ($.preventDefault(), r());
    };
    return document.addEventListener("keydown", k), () => document.removeEventListener("keydown", k);
  }, [r]), G(() => {
    var k, $;
    ($ = (k = y.current) == null ? void 0 : k.querySelector("[data-autofocus]")) == null || $.focus();
  }, [n]);
  const E = (k) => {
    const $ = [...c.filter((S) => S.text !== ""), { sign: "+", text: k }, on()];
    i($), u($.length - 1), a("general");
  };
  return /* @__PURE__ */ t.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ t.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: y }, /* @__PURE__ */ t.createElement("div", { className: "bical-head" }, /* @__PURE__ */ t.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ t.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: r }, "✕")), /* @__PURE__ */ t.createElement("div", { className: "bical-tabs", role: "tablist" }, Kg.map((k) => /* @__PURE__ */ t.createElement(
    "button",
    {
      key: k.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": k.key === n,
      onClick: () => a(k.key)
    },
    k.label
  ))), /* @__PURE__ */ t.createElement("div", { className: "bical-body" }, n === "text" && /* @__PURE__ */ t.createElement(Vg, { history: l, onHistory: s, onPush: E }), n === "general" && /* @__PURE__ */ t.createElement(
    Eg,
    {
      lines: c,
      onLines: i,
      active: d,
      onActive: u,
      digits: m,
      onDigits: _,
      mode: p,
      onMode: f
    }
  ), n === "date" && /* @__PURE__ */ t.createElement(Jg, null), n === "unit" && /* @__PURE__ */ t.createElement(Zg, null), n === "fx" && /* @__PURE__ */ t.createElement(Qg, null)), /* @__PURE__ */ t.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-btn", onClick: r }, "닫기"))));
}
const Ug = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], Yg = 20;
function Vg({ history: e, onHistory: n, onPush: a }) {
  var f;
  const [o, r] = x(""), [l, s] = x(null), [c, i] = x(!1), [d, u] = x(!1), m = I(!1), _ = Fe(sa, []), p = (y) => {
    r(y), u(!1);
    const E = Xg(y, { today: _, rates: Qt, taxRate: null });
    s(E), y.trim() && n([y, ...e.filter((k) => k !== y)].slice(0, Yg));
  };
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "data-autofocus": !0,
      value: o,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (y) => r(y.target.value),
      onCompositionStart: () => {
        m.current = !0;
      },
      onCompositionEnd: () => {
        m.current = !1;
      },
      onKeyDown: (y) => {
        y.key === "Enter" && !y.shiftKey && !m.current && !y.nativeEvent.isComposing && (y.preventDefault(), p(o));
      }
    }
  ), /* @__PURE__ */ t.createElement("div", { className: "bical-chips" }, Ug.map((y) => /* @__PURE__ */ t.createElement("button", { key: y, type: "button", className: "bical-chip", onClick: () => p(y) }, y))), l && (l.ok ? /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, l.explain), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, l.value), /* @__PURE__ */ t.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ t.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var y;
        (y = navigator.clipboard) == null || y.writeText(l.value).then(
          () => u(!0),
          () => u(!1)
        );
      }
    },
    d ? "복사함" : "결과복사"
  ), /* @__PURE__ */ t.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(l.value) }, "일반계산에 추가"))) : /* @__PURE__ */ t.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ t.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((f = l.supported) != null ? f : rn).map((y) => /* @__PURE__ */ t.createElement("li", { key: y }, y))))), e.length > 0 && /* @__PURE__ */ t.createElement("div", { className: "bical-log" }, /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => i((y) => !y) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ t.createElement("ol", null, e.map((y) => /* @__PURE__ */ t.createElement("li", { key: y }, /* @__PURE__ */ t.createElement("button", { type: "button", onClick: () => p(y) }, y))))), /* @__PURE__ */ t.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function Jg() {
  const e = Fe(sa, []), [n, a] = x(je(e)), [o, r] = x(je(e)), [l, s] = x("exclude-first"), c = Vn(n), i = Vn(o), d = c && i ? Lo(c, i, l) : null;
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: l, onChange: (u) => s(u.target.value) }, /* @__PURE__ */ t.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ t.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ t.createElement("input", { className: "bical-input", type: "date", "data-autofocus": !0, value: n, onChange: (u) => a(u.target.value) }), /* @__PURE__ */ t.createElement("span", null, "~"), /* @__PURE__ */ t.createElement("input", { className: "bical-input", type: "date", value: o, onChange: (u) => r(u.target.value) })), d ? /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, je(c), "(", Jn(c), ") ~ ", je(i), "(", Jn(i), ")", d.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, d.days.toLocaleString(), "일"), /* @__PURE__ */ t.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", d.y, "년 ", d.m, "개월 ", d.d, "일")) : /* @__PURE__ */ t.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function Zg() {
  const [e, n] = x("area"), [a, o] = x(Oe.area.units[0].key), [r, l] = x(Oe.area.units[4].key), [s, c] = x(""), [i, d] = x(4), [u, m] = x("half"), _ = (y) => {
    n(y), o(Oe[y].units[0].key), l(Oe[y].units[1].key), c("");
  }, p = fe(s), f = p ? zg(e, a, r, p, i, u) : null;
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: e, onChange: (y) => _(y.target.value) }, Object.keys(Oe).map((y) => /* @__PURE__ */ t.createElement("option", { key: y, value: y }, Oe[y].label))), /* @__PURE__ */ t.createElement("span", { className: "bical-sub" }, "기준 ", Oe[e].base)), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ t.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: s,
      onChange: (y) => c(y.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: a, onChange: (y) => o(y.target.value) }, Oe[e].units.map((y) => /* @__PURE__ */ t.createElement("option", { key: y.key, value: y.key }, y.label))), /* @__PURE__ */ t.createElement("span", null, "→"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: r, onChange: (y) => l(y.target.value) }, Oe[e].units.map((y) => /* @__PURE__ */ t.createElement("option", { key: y.key, value: y.key }, y.label)))), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: i, onChange: (y) => d(Number(y.target.value)) }, Hg.map((y) => /* @__PURE__ */ t.createElement("option", { key: y, value: y }, y))), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: u, onChange: (y) => m(y.target.value) }, /* @__PURE__ */ t.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ t.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ t.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, Va(e, a), " → ", Va(e, r), " · 기준단위 1단계 환산"), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, f ? ze(f, i, !0) : "—")));
}
function Va(e, n) {
  var a, o;
  return (o = (a = Oe[e].units.find((r) => r.key === n)) == null ? void 0 : a.label) != null ? o : n;
}
function Qg() {
  const e = Fe(sa, []), [n, a] = x(je(e)), [o, r] = x("JPY"), [l, s] = x("KRW"), [c, i] = x(""), d = fe(c), u = d ? Io(Qt, d, o, l) : null, m = Zn(Qt, o);
  return /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ t.createElement("input", { className: "bical-input", type: "date", value: n, onChange: (_) => a(_.target.value) })), /* @__PURE__ */ t.createElement("div", { className: "bical-row" }, /* @__PURE__ */ t.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ t.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (_) => i(_.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: o, onChange: (_) => r(_.target.value) }, Qt.map((_) => /* @__PURE__ */ t.createElement("option", { key: _.code, value: _.code }, _.code, " (", _.label, ")"))), /* @__PURE__ */ t.createElement("span", null, "→"), /* @__PURE__ */ t.createElement("select", { className: "bical-select", value: l, onChange: (_) => s(_.target.value) }, Qt.map((_) => /* @__PURE__ */ t.createElement("option", { key: _.code, value: _.code }, _.code, " (", _.label, ")")))), /* @__PURE__ */ t.createElement("div", { className: "bical-result" }, /* @__PURE__ */ t.createElement("div", { className: "bical-explain" }, m ? jo(m) : ""), /* @__PURE__ */ t.createElement("div", { className: "bical-value" }, u ? ze(u.value, 2, !0) : "—")), /* @__PURE__ */ t.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ t.createElement("b", null, "샘플 고시입니다 — 원천 미결."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function sa() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function ev(e) {
  var n;
  return it((n = fe(String(e))) != null ? n : fe("0"), 0, "half");
}
const Fo = eo(null);
function K0({ children: e }) {
  const [n, a] = x(!1), [o, r] = x("text"), [l, s] = x(null), [c, i] = x([]), [d, u] = x(0), m = Fe(() => ({
    open: (_) => {
      var p, f;
      r((p = _ == null ? void 0 : _.tab) != null ? p : "text"), s((f = _ == null ? void 0 : _.seed) != null ? f : null), u((y) => y + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ t.createElement(Fo.Provider, { value: m }, e, n && /* @__PURE__ */ t.createElement(
    Gg,
    {
      key: d,
      tab: o,
      onTab: r,
      seed: l,
      onClose: m.close,
      history: c,
      onHistory: i
    }
  ));
}
function G0() {
  var e;
  return (e = to(Fo)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class U0 extends Za {
  constructor() {
    super(...arguments), this.rootRef = zo(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new _o(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: n, children: a, ...o } = this.props;
    return /* @__PURE__ */ t.createElement("div", { ref: this.rootRef, ...o }, a);
  }
}
export {
  jv as AXActionCard,
  dv as AXAiIconBadge,
  wv as AXAiSuggestionBanner,
  so as AXAvatar,
  _v as AXAvatarStack,
  pv as AXBadge,
  Iv as AXBreadcrumb,
  Bv as AXButton,
  iv as AXCardPanel,
  fv as AXCommentRow,
  sv as AXCommentThread,
  Dv as AXDataTable,
  uv as AXDivider,
  Fv as AXDrawer,
  qv as AXDropdownMenu,
  kv as AXEmptyState,
  Zm as AXErpActionMenu,
  h0 as AXErpBanner,
  Ft as AXErpButton,
  Gg as AXErpCalculatorModal,
  K0 as AXErpCalculatorProvider,
  p0 as AXErpCalendar,
  po as AXErpCard,
  i0 as AXErpCodePicker,
  T0 as AXErpCsvButton,
  Ca as AXErpDatePicker,
  d0 as AXErpDateRange,
  Co as AXErpError,
  r_ as AXErpField,
  A0 as AXErpFileDrop,
  B0 as AXErpFilterBand,
  N0 as AXErpFormRow,
  $0 as AXErpFormSection,
  e0 as AXErpGisuField,
  sd as AXErpGlyph,
  t0 as AXErpGrid,
  o0 as AXErpGridStatus,
  Qv as AXErpHint,
  vn as AXErpIcon,
  Un as AXErpIconButton,
  j0 as AXErpKpiTile,
  I0 as AXErpKpiTileGroup,
  ta as AXErpLinkButton,
  O0 as AXErpMainScreen,
  z0 as AXErpMenuAreaHead,
  H0 as AXErpMenuGroup,
  f0 as AXErpMiniCalendar,
  Do as AXErpModal,
  y0 as AXErpMoneyInput,
  bh as AXErpMsg,
  E0 as AXErpNote,
  W0 as AXErpOverviewGrid,
  Xv as AXErpPage,
  Zv as AXErpPill,
  q0 as AXErpProposalBanner,
  X0 as AXErpProposalCards,
  $E as AXErpProposalList,
  P0 as AXErpProposalModal,
  R0 as AXErpQuickMenu,
  x0 as AXErpReadonly,
  Jv as AXErpReadout,
  zv as AXErpSaveBar,
  Vv as AXErpSearchBar,
  ob as AXErpSelect,
  Hv as AXErpSideBar,
  Gv as AXErpSidePanel,
  Kv as AXErpSidePanelGroup,
  Uv as AXErpStartGuide,
  L0 as AXErpStatCard,
  g0 as AXErpStateBadge,
  c0 as AXErpSummaryCard,
  Yv as AXErpSummaryList,
  mo as AXErpTabs,
  ab as AXErpTextInput,
  Ov as AXErpTitleBar,
  C0 as AXErpToggle,
  Dn as AXErpTooltip,
  s0 as AXErpTreeCell,
  b0 as AXErpVerify,
  Nv as AXExpandableSummary,
  yv as AXFileChip,
  Ol as AXFileTypeIcon,
  Av as AXIconButton,
  Sv as AXKeyValueGrid,
  hv as AXKeyValueRow,
  bv as AXListRow,
  Pv as AXModal,
  mv as AXPanelHeader,
  Ev as AXPersonRow,
  $v as AXProgressBar,
  gv as AXRankingRow,
  Oi as AXSearchInput,
  Mv as AXSegmentedControl,
  vv as AXStatusBadge,
  xv as AXStepProgress,
  Tv as AXTagChip,
  Lv as AXToggleSwitch,
  Rv as AXTreeItem,
  Cv as AXTypingDots,
  wo as AX_ERP_CALENDAR_KO,
  Eh as AX_ERP_DIRTY_MESSAGE,
  no as GW_ORIGIN,
  ho as JAPANESE_ERAS,
  Wt as OBTPortal,
  U0 as OBTResizeContainer,
  _o as OBTResizeSensor,
  cn as REFRESH_KEY,
  Hn as SESSION_EXPIRED_EVENT,
  Qn as TOKEN_KEY,
  xo as amDigits,
  th as amNumber,
  un as authorizedFetch,
  Uf as axErpCalendarLocale,
  ef as axErpCodeLabel,
  M0 as axErpDownload,
  $b as axErpFileName,
  l_ as axErpGisuLabel,
  k0 as axErpHttpMessage,
  Jm as axErpMenuItem,
  Wv as axErpMenuSection,
  m0 as axErpRangeValid,
  r0 as axErpRowActivate,
  So as axErpSaveBlob,
  Bb as axErpSaveCsv,
  Sb as axErpTableToCsv,
  Yo as clearTokens,
  av as colors,
  ov as configureAuth,
  lv as configureComments,
  Db as csvNumber,
  ea as decodeClaims,
  bo as eraOf,
  _0 as eraShortDate,
  qf as eraYearLabel,
  eh as fmtAm,
  u0 as fmtDt,
  er as getFreshToken,
  Go as getStoredToken,
  Ko as isExpired,
  oo as isRefreshExpired,
  tr as isReply,
  a0 as measureMoneyMetrics,
  n0 as moneyColWidth,
  q_ as moneyColWidthForDigits,
  en as notifySessionExpired,
  rv as onSessionExpired,
  lo as refreshTokens,
  Uo as saveTokens,
  Jo as startRefreshExpiryWatch,
  ro as stopRefreshExpiryWatch,
  Qy as toHalfWidth,
  yo as todayLocal,
  S0 as useAXErpBusy,
  G0 as useAXErpCalculator,
  w0 as useAXErpConfirm,
  gh as useAXErpDirtyGuard,
  D0 as useAXErpEditor,
  v0 as useAXErpNotice,
  F0 as useAXErpQuickMenu,
  l0 as useAXErpTree,
  cv as useCommentCounts,
  sr as useComments
};
